import React, { useState, useRef, useEffect } from "react";
import API_BASE_URL from "../../../apiConfig";
import jsPDF from "jspdf";
import "../../../assets/fonts/kids_avenue/KidsAvenue";
import greatVibes from "../../../fonts/GreatVibes";
import statesAndDistricts from "./../../../data/statesAndDistricts.json";

const readFileAsBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

const NewPanApplication = () => {
  const [newPanId, setNewPanId] = useState(localStorage.getItem("newPanId"));
  const [hideRA, setHideRA] = useState(true);
  const [formData, setFormData] = useState({
    AreaCode: "",
    AOType: "",
    RangeCode: "",
    AOCode: "",
    state: "",
    district: "",
    category: "",
    ApplicantCheckedOption: "",
    LastName: "",
    FirstName: "",
    MiddleName: "",
    NewPanName: "",
    FatherLastName: "",
    FatherFirstName: "",
    FatherMiddleName: "",
    MotherLastName: "",
    MotherFirstName: "",
    MotherMiddleName: "",
    Dob: "",
    ISDCode: "",
    STDCode: "",
    MobileNo: "",
    EmailId: "",
    AadharName: "",
    PanDispatchState: "",
    Aadhar_EID: "",
    RAAddress: "",
    IdentityProof: "",
    AddressProof: "",
    DobProof: "",
    ResidentRoom: "",
    ResidentPremises: "",
    ResidentStreet: "",
    ResidentArea: "",
    ResidentCity: "",
    ResidentState: "",
    ResidentPinCode: "",
    OfficeName: "",
    OfficeRoom: "",
    OfficePremises: "",
    OfficeStreet: "",
    OfficeArea: "",
    OfficeCity: "",
    OfficeState: "",
    OfficePinCode: "",
    RepresentativeCheckedOption: "",
    RepresentativeLastName: "",
    RepresentativeFirstName: "",
    RepresentativeMiddleName: "",
    RepresentativeRoom: "",
    RepresentativePremises: "",
    RepresentativeStreet: "",
    RepresentativeArea: "",
    RepresentativeCity: "",
    RepresentativeState: "",
    RepresentativePinCode: "",
    pdfDocument: null,  // File
    photo: null,        // File
    signature: null,    // File

  });

  const pdfDocumentRef = useRef(null);
  const photoRef = useRef(null);
  const signatureRef = useRef(null);
  const [submissionDate, setSubmissionDate] = useState(null);

  // AO Code Data mapping for State and District
  const aoCodeData = {
    "Andaman and Nicobar Islands": {
      "Andaman and Nicobar": { AreaCode: "WBG", AOType: "W", RangeCode: "101", AOCode: "93" }
    },
    "Andhra Pradesh": {
      "Adoni": { AreaCode: "APR", AOType: "W", RangeCode: "77", AOCode: "5" },
      "Amalapuram": { AreaCode: "APR", AOType: "W", RangeCode: "90", AOCode: "4" },
      "Anakapalli": { AreaCode: "APR", AOType: "W", RangeCode: "84", AOCode: "91" },
      "Anantapur": { AreaCode: "APR", AOType: "W", RangeCode: "77", AOCode: "91" },
      "Bapatla": { AreaCode: "APR", AOType: "W", RangeCode: "79", AOCode: "10" },
      "Bhimavaram": { AreaCode: "APR", AOType: "W", RangeCode: "116", AOCode: "2" },
      "Chirala": { AreaCode: "APR", AOType: "W", RangeCode: "79", AOCode: "11" },
      "Chittoor": { AreaCode: "APR", AOType: "W", RangeCode: "81", AOCode: "3" },
      "Eluru": { AreaCode: "APR", AOType: "W", RangeCode: "116", AOCode: "5" },
      "Gudivada": { AreaCode: "APR", AOType: "W", RangeCode: "74", AOCode: "5" },
      "Gudur": { AreaCode: "APR", AOType: "W", RangeCode: "81", AOCode: "5" },
      "Guntakal": { AreaCode: "APR", AOType: "W", RangeCode: "77", AOCode: "92" },
      "Guntur": { AreaCode: "APR", AOType: "W", RangeCode: "78", AOCode: "1" },
      "Hindupur": { AreaCode: "APR", AOType: "W", RangeCode: "77", AOCode: "93" },
      "Kadapa": { AreaCode: "APR", AOType: "W", RangeCode: "80", AOCode: "91" },
      "Kakinada": { AreaCode: "APR", AOType: "W", RangeCode: "90", AOCode: "1" },
      "Kurnool": { AreaCode: "APR", AOType: "W", RangeCode: "77", AOCode: "1" },
      "Machilipatnam": { AreaCode: "APR", AOType: "W", RangeCode: "75", AOCode: "5" },
      "Madanapalle": { AreaCode: "APR", AOType: "W", RangeCode: "81", AOCode: "5" },
      "Nandyal": { AreaCode: "APR", AOType: "W", RangeCode: "77", AOCode: "3" },
      "Narasaraopet": { AreaCode: "APR", AOType: "W", RangeCode: "79", AOCode: "3" },
      "Nellore": { AreaCode: "APR", AOType: "W", RangeCode: "80", AOCode: "1" },
      "Ongole": { AreaCode: "APR", AOType: "W", RangeCode: "79", AOCode: "4" },
      "Palakol": { AreaCode: "APR", AOType: "W", RangeCode: "116", AOCode: "4" },
      "Proddatur": { AreaCode: "APR", AOType: "W", RangeCode: "80", AOCode: "92" },
      "Rajahmundry": { AreaCode: "APR", AOType: "W", RangeCode: "90", AOCode: "1" },
      "Srikakulam": { AreaCode: "APR", AOType: "W", RangeCode: "85", AOCode: "95" },
      "Tadepalligudem": { AreaCode: "APR", AOType: "W", RangeCode: "116", AOCode: "9" },
      "Tanuku": { AreaCode: "APR", AOType: "W", RangeCode: "116", AOCode: "7" },
      "Tenali": { AreaCode: "APR", AOType: "W", RangeCode: "78", AOCode: "3" },
      "Tirupati": { AreaCode: "APR", AOType: "W", RangeCode: "81", AOCode: "6" },
      "Tuni": { AreaCode: "APR", AOType: "W", RangeCode: "90", AOCode: "3" },
      "Vijayanagaram": { AreaCode: "APR", AOType: "W", RangeCode: "85", AOCode: "92" },
      "Vijayawada": { AreaCode: "APR", AOType: "W", RangeCode: "74", AOCode: "1" },
      "Visakhapatnam": { AreaCode: "APR", AOType: "W", RangeCode: "85", AOCode: "1" },
      "Rajamahendravaram": { AreaCode: "APR", AOType: "W", RangeCode: "116", AOCode: "1" }
    },

    "Arunachal Pradesh": {
      "Anjaw": { AreaCode: "SHL", AOType: "WT", RangeCode: "10", AOCode: "11" },
      "Changlang": { AreaCode: "SHL", AOType: "WT", RangeCode: "10", AOCode: "11" },
      "Dibang Valley": { AreaCode: "SHL", AOType: "WT", RangeCode: "10", AOCode: "11" },
      "East Kameng": { AreaCode: "SHL", AOType: "WT", RangeCode: "10", AOCode: "11" },
      "East Siang": { AreaCode: "SHL", AOType: "WT", RangeCode: "10", AOCode: "11" },
      "Itanagar": { AreaCode: "SHL", AOType: "WT", RangeCode: "10", AOCode: "11" },
      "Kra Daadi": { AreaCode: "SHL", AOType: "WT", RangeCode: "10", AOCode: "11" },
      "Kurung Kumey": { AreaCode: "SHL", AOType: "WT", RangeCode: "10", AOCode: "11" },
      "Lohit": { AreaCode: "SHL", AOType: "WT", RangeCode: "10", AOCode: "11" },
      "Longding": { AreaCode: "SHL", AOType: "WT", RangeCode: "10", AOCode: "11" },
      "Lower Dibang Valley": { AreaCode: "SHL", AOType: "WT", RangeCode: "10", AOCode: "11" },
      "Lower Subansiri": { AreaCode: "SHL", AOType: "WT", RangeCode: "10", AOCode: "11" },
      "Namsai": { AreaCode: "SHL", AOType: "WT", RangeCode: "10", AOCode: "11" },
      "Papum Pare": { AreaCode: "SHL", AOType: "WT", RangeCode: "10", AOCode: "11" },
      "Shiyomi": { AreaCode: "SHL", AOType: "WT", RangeCode: "10", AOCode: "11" },
      "Siang": { AreaCode: "SHL", AOType: "WT", RangeCode: "10", AOCode: "11" },
      "Tawang": { AreaCode: "SHL", AOType: "WT", RangeCode: "10", AOCode: "11" },
      "Tirap": { AreaCode: "SHL", AOType: "WT", RangeCode: "10", AOCode: "11" },
      "Upper Siang": { AreaCode: "SHL", AOType: "WT", RangeCode: "10", AOCode: "11" },
      "Upper Subansiri": { AreaCode: "SHL", AOType: "WT", RangeCode: "10", AOCode: "11" },
      "West Kameng": { AreaCode: "SHL", AOType: "WT", RangeCode: "10", AOCode: "11" },
      "West Siang": { AreaCode: "SHL", AOType: "WT", RangeCode: "10", AOCode: "11" }
    },
    "Assam": {
      "Bongaigaon": { AreaCode: "SHL", AOType: "W", RangeCode: "2", AOCode: "94" },
      "Barpeta": { AreaCode: "SHL", AOType: "W", RangeCode: "2", AOCode: "91" },
      "Digboi": { AreaCode: "SHL", AOType: "W", RangeCode: "25", AOCode: "91" },
      "Duliajan": { AreaCode: "SHL", AOType: "W", RangeCode: "25", AOCode: "93" },
      "Goalpara": { AreaCode: "SHL", AOType: "W", RangeCode: "2", AOCode: "93" },
      "Golaghat": { AreaCode: "SHL", AOType: "W", RangeCode: "7", AOCode: "11" },
      "Guwahati": { AreaCode: "SHL", AOType: "W", RangeCode: "1", AOCode: "2" },
      "Dhubri": { AreaCode: "SHL", AOType: "W", RangeCode: "2", AOCode: "92" },
      "Dibrugarh": { AreaCode: "SHL", AOType: "W", RangeCode: "25", AOCode: "1" },
      "Jorhat": { AreaCode: "SHL", AOType: "W", RangeCode: "7", AOCode: "1" },
      "Karimganj": { AreaCode: "SHL", AOType: "W", RangeCode: "16", AOCode: "21" },
      "Mangaldoi": { AreaCode: "SHL", AOType: "W", RangeCode: "1", AOCode: "94" },
      "Morigaon": { AreaCode: "SHL", AOType: "W", RangeCode: "1", AOCode: "95" },
      "Nagaon": { AreaCode: "SHL", AOType: "W", RangeCode: "1", AOCode: "93" },
      "Nalbari": { AreaCode: "SHL", AOType: "W", RangeCode: "2", AOCode: "13" },
      "North Lakhimpur": { AreaCode: "SHL", AOType: "W", RangeCode: "1", AOCode: "92" },
      "Sivasagar": { AreaCode: "SHL", AOType: "W", RangeCode: "7", AOCode: "91" },
      "Silchar": { AreaCode: "SHL", AOType: "W", RangeCode: "16", AOCode: "1" },
      "Tezpur": { AreaCode: "SHL", AOType: "W", RangeCode: "1", AOCode: "91" },
      "Tinsukia": { AreaCode: "SHL", AOType: "W", RangeCode: "25", AOCode: "92" }
    },

    "Bihar": {
      "Ara": { AreaCode: "PTN", AOType: "W", RangeCode: "21", AOCode: "5" },
      "Bettiah": { AreaCode: "PTN", AOType: "W", RangeCode: "27", AOCode: "4" },
      "Bhagalpur": { AreaCode: "PTN", AOType: "W", RangeCode: "30", AOCode: "1" },
      "Biharsharif": { AreaCode: "PTN", AOType: "W", RangeCode: "21", AOCode: "92" },
      "Buxar": { AreaCode: "PTN", AOType: "W", RangeCode: "21", AOCode: "6" },
      "Chapra": { AreaCode: "PTN", AOType: "W", RangeCode: "27", AOCode: "91" },
      "Darbhanga": { AreaCode: "PTN", AOType: "W", RangeCode: "27", AOCode: "94" },
      "Begusarai": { AreaCode: "PTN", AOType: "W", RangeCode: "30", AOCode: "91" },
      "Gaya": { AreaCode: "PTN", AOType: "W", RangeCode: "24", AOCode: "91" },
      "Katihar": { AreaCode: "PTN", AOType: "W", RangeCode: "30", AOCode: "6" },
      "Lakhisarai": { AreaCode: "PTN", AOType: "W", RangeCode: "30", AOCode: "93" },
      "Madhubani": { AreaCode: "PTN", AOType: "W", RangeCode: "27", AOCode: "96" },
      "Motihari": { AreaCode: "PTN", AOType: "W", RangeCode: "27", AOCode: "2" },
      "Munger": { AreaCode: "PTN", AOType: "W", RangeCode: "30", AOCode: "92" },
      "Muzaffarpur": { AreaCode: "PTN", AOType: "W", RangeCode: "27", AOCode: "1" },
      "Patna": { AreaCode: "PTN", AOType: "W", RangeCode: "21", AOCode: "1" },
      "Purnea": { AreaCode: "PTN", AOType: "W", RangeCode: "30", AOCode: "94" },
      "Saharsa": { AreaCode: "PTN", AOType: "W", RangeCode: "30", AOCode: "95" },
      "Samastipur": { AreaCode: "PTN", AOType: "W", RangeCode: "27", AOCode: "95" },
      "Sasaram": { AreaCode: "PTN", AOType: "W", RangeCode: "24", AOCode: "93" },
      "Sitamarhi": { AreaCode: "PTN", AOType: "W", RangeCode: "27", AOCode: "93" },
      "Siwan": { AreaCode: "PTN", AOType: "W", RangeCode: "27", AOCode: "92" },
      "Vaishali": { AreaCode: "PTN", AOType: "W", RangeCode: "21", AOCode: "4" }
    },

    "Delhi": {
      "Central Delhi": { AreaCode: "DEL", AOType: "W", RangeCode: "31", AOCode: "1" },
      "North Delhi": { AreaCode: "DEL", AOType: "W", RangeCode: "49", AOCode: "1" },
      "East Delhi": { AreaCode: "DEL", AOType: "W", RangeCode: "260", AOCode: "1" },
      "New Delhi": { AreaCode: "DEL", AOType: "W", RangeCode: "61", AOCode: "1" },
      "North East Delhi": { AreaCode: "DEL", AOType: "W", RangeCode: "52", AOCode: "2" },
      "Shahdara": { AreaCode: "DEL", AOType: "W", RangeCode: "66", AOCode: "3" },
      "South East Delhi": { AreaCode: "DEL", AOType: "W", RangeCode: "52", AOCode: "5" },
      "South West Delhi": { AreaCode: "DEL", AOType: "W", RangeCode: "56", AOCode: "13" },
      "West Delhi": { AreaCode: "DEL", AOType: "W", RangeCode: "57", AOCode: "2" }
    },

    "Chandigarh": {
      "Chandigarh": { AreaCode: "NWR", AOType: "W", RangeCode: "41", AOCode: "1" }
    },

    "Chhattisgarh": {
      "Ambikapur": { AreaCode: "BPL", AOType: "W", RangeCode: "88", AOCode: "91" },
      "Bhatapara": { AreaCode: "BPL", AOType: "W", RangeCode: "85", AOCode: "1" },
      "Bhilai": { AreaCode: "BPL", AOType: "W", RangeCode: "87", AOCode: "1" },
      "Bilaspur": { AreaCode: "BPL", AOType: "W", RangeCode: "88", AOCode: "1" },
      "Dhamtari": { AreaCode: "BPL", AOType: "W", RangeCode: "85", AOCode: "93" },
      "Jagdalpur": { AreaCode: "BPL", AOType: "W", RangeCode: "85", AOCode: "94" },
      "Janjgir Champa": { AreaCode: "BPL", AOType: "W", RangeCode: "89", AOCode: "10" },
      "Kanker": { AreaCode: "BPL", AOType: "W", RangeCode: "86", AOCode: "7" },
      "Kawardha": { AreaCode: "BPL", AOType: "W", RangeCode: "57", AOCode: "5" },
      "Korba": { AreaCode: "BPL", AOType: "W", RangeCode: "88", AOCode: "93" },
      "Mahasamund": { AreaCode: "BPL", AOType: "W", RangeCode: "85", AOCode: "95" },
      "Manendragargh": { AreaCode: "BPL", AOType: "W", RangeCode: "89", AOCode: "11" },
      "Raigarh": { AreaCode: "BPL", AOType: "W", RangeCode: "88", AOCode: "3" },
      "Raipur": { AreaCode: "BPL", AOType: "W", RangeCode: "85", AOCode: "1" },
      "Rajnandgaon": { AreaCode: "BPL", AOType: "W", RangeCode: "87", AOCode: "91" },

      "Dbalod": { AreaCode: "BPL", AOType: "W", RangeCode: "", AOCode: "" },
      "Baloda Bazar": { AreaCode: "BPL", AOType: "W", RangeCode: "", AOCode: "" },
      "Balrampur": { AreaCode: "BPL", AOType: "W", RangeCode: "", AOCode: "" },
      "Bastar": { AreaCode: "BPL", AOType: "W", RangeCode: "", AOCode: "" },
      "Bemetra": { AreaCode: "BPL", AOType: "W", RangeCode: "", AOCode: "" },
      "Bijapur": { AreaCode: "BPL", AOType: "W", RangeCode: "", AOCode: "" },
      "Dantewada": { AreaCode: "BPL", AOType: "W", RangeCode: "", AOCode: "" },
      "Durg": { AreaCode: "BPL", AOType: "W", RangeCode: "", AOCode: "" },
      "Gariaband": { AreaCode: "BPL", AOType: "W", RangeCode: "", AOCode: "" },
      "Gaurella-Pendra-Marwahi": { AreaCode: "BPL", AOType: "W", RangeCode: "", AOCode: "" },
      "Jashpur": { AreaCode: "BPL", AOType: "W", RangeCode: "", AOCode: "" },
      "Kabirdham": { AreaCode: "BPL", AOType: "W", RangeCode: "", AOCode: "" },
      "Kondagaon": { AreaCode: "BPL", AOType: "W", RangeCode: "", AOCode: "" },
      "Khairagarh": { AreaCode: "BPL", AOType: "W", RangeCode: "", AOCode: "" },
      "Koriya": { AreaCode: "BPL", AOType: "W", RangeCode: "", AOCode: "" },
      "Mohla-Manpur": { AreaCode: "BPL", AOType: "W", RangeCode: "", AOCode: "" },
      "Mungeli": { AreaCode: "BPL", AOType: "W", RangeCode: "", AOCode: "" },
      "Narayanpur": { AreaCode: "BPL", AOType: "W", RangeCode: "", AOCode: "" },
      "Sarangarh-Bilaigarh": { AreaCode: "BPL", AOType: "W", RangeCode: "", AOCode: "" },
      "Sakti": { AreaCode: "BPL", AOType: "W", RangeCode: "", AOCode: "" },
      "Sukma": { AreaCode: "BPL", AOType: "W", RangeCode: "", AOCode: "" },
      "Surajpur": { AreaCode: "BPL", AOType: "W", RangeCode: "", AOCode: "" },
      "Surgunja": { AreaCode: "BPL", AOType: "W", RangeCode: "", AOCode: "" }
    },

    "Dadra and Nagar Haveli": {
      "Silvassa": { AreaCode: "GUJ", AOType: "W", RangeCode: "410", AOCode: "92" }
    },

    "Daman and Diu": {
      "Daman": { AreaCode: "GUJ", AOType: "W", RangeCode: "410", AOCode: "91" },
      "Diu": { AreaCode: "GUJ", AOType: "W", RangeCode: "410", AOCode: "91" }
    },

    "Goa": {
      "Margoa": { AreaCode: "KAR", AOType: "W", RangeCode: "511", AOCode: "93" },
      "Panaji": { AreaCode: "KAR", AOType: "W", RangeCode: "511", AOCode: "1" }
    },
    "Gujarat": {
      "Ahemdabad": { AreaCode: "GUJ", AOType: "W", RangeCode: "108", AOCode: "1" },
      "Amreli": { AreaCode: "GUJ", AOType: "W", RangeCode: "304", AOCode: "92" },
      "Anand": { AreaCode: "GUJ", AOType: "W", RangeCode: "304", AOCode: "92" },
      "Bharuch": { AreaCode: "GUJ", AOType: "W", RangeCode: "304", AOCode: "91" },
      "Bhavnagar": { AreaCode: "GUJ", AOType: "W", RangeCode: "120", AOCode: "1" },
      "Dahod": { AreaCode: "GUJ", AOType: "W", RangeCode: "304", AOCode: "93" },
      "Bardoli": { AreaCode: "GUJ", AOType: "W", RangeCode: "403", AOCode: "91" },
      "Vadodara": { AreaCode: "GUJ", AOType: "W", RangeCode: "301", AOCode: "1" },
      "Dwarka": { AreaCode: "GUJ", AOType: "W", RangeCode: "221", AOCode: "4" },
      "Gandhidham": { AreaCode: "GUJ", AOType: "W", RangeCode: "202", AOCode: "91" },
      "Gandhinagar": { AreaCode: "GUJ", AOType: "W", RangeCode: "123", AOCode: "1" },
      "Godhara": { AreaCode: "GUJ", AOType: "W", RangeCode: "304", AOCode: "94" },
      "Himmatnagar": { AreaCode: "GUJ", AOType: "W", RangeCode: "104", AOCode: "93" },
      "Jamnagar": { AreaCode: "GUJ", AOType: "W", RangeCode: "221", AOCode: "2" },
      "Junagadh": { AreaCode: "GUJ", AOType: "W", RangeCode: "201", AOCode: "92" },
      "Lunawada": { AreaCode: "GUJ", AOType: "W", RangeCode: "304", AOCode: "95" },
      "Mehsana": { AreaCode: "GUJ", AOType: "W", RangeCode: "123", AOCode: "93" },
      "Modasa": { AreaCode: "GUJ", AOType: "W", RangeCode: "104", AOCode: "94" },
      "Morbi": { AreaCode: "GUJ", AOType: "W", RangeCode: "201", AOCode: "93" },
      "Madiad": { AreaCode: "GUJ", AOType: "W", RangeCode: "304", AOCode: "96" },
      "Navsari": { AreaCode: "GUJ", AOType: "W", RangeCode: "412", AOCode: "1" },
      "Palanpur": { AreaCode: "GUJ", AOType: "W", RangeCode: "123", AOCode: "91" },
      "Patan": { AreaCode: "GUJ", AOType: "W", RangeCode: "123", AOCode: "92" },
      "Petlad": { AreaCode: "GUJ", AOType: "W", RangeCode: "301", AOCode: "93" },
      "Porbandar": { AreaCode: "GUJ", AOType: "W", RangeCode: "221", AOCode: "93" },
      "Rajkot": { AreaCode: "GUJ", AOType: "W", RangeCode: "201", AOCode: "1" },
      "Surat": { AreaCode: "GUJ", AOType: "W", RangeCode: "404", AOCode: "1" },
      "Surendranagar": { AreaCode: "GUJ", AOType: "W", RangeCode: "108", AOCode: "91" },
      "Valsad": { AreaCode: "GUJ", AOType: "W", RangeCode: "410", AOCode: "1" },
      "Vapi": { AreaCode: "GUJ", AOType: "W", RangeCode: "410", AOCode: "93" },
      "Aravali": { AreaCode: "GUJ", AOType: "W", RangeCode: "120", AOCode: "10" },
      "Banaskantha": { AreaCode: "GUJ", AOType: "W", RangeCode: "120", AOCode: "10" },
      "Botad": { AreaCode: "GUJ", AOType: "W", RangeCode: "120", AOCode: "10" }
    },

    "Haryana": {
      "Ambala": { AreaCode: "NWR", AOType: "W", RangeCode: "65", AOCode: "92" },
      "Bhiwani": { AreaCode: "NWR", AOType: "W", RangeCode: "57", AOCode: "92" },
      "Faridabad": { AreaCode: "NWR", AOType: "W", RangeCode: "51", AOCode: "1" },
      "Fatehabad": { AreaCode: "NWR", AOType: "W", RangeCode: "57", AOCode: "93" },
      "Gurgaon": { AreaCode: "NWR", AOType: "W", RangeCode: "53", AOCode: "1" },
      "Hisar": { AreaCode: "NWR", AOType: "W", RangeCode: "57", AOCode: "1" },
      "Jind": { AreaCode: "NWR", AOType: "W", RangeCode: "57", AOCode: "94" },
      "Kaithal": { AreaCode: "NWR", AOType: "W", RangeCode: "60", AOCode: "91" },
      "Karnal": { AreaCode: "NWR", AOType: "W", RangeCode: "60", AOCode: "1" },
      "Kurukshetra": { AreaCode: "NWR", AOType: "W", RangeCode: "60", AOCode: "92" },
      "Narnaul": { AreaCode: "NWR", AOType: "W", RangeCode: "107", AOCode: "92" },
      "Panchkula": { AreaCode: "NWR", AOType: "W", RangeCode: "65", AOCode: "1" },
      "Panipat": { AreaCode: "NWR", AOType: "W", RangeCode: "60", AOCode: "93" },
      "Rewari": { AreaCode: "NWR", AOType: "W", RangeCode: "107", AOCode: "93" },
      "Rohtak": { AreaCode: "NWR", AOType: "W", RangeCode: "54", AOCode: "2" },
      "Sirsa": { AreaCode: "NWR", AOType: "W", RangeCode: "57", AOCode: "95" },
      "Sonepat": { AreaCode: "NWR", AOType: "W", RangeCode: "60", AOCode: "94" },
      "Yamunanagar": { AreaCode: "NWR", AOType: "W", RangeCode: "65", AOCode: "91" },
      "Dadri": { AreaCode: "NWR", AOType: "W", RangeCode: "57", AOCode: "91" }
    },

    "Himachal Pradesh": {
      "Baddi": { AreaCode: "NWR", AOType: "W", RangeCode: "35", AOCode: "5" },
      "Dalhousie": { AreaCode: "NWR", AOType: "W", RangeCode: "37", AOCode: "92" },
      "Hamirpur": { AreaCode: "NWR", AOType: "W", RangeCode: "37", AOCode: "93" },
      "Dharamshala": { AreaCode: "NWR", AOType: "W", RangeCode: "37", AOCode: "99" },
      "Kulu": { AreaCode: "NWR", AOType: "W", RangeCode: "37", AOCode: "94" },
      "Mandi": { AreaCode: "NWR", AOType: "W", RangeCode: "37", AOCode: "95" },
      "Nahan": { AreaCode: "NWR", AOType: "W", RangeCode: "37", AOCode: "8" },
      "Nurpur": { AreaCode: "NWR", AOType: "W", RangeCode: "37", AOCode: "96" },
      "Palampur": { AreaCode: "NWR", AOType: "W", RangeCode: "37", AOCode: "97" },
      "Parwanoo": { AreaCode: "NWR", AOType: "W", RangeCode: "37", AOCode: "7" },
      "Rampur Bushahr": { AreaCode: "NWR", AOType: "W", RangeCode: "37", AOCode: "4" },
      "Shimla": { AreaCode: "NWR", AOType: "W", RangeCode: "37", AOCode: "1" },
      "Solan": { AreaCode: "DLC", AOType: "WX", RangeCode: "170", AOCode: "2" },
      "Sunder Nagar": { AreaCode: "NWR", AOType: "W", RangeCode: "37", AOCode: "1" },
      "Una": { AreaCode: "NWR", AOType: "W", RangeCode: "37", AOCode: "98" }
    },


    "Jharkhand": {
      "Bokaro": { AreaCode: "PTN", AOType: "W", RangeCode: "57", AOCode: "93" },
      "Chaibasa": { AreaCode: "PTN", AOType: "W", RangeCode: "54", AOCode: "93" },
      "Dumka": { AreaCode: "PTN", AOType: "W", RangeCode: "60", AOCode: "93" },
      "Giridih": { AreaCode: "PTN", AOType: "W", RangeCode: "60", AOCode: "94" },
      "Daltonganj": { AreaCode: "PTN", AOType: "W", RangeCode: "51", AOCode: "93" },
      "Hazaribagh": { AreaCode: "PTN", AOType: "W", RangeCode: "57", AOCode: "1" },
      "Deogarh": { AreaCode: "PTN", AOType: "W", RangeCode: "60", AOCode: "92" },
      "Dhanbad": { AreaCode: "PTN", AOType: "W", RangeCode: "60", AOCode: "1" },
      "Jamshedpur": { AreaCode: "PTN", AOType: "W", RangeCode: "54", AOCode: "1" },
      "Koderma": { AreaCode: "PTN", AOType: "W", RangeCode: "57", AOCode: "5" },
      "Ramgarh": { AreaCode: "PTN", AOType: "W", RangeCode: "57", AOCode: "92" },
      "Ranchi": { AreaCode: "PTN", AOType: "W", RangeCode: "51", AOCode: "1" },
      "Sahebganj": { AreaCode: "PTN", AOType: "W", RangeCode: "60", AOCode: "95" },
      "Chatra": { AreaCode: "PTN", AOType: "W", RangeCode: "57", AOCode: "1" },
      "East Singhbhum": { AreaCode: "PTN", AOType: "W", RangeCode: "54", AOCode: "1" },
      "Garhwa": { AreaCode: "PTN", AOType: "W", RangeCode: "60", AOCode: "92" },
      "Godda": { AreaCode: "PTN", AOType: "W", RangeCode: "60", AOCode: "92" },
      "Gumla": { AreaCode: "PTN", AOType: "W", RangeCode: "60", AOCode: "92" },
      "Jamtara": { AreaCode: "PTN", AOType: "W", RangeCode: "60", AOCode: "92" },
      "Khunti": { AreaCode: "PTN", AOType: "W", RangeCode: "60", AOCode: "92" },
      "Lohardaga": { AreaCode: "PTN", AOType: "W", RangeCode: "60", AOCode: "92" },
      "Pakur": { AreaCode: "PTN", AOType: "W", RangeCode: "60", AOCode: "92" },
      "Palamu": { AreaCode: "PTN", AOType: "W", RangeCode: "60", AOCode: "92" },
      "Seraikela Kharsawan": { AreaCode: "PTN", AOType: "W", RangeCode: "60", AOCode: "92" },
      "Latehar": { AreaCode: "PTN", AOType: "W", RangeCode: "60", AOCode: "92" }
    },


    "Karnataka": {
      "Bagalkot": { AreaCode: "KAR", AOType: "W", RangeCode: "521", AOCode: "91" },
      "Ballari": { AreaCode: "KAR", AOType: "W", RangeCode: "421", AOCode: "91" },
      "Belagavi": { AreaCode: "KAR", AOType: "W", RangeCode: "521", AOCode: "1" },
      "Bangalore": { AreaCode: "KAR", AOType: "W", RangeCode: "125", AOCode: "91" },
      "Bidar": { AreaCode: "KAR", AOType: "W", RangeCode: "421", AOCode: "4" },
      "Chamarajanagar": { AreaCode: "KAR", AOType: "W", RangeCode: "321", AOCode: "1" },
      "Chikaballapur": { AreaCode: "KAR", AOType: "W", RangeCode: "128", AOCode: "94" },
      "Chikmagalur": { AreaCode: "KAR", AOType: "W", RangeCode: "321", AOCode: "94" },
      "Chitradurga": { AreaCode: "KAR", AOType: "W", RangeCode: "128", AOCode: "93" },
      "Dakshina Kannada": { AreaCode: "KAR", AOType: "W", RangeCode: "128", AOCode: "91" },
      "Davanagere": { AreaCode: "KAR", AOType: "W", RangeCode: "113", AOCode: "94" },
      "Dharwad": { AreaCode: "KAR", AOType: "W", RangeCode: "411", AOCode: "91" },
      "Gadag": { AreaCode: "KAR", AOType: "W", RangeCode: "411", AOCode: "11" },
      "Hassan": { AreaCode: "KAR", AOType: "W", RangeCode: "321", AOCode: "92" },
      "Haveri": { AreaCode: "KAR", AOType: "W", RangeCode: "113", AOCode: "93" },
      "Kalaburagi": { AreaCode: "KAR", AOType: "W", RangeCode: "421", AOCode: "1" },
      "Kodagu": { AreaCode: "KAR", AOType: "W", RangeCode: "321", AOCode: "1" },
      "Kolar": { AreaCode: "KAR", AOType: "W", RangeCode: "126", AOCode: "93" },
      "Koppal": { AreaCode: "KAR", AOType: "W", RangeCode: "411", AOCode: "92" },
      "Mandya": { AreaCode: "KAR", AOType: "W", RangeCode: "321", AOCode: "93" },
      "Mysore": { AreaCode: "KAR", AOType: "W", RangeCode: "321", AOCode: "1" },
      "Raichur": { AreaCode: "KAR", AOType: "W", RangeCode: "421", AOCode: "6" },
      "Ramnagar": { AreaCode: "KAR", AOType: "W", RangeCode: "125", AOCode: "94" },
      "Shivamoga": { AreaCode: "KAR", AOType: "W", RangeCode: "224", AOCode: "91" },
      "Tumakuru": { AreaCode: "KAR", AOType: "W", RangeCode: "212", AOCode: "91" },
      "Udupi": { AreaCode: "KAR", AOType: "W", RangeCode: "531", AOCode: "92" },
      "Uttara Kannada": { AreaCode: "KAR", AOType: "W", RangeCode: "531", AOCode: "7" },
      "Vijayapura": { AreaCode: "KAR", AOType: "W", RangeCode: "521", AOCode: "92" },
      "Yadgir": { AreaCode: "KAR", AOType: "W", RangeCode: "421", AOCode: "5" }
    },

    "Kerala": {
      "Alappuzha": { AreaCode: "KRL", AOType: "W", RangeCode: "61", AOCode: "91" },
      "Kannur": { AreaCode: "KRL", AOType: "W", RangeCode: "31", AOCode: "91" },
      "Ernakulam": { AreaCode: "KRL", AOType: "W", RangeCode: "10", AOCode: "91" },
      "Idukki": { AreaCode: "KRL", AOType: "W", RangeCode: "10", AOCode: "1" },
      "Kottayam": { AreaCode: "KRL", AOType: "W", RangeCode: "61", AOCode: "1" },
      "Kozhikode": { AreaCode: "KRL", AOType: "W", RangeCode: "31", AOCode: "1" },
      "Malappuram": { AreaCode: "KRL", AOType: "W", RangeCode: "21", AOCode: "93" },
      "Palakkad": { AreaCode: "KRL", AOType: "W", RangeCode: "21", AOCode: "92" },
      "Kasaragod": { AreaCode: "KRL", AOType: "W", RangeCode: "31", AOCode: "92" },
      "Kollam": { AreaCode: "KRL", AOType: "W", RangeCode: "51", AOCode: "91" },
      "Thiruvalla": { AreaCode: "KRL", AOType: "W", RangeCode: "61", AOCode: "92" },
      "Thiruvananthapuram": { AreaCode: "KRL", AOType: "W", RangeCode: "51", AOCode: "1" },
      "Thrissur": { AreaCode: "KRL", AOType: "W", RangeCode: "21", AOCode: "4" },
      "Wayanad": { AreaCode: "KRL", AOType: "W", RangeCode: "32", AOCode: "7" }
    },

    "Madhya Pradesh": {
      "Agar Malwa": { AreaCode: "BPL", AOType: "W", RangeCode: "91", AOCode: "94" },
      "Alirajpur": { AreaCode: "BPL", AOType: "W", RangeCode: "33", AOCode: "4" },
      "Anuppur": { AreaCode: "BPL", AOType: "W", RangeCode: "71", AOCode: "96" },
      "Ashok Nagar": { AreaCode: "BPL", AOType: "W", RangeCode: "41", AOCode: "94" },
      "Balaghat": { AreaCode: "BPL", AOType: "W", RangeCode: "72", AOCode: "92" },
      "Barwani": { AreaCode: "BPL", AOType: "W", RangeCode: "33", AOCode: "4" },
      "Betul": { AreaCode: "BPL", AOType: "W", RangeCode: "31", AOCode: "91" },
      "Bind": { AreaCode: "BPL", AOType: "W", RangeCode: "33", AOCode: "92" },
      "Bhopal": { AreaCode: "BPL", AOType: "W", RangeCode: "31", AOCode: "1" },
      "Burhanpur": { AreaCode: "BPL", AOType: "W", RangeCode: "61", AOCode: "93" },
      "Chhatarpur": { AreaCode: "BPL", AOType: "W", RangeCode: "41", AOCode: "11" },
      "Chhindwara": { AreaCode: "BPL", AOType: "W", RangeCode: "71", AOCode: "91" },
      "Damoh": { AreaCode: "DLC", AOType: "CA", RangeCode: "267", AOCode: "1" },
      "Datia": { AreaCode: "DLC", AOType: "CA", RangeCode: "267", AOCode: "1" },
      "Dewas": { AreaCode: "DLC", AOType: "CA", RangeCode: "267", AOCode: "1" },
      "Dhar": { AreaCode: "DLC", AOType: "CA", RangeCode: "267", AOCode: "1" },
      "Dindori": { AreaCode: "BPL", AOType: "W", RangeCode: "33", AOCode: "4" },
      "Guna": { AreaCode: "BPL", AOType: "W", RangeCode: "41", AOCode: "93" },
      "Gwalior": { AreaCode: "BPL", AOType: "W", RangeCode: "41", AOCode: "1" },
      "Harda": { AreaCode: "BPL", AOType: "W", RangeCode: "31", AOCode: "92" },
      "Hoshangabad": { AreaCode: "BPL", AOType: "W", RangeCode: "33", AOCode: "4" },
      "Indore": { AreaCode: "BPL", AOType: "W", RangeCode: "61", AOCode: "1" },
      "Jabalpur": { AreaCode: "BPL", AOType: "W", RangeCode: "71", AOCode: "1" },
      "Jhabua": { AreaCode: "DLC", AOType: "CA", RangeCode: "267", AOCode: "1" },
      "Katni": { AreaCode: "BPL", AOType: "W", RangeCode: "71", AOCode: "91" },
      "Khandwa": { AreaCode: "BPL", AOType: "W", RangeCode: "61", AOCode: "94" },
      "Khargone": { AreaCode: "BPL", AOType: "W", RangeCode: "61", AOCode: "92" },
      "Mandla": { AreaCode: "BPL", AOType: "W", RangeCode: "33", AOCode: "4" },
      "Mandsaur": { AreaCode: "BPL", AOType: "W", RangeCode: "91", AOCode: "92" },
      "Mauganj": { AreaCode: "BPL", AOType: "W", RangeCode: "71", AOCode: "92" },
      "Morena": { AreaCode: "BPL", AOType: "W", RangeCode: "41", AOCode: "95" },
      "Narsinghpur": { AreaCode: "BPL", AOType: "W", RangeCode: "33", AOCode: "4" },
      "Niwari": { AreaCode: "BPL", AOType: "W", RangeCode: "41", AOCode: "4" },
      "Neemuch": { AreaCode: "BPL", AOType: "W", RangeCode: "91", AOCode: "93" },
      "Raisen": { AreaCode: "BPL", AOType: "W", RangeCode: "26", AOCode: "93" },
      "Rajgarh": { AreaCode: "BPL", AOType: "W", RangeCode: "91", AOCode: "96" },
      "Ratlam": { AreaCode: "BPL", AOType: "W", RangeCode: "91", AOCode: "95" },
      "Rewa": { AreaCode: "BPL", AOType: "W", RangeCode: "71", AOCode: "92" },
      "Sagar": { AreaCode: "BPL", AOType: "W", RangeCode: "71", AOCode: "93" },
      "Satna": { AreaCode: "BPL", AOType: "W", RangeCode: "71", AOCode: "94" },
      "Sehore": { AreaCode: "BPL", AOType: "W", RangeCode: "33", AOCode: "5" },
      "Sheoni": { AreaCode: "BPL", AOType: "W", RangeCode: "72", AOCode: "96" },
      "Shahdol": { AreaCode: "BPL", AOType: "W", RangeCode: "71", AOCode: "96" },
      "Shajapur": { AreaCode: "BPL", AOType: "W", RangeCode: "91", AOCode: "94" },
      "Sheopur": { AreaCode: "BPL", AOType: "W", RangeCode: "41", AOCode: "95" },
      "Shivpuri": { AreaCode: "BPL", AOType: "W", RangeCode: "41", AOCode: "1" },
      "Sidhi": { AreaCode: "BPL", AOType: "W", RangeCode: "71", AOCode: "92" },
      "Singrauli": { AreaCode: "BPL", AOType: "W", RangeCode: "71", AOCode: "97" },
      "Tikamgarh": { AreaCode: "BPL", AOType: "W", RangeCode: "41", AOCode: "4" },
      "Ujjain": { AreaCode: "BPL", AOType: "W", RangeCode: "91", AOCode: "1" },
      "Umaria": { AreaCode: "BPL", AOType: "W", RangeCode: "71", AOCode: "96" },
      "Vidisha": { AreaCode: "BPL", AOType: "W", RangeCode: "33", AOCode: "91" }
    },

    "Maharashtra": {
      "Ahmednagar": { AreaCode: "PNE", AOType: "W", RangeCode: "52", AOCode: "91" },
      "Akola": { AreaCode: "NGP", AOType: "W", RangeCode: "101", AOCode: "1" },
      "Amrawati": { AreaCode: "NGP", AOType: "W", RangeCode: "301", AOCode: "1" },
      "Aurangabad": { AreaCode: "PNE", AOType: "W", RangeCode: "27", AOCode: "1" },
      "Bhandara": { AreaCode: "NGP", AOType: "W", RangeCode: "2", AOCode: "41" },
      "Buldhana": { AreaCode: "NGP", AOType: "W", RangeCode: "101", AOCode: "2" },
      "Chandrapur": { AreaCode: "NGP", AOType: "W", RangeCode: "301", AOCode: "91" },
      "Dhule": { AreaCode: "PNE", AOType: "W", RangeCode: "21", AOCode: "92" },
      "Gadchiroli": { AreaCode: "NGP", AOType: "W", RangeCode: "301", AOCode: "92" },
      "Gondia": { AreaCode: "NGP", AOType: "W", RangeCode: "4", AOCode: "93" },
      "Hingoli": { AreaCode: "PNE", AOType: "W", RangeCode: "27", AOCode: "94" },
      "Jalna": { AreaCode: "PNE", AOType: "W", RangeCode: "27", AOCode: "91" },
      "Jalgaon": { AreaCode: "PNE", AOType: "W", RangeCode: "25", AOCode: "1" },
      "Kolhapur": { AreaCode: "PNE", AOType: "W", RangeCode: "93", AOCode: "91" },
      "Latur": { AreaCode: "PNE", AOType: "W", RangeCode: "27", AOCode: "92" },
      "Mumbai City": { AreaCode: "MUM", AOType: "W", RangeCode: "125", AOCode: "1" },
      "Mumbai Suburban": { AreaCode: "MUM", AOType: "W", RangeCode: "251", AOCode: "1" },
      "Nandurbar": { AreaCode: "PNE", AOType: "W", RangeCode: "25", AOCode: "1" },
      "Nanded": { AreaCode: "PNE", AOType: "W", RangeCode: "27", AOCode: "93" },
      "Nagpur": { AreaCode: "NGP", AOType: "W", RangeCode: "1", AOCode: "1" },
      "Pune": { AreaCode: "PNE", AOType: "W", RangeCode: "21", AOCode: "1" },
      "Palghar": { AreaCode: "PNE", AOType: "W", RangeCode: "70", AOCode: "91" },
      "Ratnagiri": { AreaCode: "PNE", AOType: "W", RangeCode: "93", AOCode: "6" },
      "Sangli": { AreaCode: "PNE", AOType: "W", RangeCode: "94", AOCode: "1" },
      "Satara": { AreaCode: "PNE", AOType: "W", RangeCode: "62", AOCode: "2" },
      "Solapur": { AreaCode: "PNE", AOType: "W", RangeCode: "63", AOCode: "1" },
      "Thane": { AreaCode: "PNE", AOType: "W", RangeCode: "70", AOCode: "1" },
      "Wardha": { AreaCode: "NGP", AOType: "W", RangeCode: "3", AOCode: "92" },
      "Yavatmal": { AreaCode: "NGP", AOType: "W", RangeCode: "3", AOCode: "91" },
      "Ichalkaranji": { AreaCode: "PNE", AOType: "W", RangeCode: "93", AOCode: "93" }
    },

    "Manipur": {
      "Bishnupur": { AreaCode: "SHL", AOType: "W", RangeCode: "9", AOCode: "2" },
      "Chandel": { AreaCode: "SHL", AOType: "W", RangeCode: "9", AOCode: "2" },
      "Churachandpur": { AreaCode: "SHL", AOType: "W", RangeCode: "9", AOCode: "2" },
      "Imphal East": { AreaCode: "SHL", AOType: "W", RangeCode: "9", AOCode: "1" },
      "Imphal West": { AreaCode: "SHL", AOType: "W", RangeCode: "9", AOCode: "1" },
      "Jaribam": { AreaCode: "SHL", AOType: "W", RangeCode: "9", AOCode: "1" },
      "Kakching": { AreaCode: "SHL", AOType: "W", RangeCode: "9", AOCode: "1" },
      "Kamjong": { AreaCode: "SHL", AOType: "W", RangeCode: "9", AOCode: "1" },
      "Kangpokpi": { AreaCode: "SHL", AOType: "W", RangeCode: "9", AOCode: "1" },
      "Noney": { AreaCode: "SHL", AOType: "W", RangeCode: "9", AOCode: "1" },
      "Pherzawl": { AreaCode: "SHL", AOType: "W", RangeCode: "9", AOCode: "1" },
      "Senapati": { AreaCode: "SHL", AOType: "W", RangeCode: "9", AOCode: "1" },
      "Tengnoupal": { AreaCode: "SHL", AOType: "W", RangeCode: "9", AOCode: "1" },
      "Thoubal": { AreaCode: "SHL", AOType: "W", RangeCode: "9", AOCode: "1" },
      "Ukhrul": { AreaCode: "SHL", AOType: "W", RangeCode: "9", AOCode: "1" }
    },

    "Meghalaya": {
      "East Garo Hills": { AreaCode: "SHL", AOType: "W", RangeCode: "15", AOCode: "1" },
      "East Khasi Hills": { AreaCode: "SHL", AOType: "W", RangeCode: "15", AOCode: "1" },
      "Jaintia Hills": { AreaCode: "SHL", AOType: "W", RangeCode: "15", AOCode: "1" },
      "Ri Bhoi": { AreaCode: "SHL", AOType: "CI", RangeCode: "15", AOCode: "1" },
      "South Garo Hills": { AreaCode: "SHL", AOType: "W", RangeCode: "15", AOCode: "2" },
      "South Khasi Hills": { AreaCode: "SHL", AOType: "W", RangeCode: "15", AOCode: "2" },
      "West Garo Hills": { AreaCode: "SHL", AOType: "W", RangeCode: "15", AOCode: "2" },
      "West Khasi Hills": { AreaCode: "SHL", AOType: "W", RangeCode: "15", AOCode: "2" }
    },
    "Mizoram": {
      "Aizawl": { AreaCode: "SHL", AOType: "W", RangeCode: "2", AOCode: "6" },
      "Champhai": { AreaCode: "SHL", AOType: "W", RangeCode: "2", AOCode: "6" },
      "Kolasib": { AreaCode: "SHL", AOType: "W", RangeCode: "2", AOCode: "6" },
      "Lawngtlai": { AreaCode: "SHL", AOType: "W", RangeCode: "2", AOCode: "6" },
      "Lunglei": { AreaCode: "SHL", AOType: "W", RangeCode: "2", AOCode: "6" },
      "Mamit": { AreaCode: "SHL", AOType: "W", RangeCode: "2", AOCode: "6" },
      "Saiha": { AreaCode: "SHL", AOType: "W", RangeCode: "2", AOCode: "6" },
      "Serchhip": { AreaCode: "SHL", AOType: "W", RangeCode: "2", AOCode: "6" }
    },
    "Nagaland": {
      "Dimapur": { AreaCode: "SHL", AOType: "W", RangeCode: "7", AOCode: "6" },
      "Kiphire": { AreaCode: "SHL", AOType: "W", RangeCode: "7", AOCode: "6" },
      "Kohima": { AreaCode: "SHL", AOType: "W", RangeCode: "7", AOCode: "6" },
      "Longleng": { AreaCode: "SHL", AOType: "W", RangeCode: "7", AOCode: "6" },
      "Mokokchung": { AreaCode: "SHL", AOType: "W", RangeCode: "7", AOCode: "6" },
      "Mon": { AreaCode: "SHL", AOType: "W", RangeCode: "7", AOCode: "6" },
      "Peren": { AreaCode: "SHL", AOType: "W", RangeCode: "7", AOCode: "6" },
      "Phek": { AreaCode: "SHL", AOType: "W", RangeCode: "7", AOCode: "6" },
      "Tuensang": { AreaCode: "SHL", AOType: "W", RangeCode: "7", AOCode: "6" },
      "Wokha": { AreaCode: "SHL", AOType: "W", RangeCode: "7", AOCode: "6" },
      "Zunheboto": { AreaCode: "SHL", AOType: "W", RangeCode: "7", AOCode: "6" }
    },

    "Odisha": {
      "Angul": { AreaCode: "BBN", AOType: "W", RangeCode: "1", AOCode: "93" },
      "Bargarh": { AreaCode: "BBN", AOType: "W", RangeCode: "7", AOCode: "93" },
      "Bolangir": { AreaCode: "BBN", AOType: "W", RangeCode: "7", AOCode: "91" },
      "Baleswar": { AreaCode: "BBN", AOType: "W", RangeCode: "4", AOCode: "91" },
      "Boudh": { AreaCode: "BBN", AOType: "W", RangeCode: "", AOCode: "" },
      "Cuttack": { AreaCode: "BBN", AOType: "W", RangeCode: "4", AOCode: "1" },
      "Dhenkanal": { AreaCode: "BBN", AOType: "W", RangeCode: "1", AOCode: "94" },
      "Gajapati": { AreaCode: "BBN", AOType: "W", RangeCode: "", AOCode: "" },
      "Ganjam": { AreaCode: "BBN", AOType: "W", RangeCode: "", AOCode: "" },
      "Jagatsinghpur": { AreaCode: "BBN", AOType: "W", RangeCode: "", AOCode: "" },
      "Jajpur": { AreaCode: "BBN", AOType: "W", RangeCode: "4", AOCode: "2" },
      "Jharsuguda": { AreaCode: "BBN", AOType: "W", RangeCode: "9", AOCode: "93" },
      "Kalahandi": { AreaCode: "BBN", AOType: "W", RangeCode: "", AOCode: "" },
      "Kandhamal": { AreaCode: "BBN", AOType: "W", RangeCode: "", AOCode: "" },
      "Kendrapara": { AreaCode: "BBN", AOType: "W", RangeCode: "2", AOCode: "93" },
      "Kendujhar": { AreaCode: "", AOType: "", RangeCode: "9", AOCode: "92" },
      "Khurda": { AreaCode: "", AOType: "", RangeCode: "2", AOCode: "4" },
      "Koraput": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "Malkangiri": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "Mayurbhanj": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "Nabarangpur": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "Nayagarh": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "Puri": { AreaCode: "BBN", AOType: "W", RangeCode: "1", AOCode: "95" },
      "Rayagada": { AreaCode: "BBN", AOType: "W", RangeCode: "7", AOCode: "97" },
      "Sambalpur": { AreaCode: "BBN", AOType: "W", RangeCode: "7", AOCode: "92" },
      "Sonepur": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "Sundargarh": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" }
    },

    "Punjab": {
      "Abhor": { AreaCode: "BPL", AOType: "W", RangeCode: "84", AOCode: "4" },
      "Amritsar": { AreaCode: "NWR", AOType: "W", RangeCode: "80", AOCode: "1" },
      "Barnala": { AreaCode: "NWR", AOType: "W", RangeCode: "47", AOCode: "97" },
      "Bathinda": { AreaCode: "NWR", AOType: "W", RangeCode: "89", AOCode: "1" },
      "Faridkot": { AreaCode: "NWR", AOType: "W", RangeCode: "89", AOCode: "91" },
      "Fatehgarh Sahib": { AreaCode: "NWR", AOType: "W", RangeCode: "", AOCode: "" },
      "Fazilka": { AreaCode: "NWR", AOType: "W", RangeCode: "", AOCode: "" },
      "Firozpur": { AreaCode: "NWR", AOType: "W", RangeCode: "89", AOCode: "94" },
      "Gurdaspur": { AreaCode: "NWR", AOType: "W", RangeCode: "80", AOCode: "94" },
      "Hoshiarpur": { AreaCode: "NWR", AOType: "W", RangeCode: "101", AOCode: "92" },
      "Jalandhar": { AreaCode: "NWR", AOType: "W", RangeCode: "101", AOCode: "1" },
      "Kapurthala": { AreaCode: "NWR", AOType: "W", RangeCode: "104", AOCode: "3" },
      "Ludhiana": { AreaCode: "NWR", AOType: "W", RangeCode: "110", AOCode: "5" },
      "Mansa": { AreaCode: "NWR", AOType: "W", RangeCode: "89", AOCode: "4" },
      "Moga": { AreaCode: "NWR", AOType: "W", RangeCode: "110", AOCode: "96" },
      "Muktsar": { AreaCode: "NWR", AOType: "W", RangeCode: "89", AOCode: "92" },
      "Nawansahar": { AreaCode: "NWR", AOType: "W", RangeCode: "101", AOCode: "91" },
      "Patiala": { AreaCode: "NWR", AOType: "W", RangeCode: "47", AOCode: "30" },
      "Rupnagar": { AreaCode: "NWR", AOType: "W", RangeCode: "", AOCode: "" },
      "Sangur": { AreaCode: "NWR", AOType: "W", RangeCode: "47", AOCode: "94" },
      "Sahid BhagatSingh Nagar": { AreaCode: "NWR", AOType: "W", RangeCode: "", AOCode: "" },
      "Tar Taran": { AreaCode: "NWR", AOType: "W", RangeCode: "80", AOCode: "3" },
      "Dasuya": { AreaCode: "NWR", AOType: "W", RangeCode: "101", AOCode: "93" },
      "Batala": { AreaCode: "NWR", AOType: "W", RangeCode: "80", AOCode: "91" },
      "Gobindgarh": { AreaCode: "NWR", AOType: "W", RangeCode: "47", AOCode: "99" },
      "Jagraon": { AreaCode: "NWR", AOType: "W", RangeCode: "110", AOCode: "95" },
      "Khanna": { AreaCode: "NWR", AOType: "W", RangeCode: "113", AOCode: "91" },
      "Malerkotla": { AreaCode: "NWR", AOType: "W", RangeCode: "113", AOCode: "3" },
      "Mandi Gobindgarh": { AreaCode: "NWR", AOType: "W", RangeCode: "47", AOCode: "98" },
      "Nabha": { AreaCode: "NWR", AOType: "W", RangeCode: "47", AOCode: "91" },
      "Nakodar": { AreaCode: "NWR", AOType: "W", RangeCode: "104", AOCode: "92" },
      "Phagwara": { AreaCode: "NWR", AOType: "W", RangeCode: "104", AOCode: "91" },
      "Rajpura": { AreaCode: "NWR", AOType: "W", RangeCode: "47", AOCode: "92" },
      "Ropar": { AreaCode: "NWR", AOType: "W", RangeCode: "41", AOCode: "94" },
      "Samana": { AreaCode: "NWR", AOType: "W", RangeCode: "47", AOCode: "93" },
      "Sirhind": { AreaCode: "NWR", AOType: "W", RangeCode: "47", AOCode: "95" },
      "Sunam": { AreaCode: "NWR", AOType: "W", RangeCode: "47", AOCode: "96" },
      "Zira": { AreaCode: "NWR", AOType: "W", RangeCode: "", AOCode: "" },
      "Balasore": { AreaCode: "NWR", AOType: "W", RangeCode: "", AOCode: "" }
    },
    "Rajasthan": {
      "Abu": { AreaCode: "RJN", AOType: "W", RangeCode: "510", AOCode: "91" },
      "Ajmer": { AreaCode: "RJN", AOType: "W", RangeCode: "750", AOCode: "1" },
      "Alwar": { AreaCode: "RJN", AOType: "W", RangeCode: "110", AOCode: "1" },
      "Banswara": { AreaCode: "RJN", AOType: "W", RangeCode: "720", AOCode: "91" },
      "Baran": { AreaCode: "RJN", AOType: "W", RangeCode: "780", AOCode: "4" },
      "Barmer": { AreaCode: "RJN", AOType: "W", RangeCode: "540", AOCode: "95" },
      "Bhilwara": { AreaCode: "RJN", AOType: "W", RangeCode: "750", AOCode: "91" },
      "Bikaner": { AreaCode: "RJN", AOType: "W", RangeCode: "570", AOCode: "1" },
      "Bundi": { AreaCode: "RJN", AOType: "W", RangeCode: "780", AOCode: "92" },
      "Chittorgarh": { AreaCode: "RJN", AOType: "W", RangeCode: "720", AOCode: "92" },
      "Churu": { AreaCode: "RJN", AOType: "W", RangeCode: "107", AOCode: "91" },
      "Dausa": { AreaCode: "RJN", AOType: "W", RangeCode: "110", AOCode: "93" },
      "Dholpur": { AreaCode: "RJN", AOType: "W", RangeCode: "", AOCode: "" },
      "Dungarpur": { AreaCode: "RJN", AOType: "W", RangeCode: "720", AOCode: "94" },
      "Hanumangarh": { AreaCode: "RJN", AOType: "W", RangeCode: "570", AOCode: "93" },
      "Jaipur": { AreaCode: "RJN", AOType: "W", RangeCode: "101", AOCode: "1" },
      "Jaisalmer": { AreaCode: "RJN", AOType: "W", RangeCode: "540", AOCode: "92" },
      "Jalore": { AreaCode: "RJN", AOType: "W", RangeCode: "540", AOCode: "96" },
      "Jhalawar": { AreaCode: "RJN", AOType: "W", RangeCode: "780", AOCode: "94" },
      "Jhunjhunu": { AreaCode: "RJN", AOType: "W", RangeCode: "107", AOCode: "92" },
      "Jodhpur": { AreaCode: "RJN", AOType: "W", RangeCode: "540", AOCode: "1" },
      "Karauli": { AreaCode: "RJN", AOType: "W", RangeCode: "780", AOCode: "93" },
      "Kota": { AreaCode: "RJN", AOType: "W", RangeCode: "780", AOCode: "1" },
      "Nagaur": { AreaCode: "RJN", AOType: "W", RangeCode: "540", AOCode: "54" },
      "Neem Ka Thana": { AreaCode: "RJN", AOType: "W", RangeCode: "107", AOCode: "94" },
      "Pali": { AreaCode: "RJN", AOType: "W", RangeCode: "510", AOCode: "95" },
      "Rajsamand": { AreaCode: "RJN", AOType: "W", RangeCode: "720", AOCode: "3" },
      "Sawai Madhopur": { AreaCode: "RJN", AOType: "W", RangeCode: "780", AOCode: "91" },
      "Sri Ganganagar": { AreaCode: "RJN", AOType: "W", RangeCode: "570", AOCode: "92" },
      "Tonk": { AreaCode: "RJN", AOType: "W", RangeCode: "107", AOCode: "5" },
      "Udaipur": { AreaCode: "SHL", AOType: "W", RangeCode: "16", AOCode: "91" }
    },
    "Sikkim": {
      "East Sikkim": { AreaCode: "BGW", AOType: "W", RangeCode: "208", AOCode: "91" },
      "North Sikkim": { AreaCode: "BGW", AOType: "W", RangeCode: "208", AOCode: "91" },
      "South Sikkim": { AreaCode: "BGW", AOType: "W", RangeCode: "208", AOCode: "91" },
      "West Sikkim": { AreaCode: "BGW", AOType: "W", RangeCode: "208", AOCode: "91" },
      "Gangtok": { AreaCode: "BGW", AOType: "W", RangeCode: "208", AOCode: "91" }
    },
    "Tamil Nadu": {
      "Chengalpattu": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "Chennai": { AreaCode: "CHE", AOType: "W", RangeCode: "105", AOCode: "1" },
      "Coimbatore": { AreaCode: "", AOType: "", RangeCode: "61", AOCode: "11" },
      "Cuddalore": { AreaCode: "", AOType: "", RangeCode: "181", AOCode: "1" },
      "Dharmapuri": { AreaCode: "", AOType: "", RangeCode: "231", AOCode: "11" },
      "Dindigul": { AreaCode: "", AOType: "", RangeCode: "501", AOCode: "91" },
      "Erode": { AreaCode: "", AOType: "", RangeCode: "65", AOCode: "11" },
      "Hosur": { AreaCode: "", AOType: "", RangeCode: "231", AOCode: "92" },
      "Kallakurichi": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "Kancheepuram": { AreaCode: "", AOType: "", RangeCode: "141", AOCode: "91" },
      "Kanyakumari": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "Karur": { AreaCode: "", AOType: "", RangeCode: "191", AOCode: "91" },
      "Krishnagiri": { AreaCode: "", AOType: "", RangeCode: "231", AOCode: "93" },
      "Madurai": { AreaCode: "", AOType: "", RangeCode: "501", AOCode: "11" },
      "Nagapattinam": { AreaCode: "", AOType: "", RangeCode: "192", AOCode: "31" },
      "Namakkal": { AreaCode: "", AOType: "", RangeCode: "65", AOCode: "91" },
      "Nilgiris": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "Perambalur": { AreaCode: "", AOType: "", RangeCode: "191", AOCode: "11" },
      "Pudukkottai": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "Ramanathapuram": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "Salem": { AreaCode: "", AOType: "", RangeCode: "231", AOCode: "1" },
      "Sivaganga": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "Tenkasi": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "Thanjavur": { AreaCode: "", AOType: "", RangeCode: "192", AOCode: "16" },
      "Theni": { AreaCode: "", AOType: "", RangeCode: "501", AOCode: "92" },
      "Thoothukudi": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "Tiruvallur": { AreaCode: "", AOType: "", RangeCode: "141", AOCode: "92" },
      "Tirunelveli": { AreaCode: "", AOType: "", RangeCode: "513", AOCode: "11" },
      "Tiruppur": { AreaCode: "", AOType: "", RangeCode: "68", AOCode: "11" },
      "Vellore": { AreaCode: "", AOType: "", RangeCode: "146", AOCode: "1" },
      "Villupuram": { AreaCode: "", AOType: "", RangeCode: "181", AOCode: "11" },
      "Virudhunagar": { AreaCode: "", AOType: "", RangeCode: "501", AOCode: "94" }
    },
    "Telangana": {
      "Adilabad": { AreaCode: "APR", AOType: "W", RangeCode: "72", AOCode: "93" },
      "Hyderabad": { AreaCode: "APR", AOType: "W", RangeCode: "50", AOCode: "1" },
      "Jagtial": { AreaCode: "APR", AOType: "W", RangeCode: "", AOCode: "" },
      "Jangaon": { AreaCode: "APR", AOType: "W", RangeCode: "", AOCode: "" },
      "Jayashankar Bhupalapally": { AreaCode: "APR", AOType: "W", RangeCode: "", AOCode: "" },
      "Jogulamba Gadwal": { AreaCode: "APR", AOType: "W", RangeCode: "", AOCode: "" },
      "Kamareddy": { AreaCode: "APR", AOType: "W", RangeCode: "", AOCode: "" },
      "Karimnagar": { AreaCode: "APR", AOType: "W", RangeCode: "72", AOCode: "2" },
      "Khammam": { AreaCode: "APR", AOType: "W", RangeCode: "63", AOCode: "91" },
      "Komaram Bheem Asifabad": { AreaCode: "APR", AOType: "W", RangeCode: "", AOCode: "" },
      "Kothagudem": { AreaCode: "APR", AOType: "W", RangeCode: "63", AOCode: "92" },
      "Mahabubnagar": { AreaCode: "APR", AOType: "W", RangeCode: "55", AOCode: "4" },
      "Mahabubabad": { AreaCode: "APR", AOType: "W", RangeCode: "", AOCode: "" },
      "Mancherial": { AreaCode: "APR", AOType: "W", RangeCode: "72", AOCode: "5" },
      "Medak": { AreaCode: "APR", AOType: "W", RangeCode: "", AOCode: "" },
      "Medchal Malkajgiri": { AreaCode: "APR", AOType: "W", RangeCode: "", AOCode: "" },
      "Mulugu": { AreaCode: "APR", AOType: "W", RangeCode: "", AOCode: "" },
      "Nagarkurnool": { AreaCode: "APR", AOType: "W", RangeCode: "", AOCode: "" },
      "Nalgonda": { AreaCode: "APR", AOType: "W", RangeCode: "53", AOCode: "91" },
      "Nirmal": { AreaCode: "APR", AOType: "W", RangeCode: "72", AOCode: "92" },
      "Nizamabad": { AreaCode: "APR", AOType: "W", RangeCode: "72", AOCode: "94" },
      "Peddapalli": { AreaCode: "APR", AOType: "W", RangeCode: "", AOCode: "" },
      "Rajanna Sircilla": { AreaCode: "APR", AOType: "W", RangeCode: "", AOCode: "" },
      "Rangareddy": { AreaCode: "APR", AOType: "W", RangeCode: "", AOCode: "" },
      "Sangareddy": { AreaCode: "APR", AOType: "W", RangeCode: "58", AOCode: "4" },
      "Siddipet": { AreaCode: "APR", AOType: "W", RangeCode: "59", AOCode: "91" },
      "Suryapet": { AreaCode: "APR", AOType: "W", RangeCode: "53", AOCode: "92" },
      "Vikarabad": { AreaCode: "APR", AOType: "W", RangeCode: "58", AOCode: "6" },
      "Wanaparthy": { AreaCode: "APR", AOType: "W", RangeCode: "", AOCode: "" },
      "Warangal": { AreaCode: "APR", AOType: "W", RangeCode: "53", AOCode: "94" },
      "Yadadri Bhuvanagiri": { AreaCode: "APR", AOType: "W", RangeCode: "", AOCode: "" }
    },
    "Tripura": {
      "Dhalai": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "Gomati": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "Khowai": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "North Tripura": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "South Tripura": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "Sepahijala": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "Agartala": { AreaCode: "SHL", AOType: "W", RangeCode: "16", AOCode: "92" },
      "Dharmanagar": { AreaCode: "SHL", AOType: "W", RangeCode: "16", AOCode: "93" },
      "West Tripura": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" }
    },
    "Uttar Pradesh": {
      "Agra": { AreaCode: "KNP", AOType: "W", RangeCode: "75", AOCode: "1" },
      "Aligarh": { AreaCode: "KNP", AOType: "W", RangeCode: "85", AOCode: "1" },
      "Ambedkar Nagar": { AreaCode: "LKN", AOType: "W", RangeCode: "61", AOCode: "3" },
      "Amethi": { AreaCode: "LKN", AOType: "W", RangeCode: "61", AOCode: "92" },
      "Amroha": { AreaCode: "BPL", AOType: "C", RangeCode: "82", AOCode: "3" },
      "Auraiya": { AreaCode: "KNP", AOType: "W", RangeCode: "75", AOCode: "5" },
      "Azamgarh": { AreaCode: "LKN", AOType: "W", RangeCode: "26", AOCode: "92" },
      "Baghpath": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "Bahraich": { AreaCode: "LKN", AOType: "W", RangeCode: "61", AOCode: "93" },
      "Ballia": { AreaCode: "LKN", AOType: "W", RangeCode: "23", AOCode: "93" },
      "Balrampur": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "Banda": { AreaCode: "KNP", AOType: "W", RangeCode: "54", AOCode: "92" },
      "Barabanki": { AreaCode: "LKN", AOType: "W", RangeCode: "93", AOCode: "94" },
      "Bareilly": { AreaCode: "LKN", AOType: "W", RangeCode: "41", AOCode: "11" },
      "Bijnor": { AreaCode: "LKN", AOType: "W", RangeCode: "71", AOCode: "94" },
      "Budaun": { AreaCode: "LKN", AOType: "W", RangeCode: "71", AOCode: "91" },
      "Bulandshahar": { AreaCode: "KNP", AOType: "W", RangeCode: "17", AOCode: "94" },
      "Basti": { AreaCode: "LKN", AOType: "W", RangeCode: "61", AOCode: "95" },
      "Bhadohi": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "Baraut": { AreaCode: "KNP", AOType: "W", RangeCode: "14", AOCode: "6" },
      "Chandauli": { AreaCode: "LKN", AOType: "W", RangeCode: "71", AOCode: "93" },
      "Chitrakoot": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "Etah": { AreaCode: "KNP", AOType: "W", RangeCode: "75", AOCode: "92" },
      "Etawah": { AreaCode: "KNP", AOType: "W", RangeCode: "80", AOCode: "93" },
      "Deoria": { AreaCode: "LKN", AOType: "W", RangeCode: "26", AOCode: "94" },
      "Deobandh": { AreaCode: "KNP", AOType: "W", RangeCode: "23", AOCode: "91" },
      "Dhampur": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "Faizabad": { AreaCode: "LKN", AOType: "W", RangeCode: "61", AOCode: "1" },
      "Farrukhabad": { AreaCode: "KNP", AOType: "W", RangeCode: "85", AOCode: "91" },
      "Fatehpur": { AreaCode: "LKN", AOType: "W", RangeCode: "20", AOCode: "93" },
      "Firozabad": { AreaCode: "LKN", AOType: "W", RangeCode: "20", AOCode: "93" },
      "Gautam Buddha Nagar": { AreaCode: "KNP", AOType: "W", RangeCode: "100", AOCode: "1" },
      "Ghaziabad": { AreaCode: "KNP", AOType: "W", RangeCode: "17", AOCode: "1" },
      "Ghazipur": { AreaCode: "LKN", AOType: "W", RangeCode: "23", AOCode: "96" },
      "Gonda": { AreaCode: "LKN", AOType: "W", RangeCode: "61", AOCode: "96" },
      "Gorakhpur": { AreaCode: "LKN", AOType: "W", RangeCode: "26", AOCode: "1" },
      "Hamirpur": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "Hapur": { AreaCode: "KNP", AOType: "W", RangeCode: "17", AOCode: "96" },
      "Hardoi": { AreaCode: "LKN", AOType: "W", RangeCode: "43", AOCode: "4" },
      "Hathras": { AreaCode: "KNP", AOType: "W", RangeCode: "75", AOCode: "95" },
      "Jalaun": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "Jaunpur": { AreaCode: "LKN", AOType: "W", RangeCode: "61", AOCode: "4" },
      "Jhansi": { AreaCode: "KNP", AOType: "W", RangeCode: "80", AOCode: "94" },
      "Kannauj": { AreaCode: "KNP", AOType: "W", RangeCode: "85", AOCode: "93" },
      "Kanpur": { AreaCode: "KNP", AOType: "W", RangeCode: "51", AOCode: "1" },
      "Kaushambhi": { AreaCode: "LKN", AOType: "W", RangeCode: "20", AOCode: "91" },
      "Kushinagar": { AreaCode: "LKN", AOType: "W", RangeCode: "26", AOCode: "91" },
      "Kasganj": { AreaCode: "KNP", AOType: "W", RangeCode: "75", AOCode: "94" },
      "Khatauli": { AreaCode: "KNP", AOType: "W", RangeCode: "23", AOCode: "94" },
      "Lakhimpur": { AreaCode: "LKN", AOType: "W", RangeCode: "43", AOCode: "2" },
      "Lalitpur": { AreaCode: "KNP", AOType: "W", RangeCode: "80", AOCode: "95" },
      "Lucknow": { AreaCode: "LKN", AOType: "W", RangeCode: "91", AOCode: "1" },
      "Maharajganj": { AreaCode: "LKN", AOType: "W", RangeCode: "26", AOCode: "4" },
      "Mahoba": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "Mainpuri": { AreaCode: "KNP", AOType: "W", RangeCode: "85", AOCode: "94" },
      "Mathura": { AreaCode: "KNP", AOType: "W", RangeCode: "75", AOCode: "91" },
      "Meerut": { AreaCode: "KNP", AOType: "W", RangeCode: "14", AOCode: "1" },
      "Mau": { AreaCode: "LKN", AOType: "W", RangeCode: "26", AOCode: "93" },
      "Mirzapur": { AreaCode: "LKN", AOType: "W", RangeCode: "23", AOCode: "94" },
      "Moradabad": { AreaCode: "LKN", AOType: "W", RangeCode: "71", AOCode: "1" },
      "Muzaffarnagar": { AreaCode: "KNP", AOType: "W", RangeCode: "23", AOCode: "2" },
      "Nazibad": { AreaCode: "LKN", AOType: "W", RangeCode: "71", AOCode: "95" },
      "Noida": { AreaCode: "KNP", AOType: "W", RangeCode: "100", AOCode: "7" },
      "Orai": { AreaCode: "KNP", AOType: "W", RangeCode: "54", AOCode: "5" },
      "Pilibhit": { AreaCode: "LKN", AOType: "W", RangeCode: "41", AOCode: "92" },
      "Pratapgarh": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "Rae Bareli": { AreaCode: "LKN", AOType: "W", RangeCode: "61", AOCode: "94" },
      "Rampur": { AreaCode: "LKN", AOType: "W", RangeCode: "71", AOCode: "4" },
      "Saharanpur": { AreaCode: "KNP", AOType: "W", RangeCode: "23", AOCode: "95" },
      "Sant Kabir Nagar": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "Shahjahanpur": { AreaCode: "LKN", AOType: "W", RangeCode: "41", AOCode: "13" },
      "Shrawasti": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "Sidharth Nagar": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "Sitapur": { AreaCode: "LKN", AOType: "W", RangeCode: "43", AOCode: "1" },
      "Sonbhadra": { AreaCode: "LKN", AOType: "W", RangeCode: "23", AOCode: "95" },
      "Sultanpur": { AreaCode: "LKN", AOType: "W", RangeCode: "61", AOCode: "91" },
      "Unnao": { AreaCode: "LKN", AOType: "W", RangeCode: "91", AOCode: "92" },
      "Varanasi": { AreaCode: "LKN", AOType: "W", RangeCode: "23", AOCode: "1" }
    },
    "Uttrakhand": {
      "Almora": { AreaCode: "LKN", AOType: "W", RangeCode: "90", AOCode: "97" },
      "Bageshwar": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "Bajpur": { AreaCode: "LKN", AOType: "W", RangeCode: "90", AOCode: "94" },
      "Chamoli": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "Champawat": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "Dehradun": { AreaCode: "KNP", AOType: "W", RangeCode: "26", AOCode: "1" },
      "Haridwar": { AreaCode: "KNP", AOType: "W", RangeCode: "26", AOCode: "96" },
      "Nainital": { AreaCode: "LKN", AOType: "W", RangeCode: "90", AOCode: "96" },
      "Pauri Garhwal": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "Pithoragarh": { AreaCode: "LKN", AOType: "W", RangeCode: "90", AOCode: "98" },
      "Rudraprayag": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "Their": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "Udham Singh Nagar": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "Uttarkashi": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "Haldwani": { AreaCode: "LKN", AOType: "W", RangeCode: "90", AOCode: "91" },
      "Kashipur": { AreaCode: "LKN", AOType: "W", RangeCode: "90", AOCode: "93" },
      "Khatima": { AreaCode: "LKN", AOType: "W", RangeCode: "90", AOCode: "99" },
      "Kotdwar": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "Sirnagar": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "Ram Nagar": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "Rishikesh": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" },
      "Roorkee": { AreaCode: "", AOType: "", RangeCode: "", AOCode: "" }
    },
    "West Bengal": {
      "Alipurdaur": { AreaCode: "WBG", AOType: "W", RangeCode: "212", AOCode: "92" },
      "Asansol": { AreaCode: "WBG", AOType: "W", RangeCode: "196", AOCode: "1" },
      "Balurghat": { AreaCode: "WBG", AOType: "W", RangeCode: "208", AOCode: "94" },
      "Bankura": { AreaCode: "WBG", AOType: "W", RangeCode: "201", AOCode: "92" },
      "Birbhum": { AreaCode: "WBG", AOType: "W", RangeCode: "201", AOCode: "1" },
      "Cooch Behar": { AreaCode: "WBG", AOType: "W", RangeCode: "212", AOCode: "91" },
      "Dikshan Dinajpur": { AreaCode: "WBG", AOType: "W", RangeCode: "", AOCode: "" },
      "Darjeeling": { AreaCode: "WBG", AOType: "W", RangeCode: "208", AOCode: "93" },
      "Hooghly": { AreaCode: "WBG", AOType: "W", RangeCode: "181", AOCode: "1" },
      "Howrah": { AreaCode: "WBG", AOType: "", RangeCode: "", AOCode: "" },
      "Durgapur": { AreaCode: "WBG", AOType: "W", RangeCode: "190", AOCode: "1" },
      "Haldia": { AreaCode: "WBG", AOType: "W", RangeCode: "176", AOCode: "1" },
      "Jalpaiguri": { AreaCode: "WBG", AOType: "W", RangeCode: "212", AOCode: "1" },
      "Jhargram": { AreaCode: "WBG", AOType: "W", RangeCode: "", AOCode: "" },
      "Kalimpong": { AreaCode: "WBG", AOType: "W", RangeCode: "208", AOCode: "95" },
      "Kolkata": { AreaCode: "WBG", AOType: "W", RangeCode: "101", AOCode: "1" },
      "Malda": { AreaCode: "WBG", AOType: "W", RangeCode: "208", AOCode: "92" },
      "Murshidabad": { AreaCode: "WBG", AOType: "W", RangeCode: "156", AOCode: "93" },
      "Midnapur": { AreaCode: "WBG", AOType: "W", RangeCode: "139", AOCode: "91" },
      "Nadia": { AreaCode: "WBG", AOType: "W", RangeCode: "156", AOCode: "91" },
      "Raiganj": { AreaCode: "WBG", AOType: "W", RangeCode: "212", AOCode: "93" },
      "Siliguri": { AreaCode: "WBG", AOType: "W", RangeCode: "207", AOCode: "1" },
      "Suri": { AreaCode: "WBG", AOType: "W", RangeCode: "201", AOCode: "93" },
      "Purulia": { AreaCode: "WBG", AOType: "W", RangeCode: "193", AOCode: "93" },
      "North 24 Parganas": { AreaCode: "WBG", AOType: "W", RangeCode: "", AOCode: "" },
      "Paschim Bardhaman": { AreaCode: "WBG", AOType: "W", RangeCode: "", AOCode: "" },
      "Paschim Medinipur": { AreaCode: "WBG", AOType: "W", RangeCode: "", AOCode: "" },
      "Purba Bardhaman": { AreaCode: "WBG", AOType: "W", RangeCode: "", AOCode: "" },
      "Purba Medinipur": { AreaCode: "WBG", AOType: "W", RangeCode: "", AOCode: "" },
      "South 24 Parganas": { AreaCode: "WBG", AOType: "W", RangeCode: "", AOCode: "" },
      "Uttar Dinajpur": { AreaCode: "WBG", AOType: "W", RangeCode: "", AOCode: "" }
    },
    "Ladakh": {
      "Ladakh": { AreaCode: "NWR", AOType: "W", RangeCode: "88", AOCode: "1" }
    },
    "Lakshwadeep": {
      "Lakshwadeep": { AreaCode: "KRL", AOType: "W", RangeCode: "10", AOCode: "1" }
    }

  };

  const formatDateToString = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = d.getFullYear();
    return `${day}/${month}/${year}`; // Format: dd/MM/yyyy
  };

  const handleCheckboxChange = (event) => {
    const { name } = event.target;
    const section = event.target.closest(".applicant-section")
      ? "ApplicantCheckedOption"
      : "RepresentativeCheckedOption";

    setFormData((prevFormData) => ({
      ...prevFormData,
      [section]: name,
    }));
  };


  const [errors, setErrors] = useState({
    Aadhar_EID: "",
    AadharName: ""
  });
  const aadharRegex = /^[2-9]{1}[0-9]{11}$/;

  // Register the optional Great Vibes font with jsPDF (requires base64 in src/fonts/GreatVibes.js)
  const registerGreatVibes = (doc) => {
    const fontString = (greatVibes || "").trim();
    if (!fontString || fontString.includes("PASTE_YOUR_BASE64_STRING_HERE")) {
      return false; // Skip when no base64 is provided
    }

    doc.addFileToVFS("GreatVibes-Regular.ttf", fontString);
    doc.addFont("GreatVibes-Regular.ttf", "GreatVibes", "normal");
    return true;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    // let newValue = value;

    // Pincode limit to 6 digits
    if (name === "ResidentPinCode" || name === "OfficePinCode" || name === "RepresentativePinCode") {
      const digitsOnly = value.replace(/\D/g, "");
      if (digitsOnly.length > 6) return; // block after 6 digits
      setFormData({ ...formData, [name]: digitsOnly });
      return;
    }

    // DOB age check (<18 hides RA fields)
    if (name === "Dob") {
      const selectedDate = new Date(value);
      const today = new Date();
      let age = today.getFullYear() - selectedDate.getFullYear();
      const m = today.getMonth() - selectedDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < selectedDate.getDate())) {
        age--;
      }
      if (age < 18) {
        setHideRA(false);
        setFormData({ ...formData, Dob: value }); // Minor: Show RA, keep data
      } else {
        setHideRA(true); // Adult: Hide RA, clear RA fields
        setFormData(prev => ({
          ...prev,
          Dob: value,
          RepresentativeCheckedOption: "",
          RepresentativeLastName: "",
          RepresentativeFirstName: "",
          RepresentativeMiddleName: "",
          RepresentativeRoom: "",
          RepresentativePremises: "",
          RepresentativeStreet: "",
          RepresentativeArea: "",
          RepresentativeCity: "",
          RepresentativeState: "",
          RepresentativePinCode: ""
        }));
      }
      return;
    }



    // Aadhaar: digits only, max 12, validate
    if (name === "Aadhar_EID") {
      const digitsOnly = value.replace(/\D/g, '');
      if (digitsOnly.length > 12) return;

      setFormData({ ...formData, [name]: digitsOnly });

      // Aadhaar validation (if regex is defined)
      if (digitsOnly.length === 12 && !aadharRegex.test(digitsOnly)) {
        setErrors((prev) => ({
          ...prev,
          Aadhar_EID: "Invalid Aadhaar number. Must be 12 digits and start from 2–9.",
        }));
      } else {
        setErrors((prev) => ({ ...prev, Aadhar_EID: "" }));
      }
      return;
    }

    if (name === "AadharName") {
      const words = value.split(" ").filter((w) => w.trim() !== "");

      if (words.length !== 3) {
        setErrors((prev) => ({ ...prev, AadharName: "Name as per Aadhar must have exactly 3 words." }));
      } else {
        setErrors((prev) => ({ ...prev, AadharName: "" }));
      }

      setFormData((prev) => ({
        ...prev,
        [name]: value,
        FirstName: words[0] || "",
        MiddleName: words[1] || "",
        LastName: words[2] || "",
      }));
      return;
    }

    //setFormData({ ...formData, [name]: newValue });
    setFormData({ ...formData, [name]: value });
  };

  // const handleStateDistrictChange = (e) => {
  //   const { name, value } = e.target;
  //   const updatedFormData = { ...formData, [name]: value };

  //   if (name === "state" || name === "district") {
  //     const { state, district } = updatedFormData;
  //     if (state && district && aoCodeData[state] && aoCodeData[state][district]) {
  //       const { AreaCode, AOType, RangeCode, AOCode } = aoCodeData[state][district];
  //       updatedFormData.AreaCode = AreaCode;
  //       updatedFormData.AoType = AOType;
  //       updatedFormData.RangeCode = RangeCode;
  //       updatedFormData.AONo = AOCode;
  //     } else {
  //       updatedFormData.AreaCode = "";
  //       updatedFormData.AoType = "";
  //       updatedFormData.RangeCode = "";
  //       updatedFormData.AONo = "";
  //     }
  //   }

  //   setFormData(updatedFormData);
  // };

  const handleStateDistrictChange = (e) => {
    const { name, value } = e.target;

    setFormData(prev => {
      const updated = { ...prev, [name]: value };

      // When state changes → reset district only
      if (name === "state") {
        updated.district = "";
        return updated;
      }

      // When district changes → auto-fill IF data exists
      if (name === "district") {
        const ao =
          aoCodeData?.[updated.state]?.[updated.district] ?? {};

        updated.AreaCode = ao.AreaCode || prev.AreaCode || "";
        updated.AOType = ao.AOType || prev.AOType || "";
        updated.RangeCode = ao.RangeCode || prev.RangeCode || "";
        updated.AOCode = ao.AOCode || prev.AOCode || "";
      }

      return updated;
    });
  };




  const handleFileChange = (e) => {
    const { name, files } = e.target;
    const file = files[0];

    // Log the selected file
    console.log(`Selected file for ${name}:`, file);

    // Validation based on input name
    if (file) {
      const fileType = file.type;

      // PDF validation
      if (name === "pdfDocument" && fileType !== "application/pdf") {
        alert("Only PDF files are allowed.");
        e.target.value = ""; // Clear input
        return;
      }

      // Image validation for photo and signature
      if ((name === "photo" || name === "signature") &&
        !(fileType === "image/jpeg" || fileType === "image/png")) {
        alert("Only JPG and PNG files are allowed.");
        e.target.value = ""; // Clear input
        return;
      }
    }

    // If valid, update state
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: file,
    }));
  };


  useEffect(() => {
    const fetchNewPanData = async () => {
      if (newPanId) {
        try {
          const authToken = localStorage.getItem("authToken");
          const response = await fetch(`${API_BASE_URL}/NewPanApplication/GetNewPanById/${newPanId}`, {
            headers: { Authorization: `Bearer ${authToken}` },
          });
          if (!response.ok) throw new Error("Failed to fetch data");
          const data = await response.json();

          // Map API data to formData
          setFormData((prev) => ({
            ...prev,
            AreaCode: data.areaCode || "",
            AOType: data.aoType || "",
            RangeCode: data.rangeCode || "",
            AOCode: data.aoCode || "",
            state: data.state || "",
            district: data.district || "",
            category: data.applicantType || "",
            ApplicantCheckedOption: data.applicantCheckedOption || "",
            LastName: data.lastName || "",
            FirstName: data.firstName || "",
            MiddleName: data.middleName || "",
            NewPanName: data.newPanName || "",
            FatherLastName: data.fatherLastName || "",
            FatherFirstName: data.fatherFirstName || "",
            FatherMiddleName: data.fatherMiddleName || "",
            MotherLastName: data.motherLastName || "",
            MotherFirstName: data.motherFirstName || "",
            MotherMiddleName: data.motherMiddleName || "",
            Dob: data.date ? data.date.split("T")[0] : "", // Convert ISO string to YYYY-MM-DD
            ISDCode: data.isdCode || "",
            STDCode: data.stdCode || "",
            MobileNo: data.mobileNo || "",
            EmailId: data.emailId || "",
            AadharName: data.aadharName || "",
            PanDispatchState: data.panDispatchState || "",
            Aadhar_EID: data.aadhar_EID || "",
            RAAddress: data.raAddress || "",
            IdentityProof: data.identityProof || "",
            AddressProof: data.addressProof || "",
            DobProof: data.dobProof || "",
            ResidentRoom: data.residentRoom || "",
            ResidentPremises: data.residentPremises || "",
            ResidentStreet: data.residentStreet || "",
            ResidentArea: data.residentArea || "",
            ResidentCity: data.residentCity || "",
            ResidentState: data.residentState || "",
            ResidentPinCode: data.residentPinCode || "",
            OfficeName: data.officeName || "",
            OfficeRoom: data.officeRoom || "",
            OfficePremises: data.officePremises || "",
            OfficeStreet: data.officeStreet || "",
            OfficeArea: data.officeArea || "",
            OfficeCity: data.officeCity || "",
            OfficeState: data.officeState || "",
            OfficePinCode: data.officePinCode || "",
            RepresentativeCheckedOption: data.representativeCheckedOption || "",
            RepresentativeLastName: data.representativeLastName || "",
            RepresentativeFirstName: data.representativeFirstName || "",
            RepresentativeMiddleName: data.representativeMiddleName || "",
            RepresentativeRoom: data.representativeRoom || "",
            RepresentativePremises: data.representativePremises || "",
            RepresentativeStreet: data.representativeStreet || "",
            RepresentativeArea: data.representativeArea || "",
            RepresentativeCity: data.representativeCity || "",
            RepresentativeState: data.representativeState || "",
            RepresentativePinCode: data.representativePinCode || "",
          }));

          // Handle RA fields visibility
          if (data.date) {
            const birthDate = new Date(data.date);
            const age = new Date().getFullYear() - birthDate.getFullYear();
            setHideRA(age >= 18);
          }
        } catch (error) {
          console.error("Error fetching record:", error);
          alert("Could not load record for editing.");
        }
      }
    };
    fetchNewPanData();
  }, [newPanId]);


  const [disableNames, setDisableNames] = useState(false);
  const handleCategoryChange = (e) => {
    const selectedOption = e.target.value;
    setFormData((prev) => ({ ...prev, category: selectedOption }));

    const disableOptions = [
      "Trust",
      "Hindu Undivided Family",
      "Partnership Firm",
      "Association Of Person",
      "Body Of Individuals Individuals",
    ];
    setDisableNames(disableOptions.includes(selectedOption));
  };


  const handleSubmitNewPan = async (event) => {
    event.preventDefault();

    const photoFile = formData.photo;
    const signatureFile = formData.signature;
    let backendSubmissionDate = "";

    const proceed = window.confirm("Do you want to submit? \n Press OK to confirm or Cancel to stay on page.");
    if (!proceed) return;

    try {
      // ✅ Step 1: Submit Main Application Data
      const applicationFormData = new FormData();
      applicationFormData.append("AreaCode", formData.AreaCode);
      applicationFormData.append("AOType", formData.AOType);
      applicationFormData.append("RangeCode", formData.RangeCode);
      applicationFormData.append("AOCode", formData.AOCode);
      applicationFormData.append("State", formData.state);
      applicationFormData.append("District", formData.district);
      applicationFormData.append("ApplicantType", formData.category);
      applicationFormData.append("ApplicantCheckedOption", formData.ApplicantCheckedOption);
      applicationFormData.append("LastName", formData.LastName);
      applicationFormData.append("FirstName", formData.FirstName);
      applicationFormData.append("MiddleName", formData.MiddleName);
      applicationFormData.append("NewPanName", formData.NewPanName);
      applicationFormData.append("FatherLastName", formData.FatherLastName);
      applicationFormData.append("FatherFirstName", formData.FatherFirstName);
      applicationFormData.append("FatherMiddleName", formData.FatherMiddleName);
      applicationFormData.append("MotherLastName", formData.MotherLastName);
      applicationFormData.append("MotherFirstName", formData.MotherFirstName);
      applicationFormData.append("MotherMiddleName", formData.MotherMiddleName);
      applicationFormData.append("Date", formatDateToString(formData.Dob));
      applicationFormData.append("ISDCode", formData.ISDCode);
      applicationFormData.append("STDCode", formData.STDCode);
      applicationFormData.append("MobileNo", formData.MobileNo);
      applicationFormData.append("EmailId", formData.EmailId);
      applicationFormData.append("AadharName", formData.AadharName);
      applicationFormData.append("PanDispatchState", formData.PanDispatchState);
      applicationFormData.append("Aadhar_EID", formData.Aadhar_EID);
      applicationFormData.append("RAAddress", formData.RAAddress);
      applicationFormData.append("IdentityProof", "AadhaarCard");
      applicationFormData.append("AddressProof", "AadhaarCard");
      applicationFormData.append("DobProof", "AadhaarCard");
      applicationFormData.append("ResidentRoom", formData.ResidentRoom);
      applicationFormData.append("ResidentPremises", formData.ResidentPremises);
      applicationFormData.append("ResidentStreet", formData.ResidentStreet);
      applicationFormData.append("ResidentArea", formData.ResidentArea);
      applicationFormData.append("ResidentCity", formData.ResidentCity);
      applicationFormData.append("ResidentState", formData.ResidentState);
      applicationFormData.append("ResidentPinCode", formData.ResidentPinCode);
      applicationFormData.append("RepresentativeCheckedOption", formData.RepresentativeCheckedOption);
      applicationFormData.append("RepresentativeLastName", formData.RepresentativeLastName);
      applicationFormData.append("RepresentativeFirstName", formData.RepresentativeFirstName);
      applicationFormData.append("RepresentativeMiddleName", formData.RepresentativeMiddleName);
      applicationFormData.append("RepresentativeRoom", formData.RepresentativeRoom);
      applicationFormData.append("RepresentativePremises", formData.RepresentativePremises);
      applicationFormData.append("RepresentativeStreet", formData.RepresentativeStreet);
      applicationFormData.append("RepresentativeArea", formData.RepresentativeArea);
      applicationFormData.append("RepresentativeCity", formData.RepresentativeCity);
      applicationFormData.append("RepresentativeState", formData.RepresentativeState);
      applicationFormData.append("RepresentativePinCode", formData.RepresentativePinCode);
      applicationFormData.append("OfficeName", formData.OfficeName);
      applicationFormData.append("OfficeRoom", formData.OfficeRoom);
      applicationFormData.append("OfficePremises", formData.OfficePremises);
      applicationFormData.append("OfficeStreet", formData.OfficeStreet);
      applicationFormData.append("OfficeArea", formData.OfficeArea);
      applicationFormData.append("OfficeCity", formData.OfficeCity);
      applicationFormData.append("OfficeState", formData.OfficeState);
      applicationFormData.append("OfficePinCode", formData.OfficePinCode);
      applicationFormData.append("PdfDocument", formData.pdfDocument);
      applicationFormData.append("Photo", formData.photo);
      applicationFormData.append("Signature", formData.signature);

      const authToken = localStorage.getItem("authToken");

      console.log("Submitting FormData to API...");
      // ✅ Debugging - Log all FormData entries
      for (let pair of applicationFormData.entries()) {
        console.log(pair[0], pair[1], pair[1] instanceof File ? pair[1].name : "");
      }

      const url = newPanId
        ? `${API_BASE_URL}/NewPanApplication/Update/${newPanId}`
        : `${API_BASE_URL}/NewPanApplication/NewPanApplication`;
      const method = newPanId ? "PUT" : "POST";

      const response = await fetch(url, {
        method: method,
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
        body: applicationFormData
      });

      const result = await response.json();
      backendSubmissionDate = result.submissionDate || "";

      // STORE BACKEND DATE
      setSubmissionDate(result.submissionDate);

      if (!response.ok) {
        // Show the actual message returned by the API
        const errorMessage = result.message || result.Message || "Failed to submit application data.";
        alert(errorMessage);
        return; // Stop further execution
        //throw new Error(errorMessage); // Optional, in case you want to log it as well
      }


      console.log("Application Submitted:", result);
      // Trigger balance update
      window.dispatchEvent(new Event("balanceUpdated"));
      setFormData({
        AreaCode: "",
        AoType: "",
        RangeCode: "",
        AONo: "",
        state: "",
        district: "",
        category: "",
        ApplicantCheckedOption: "",
        LastName: "",
        FirstName: "",
        MiddleName: "",
        NewPanName: "",
        FatherLastName: "",
        FatherFirstName: "",
        FatherMiddleName: "",
        MotherLastName: "",
        MotherFirstName: "",
        MotherMiddleName: "",
        Dob: "",
        ISDCode: "",
        STDCode: "",
        MobileNo: "",
        EmailId: "",
        AadharName: "",
        PanDispatchState: "",
        Aadhar_EID: "",
        RAAddress: "",
        IdentityProof: "",
        AddressProof: "",
        DobProof: "",
        ResidentRoom: "",
        ResidentPremises: "",
        ResidentStreet: "",
        ResidentArea: "",
        ResidentCity: "",
        ResidentState: "",
        ResidentPinCode: "",
        OfficeName: "",
        OfficeRoom: "",
        OfficePremises: "",
        OfficeStreet: "",
        OfficeArea: "",
        OfficeCity: "",
        OfficeState: "",
        OfficePinCode: "",
        RepresentativeCheckedOption: "",
        RepresentativeLastName: "",
        RepresentativeFirstName: "",
        RepresentativeMiddleName: "",
        RepresentativeRoom: "",
        RepresentativePremises: "",
        RepresentativeStreet: "",
        RepresentativeArea: "",
        RepresentativeCity: "",
        RepresentativeState: "",
        RepresentativePinCode: "",
        pdfDocument: null,  // File
        photo: null,        // File
        signature: null,    // File

      });

      // Reset actual file inputs
      if (pdfDocumentRef.current) pdfDocumentRef.current.value = "";
      if (photoRef.current) photoRef.current.value = "";
      if (signatureRef.current) signatureRef.current.value = "";

      alert(newPanId ? "Application updated successfully!" : "Form submitted successfully!");
      if (newPanId) {
        localStorage.removeItem("newPanId");
        setNewPanId(null);
      }
      //window.location.href = "/dashboard";

    } catch (error) {
      console.error("While submitting form something went wrong. Please try again.");
      if (typeof error.message === "string") {
        alert(error.message);
      } else {
        alert("An unexpected error occurred. Please try again.");
      }
    }


    //for pdf
    const doc = new jsPDF();

    // Convert images to base64
    let photoBase64 = null;
    let signatureBase64 = null;

    if (photoFile) {
      photoBase64 = await readFileAsBase64(photoFile);
    }
    if (signatureFile) {
      signatureBase64 = await readFileAsBase64(signatureFile);
    }

    const hasGreatVibes = registerGreatVibes(doc);

    // Draw a border around the entire PDF
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;


    // Function to draw border on the current page
    const drawBorder = () => {

      doc.setDrawColor(0, 0, 0); // Set border color to black
      doc.rect(5, 5, pageWidth - 10, pageHeight - 10); // Draw border with a 5px margin
    };

    // Title
    drawBorder();
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    const title = "Form No. 49A";
    const titleWidth = doc.getTextWidth(title);
    const centerX = (pageWidth - titleWidth) / 2;
    doc.text(title, centerX, 10);

    // Adjusted Y position for boxes (move them up slightly)
    const boxYnn = 6; // New Y position for both image boxes

    // Left Image Box
    doc.rect(10, boxYnn, 30, 35); // Adjusted Left image box (moved slightly up)
    if (photoBase64) {
      doc.addImage(photoBase64, "JPEG", 10, boxYnn, 30, 35);
    }

    // Right Image Box
    doc.rect(pageWidth - 40, boxYnn, 30, 35); // Right image box
    if (photoBase64) {
      doc.addImage(photoBase64, "JPEG", pageWidth - 40, boxYnn, 30, 35);
    }

    // Text inside Left Image Placeholder
    doc.setFontSize(6); // Set font size for better readability
    const placeholderText = [
      "Only ‘Individuals’ to affix",
      "recent photograph",
      "(3.5 cm × 2.5 cm)"
    ];

    let textY = boxYnn + 10; // Adjusted starting Y position for text inside the left box (move up slightly)
    if (!photoBase64) {
      placeholderText.forEach((line) => {
        const textWidth = doc.getTextWidth(line);
        const textX = 10 + (30 - textWidth) / 2; // Center text in the 30px wide box
        doc.text(line, textX, textY);
        textY += 3; // Increment Y position for the next line
      });
    }

    doc.setFontSize(5); // Set font size for better readability
    const placeholderText2 = [
      "Signature/Left thumb",
      "impression across this photo"
    ];

    // Position of the horizontal line
    const horizontalLineY = boxYnn + 28;  // Adjusted Y position for the horizontal line (move up slightly)
    const horizontalLineStartX = 10;  // Starting X position for the line (left side of the box)
    const horizontalLineEndX = 40;   // Ending X position for the line (right side of the box)

    let textYn = boxYnn + 31; // Adjusted starting Y position for text inside the box (move up slightly)
    if (!photoBase64) {
      // Draw the horizontal line above the text
      doc.line(horizontalLineStartX, horizontalLineY, horizontalLineEndX, horizontalLineY); // Draw the line

      placeholderText2.forEach((line) => {
        const textWidth = doc.getTextWidth(line);
        const textX = 10 + (30 - textWidth) / 2; // Center text in the 30px wide box
        doc.text(line, textX, textYn);
        textYn += 3; // Increment Y position for the next line
      });
    } else {
      textYn += placeholderText2.length * 3;
    }

    // Repeat for Right Image Placeholder
    textY = boxYnn + 15; // Reset adjusted Y position for right box
    if (!photoBase64) {
      placeholderText.forEach((line) => {
        const textWidth = doc.getTextWidth(line);
        const textX = pageWidth - 40 + (30 - textWidth) / 2; // Center text in the 30px wide box
        doc.text(line, textX, textY);
        textY += 3; // Increment Y position for the next line
      });
    }

    doc.setFontSize(8);
    const panText = `Application for Allotment of Permanent Account Number
    (In the case of Indian Citizens/Indian Companies/Entities incorporated in India/
    Unincorporated entities formed in India)`;
    // Center the text on the page
    doc.text(panText, pageWidth / 2, 13, { align: 'center' });

    doc.setFontSize(8);
    const panText2 = `See Rule 114`;
    const panTextWidth2 = doc.getTextWidth(panText2);
    const panCenterX2 = (pageWidth - panTextWidth2) / 2; // Center the text
    doc.text(panText2, panCenterX2, 23);


    // Instructions with centered text
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(6);
    const instructionsText = "To avoid mistake (s), please follow the accompanying instructions and examples before filling up the form";
    const instructionsWidth = doc.getTextWidth(instructionsText);
    const instructionsCenterX = (pageWidth - instructionsWidth) / 2; // Center the text horizontally
    doc.text(instructionsText, instructionsCenterX, 25);

    doc.setFont('helvetica', 'Bold');
    doc.setFontSize(8);
    // Define the text and position
    const aoText = "Assessing officer (AO code)";
    const textX = 41;  // X-coordinate for the text position
    const textRightX = textX + 5;
    const textHeadingY = 27;  // Y-coordinate for the text position
    const textHeightY = textHeadingY + 2;

    // Set the background color for the text (e.g., light gray)
    doc.setFillColor(230, 230, 230);  // RGB color for light gray background

    // Draw a rectangle to serve as the background (with some padding)
    const padding = 1; // Padding around the text
    const textWidthBg = 129;  // Get the width of the text
    const rectHeight = 4;  // Height of the rectangle (adjust as needed)
    doc.rect(textX - padding, textHeadingY - padding, textWidthBg + padding * 1, rectHeight + padding * 1, 'F'); // 'F' for fill

    // Set the text color (optional, if you want a specific text color)
    doc.setTextColor(0, 0, 0);  // Black text color (RGB format)
    // Add the text on top of the background rectangle
    doc.text(aoText, textRightX, textHeightY);

    doc.setFont('helvetica', 'Bold');
    doc.setFontSize(8);

    // Define positions and sizes
    const startX = 45; // Starting X position
    const startY = 32; // Starting Y position
    const headingBoxWidth = 25; // Width of each heading box
    const defaultBoxWidth = 8; // Default small box width (used for 3-box items)
    const boxHeightAO = 5; // Height of each box

    // Define headings and how many boxes each needs below
    const headings = [
      { label: "Area Code", boxCount: 3, fillFullWidth: false },
      { label: "AO Type", boxCount: 2, fillFullWidth: true },
      { label: "Range Code", boxCount: 3, fillFullWidth: false },
      { label: "AO Code", boxCount: 2, fillFullWidth: true }
    ];

    // Draw heading boxes with centered text
    headings.forEach((item, index) => {
      const boxX = startX + index * headingBoxWidth;
      doc.setTextColor(0, 0, 0);
      doc.rect(boxX, startY, headingBoxWidth, boxHeightAO); // Heading box

      const textWidth = doc.getTextWidth(item.label);
      const textX = boxX + (headingBoxWidth - textWidth) / 2;
      const textY = startY + boxHeightAO / 2 + 1.5;
      doc.text(item.label, textX, textY);
    });

    // Draw small boxes under each heading
    const secondRowY = startY + boxHeightAO;
    headings.forEach((item, index) => {
      const boxX = startX + index * headingBoxWidth;

      // Determine width and spacing for boxes
      let boxWidth = defaultBoxWidth;
      let spacing = 0;
      let startXBox = boxX;

      if (item.fillFullWidth) {
        // Stretch boxes to fill entire heading box
        boxWidth = headingBoxWidth / item.boxCount;
        spacing = 0;
      } else {
        // Use default width with spacing
        const totalWidth = item.boxCount * boxWidth;
        spacing = (headingBoxWidth - totalWidth) / (item.boxCount + 1);
        startXBox += spacing;
      }

      // Draw boxes
      for (let i = 0; i < item.boxCount; i++) {
        const currentX = item.fillFullWidth
          ? boxX + i * boxWidth
          : startXBox + i * (boxWidth + spacing);
        doc.rect(currentX, secondRowY, boxWidth, boxHeightAO);
      }
    });

    const aoValues = {
      "Area Code": (formData.AreaCode || "").toString().padEnd(3, " ").substring(0, 3),
      "AO Type": (formData.AOType || "").toString().padEnd(2, " ").substring(0, 2),
      "Range Code": (formData.RangeCode || "").toString().padEnd(3, " ").substring(0, 3),
      "AO Code": (formData.AOCode || "").toString().padEnd(2, " ").substring(0, 2)
    };

    // ✅ Fill characters into boxes
    headings.forEach((item, index) => {
      const boxX = startX + index * headingBoxWidth;
      const boxY = secondRowY;

      // const value = aoValues[item.label];
      // const chars = value.split("");

      const value = aoValues[item.label] ?? "";
      const chars = String(value).split("");


      let boxWidth = defaultBoxWidth;
      let spacing = 0;
      let startXBox = boxX;

      if (item.fillFullWidth) {
        boxWidth = headingBoxWidth / item.boxCount;
      } else {
        const totalWidth = item.boxCount * boxWidth;
        spacing = (headingBoxWidth - totalWidth) / (item.boxCount + 1);
        startXBox += spacing;
      }

      chars.forEach((ch, i) => {
        if (i >= item.boxCount) return;
        const currentX = item.fillFullWidth
          ? boxX + i * boxWidth
          : startXBox + i * (boxWidth + spacing);

        // Center the text inside each box
        const textX = currentX + boxWidth / 2 - doc.getTextWidth(ch) / 2;
        const textY = boxY + boxHeightAO / 2 + 1.5;
        doc.setFont("KidsAvenue", "normal");
        doc.text(ch, textX, textY);
        doc.setFont("helvetica", "normal");
      });
    });

    // Box properties
    const boxWidth = 50;  // Width of the box
    const boxHeight = 15; // Height of the box
    const boxX = pageWidth - 100 + (130 - boxWidth) / 2; // Center the box horizontally
    const boxY = textYn + 1; // Position the box below the previous content

    // Draw the box at calculated position
    doc.rect(boxX, 41, boxWidth, boxHeight);
    if (signatureBase64) {
      doc.addImage(signatureBase64, "JPEG", boxX, 41, boxWidth, boxHeight);
    }

    // Text properties
    const signatureText = "Signature / Left Thumb Impression";
    doc.setFontSize(6); // Set font size for the text

    // Calculate text dimensions
    const textWidth = doc.getTextWidth(signatureText); // Get the width of the text
    const textHeight = 2.5; // Approximate height (5% of font size is standard)

    // Adjust text position for bottom alignment within the box
    const textXright = boxX + (boxWidth - textWidth) / 2; // Center horizontally
    const textYright = boxY + boxHeight - textHeight - 2; // Position near the bottom (2 units padding)

    if (!signatureBase64) {
      // Draw the text inside the box
      doc.text(signatureText, textXright, textYright);
    }

    // Add the new lines of text below the boxes
    const textStartY = 37 + boxHeightAO + 5; // Position below the second row of boxes

    // "Sir,"
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8); // Adjust font size as needed
    doc.text("Sir,", 10, textStartY);

    // "I/We hereby request that a permanent account number be allotted to me/us."
    const nextTextY = textStartY + 4; // Position for the next line
    doc.text("I/We hereby request that a permanent account number be allotted to me/us.", 10, nextTextY);

    // "I/We give below necessary particulars"
    const finalTextY = nextTextY + 4; // Position for the final line
    doc.text("I/We give below necessary particulars", 10, finalTextY);


    // Applicant Details Section
    doc.setFont("helvetica", "bold");
    doc.setFontSize(8);
    const text = "1. Full Name (Full expanded name to be mentioned as appearing in proof of identity/date of birth/address documents: initials are not permitted)";
    const x = 6;
    const y = 61;
    const fontSize = 7;
    const lineHeight = 0.5;
    const width = 200; // Adjust width as per your requirement
    const height = 5;

    // Set background color
    doc.setFillColor(240, 240, 240); // Light gray background (RGB)
    doc.rect(x - 1, y - fontSize * lineHeight, width, height, "F"); // "F" stands for fill
    doc.text(text, 10, y);

    // Lease Select Title Section Below Full Name
    const leaseSelectTitleX = 20; // Horizontal position of the title
    const leaseSelectTitleY = 66; // Position for the Lease Select Title (below the Full Name section)
    // Draw the "Lease Select Title"
    doc.setFontSize(8); // Set font size for the title
    doc.setFont("helvetica", "normal");
    doc.text("Please select title", 10, 66);

    // Define the starting X and Y position for checkboxes (aligned with the title)
    const checkboxStartX = leaseSelectTitleX + 15; // Starting X position for checkboxes (offset to the right of the title)
    const checkboxY = leaseSelectTitleY - 2; // Adjust Y to align with the title text

    // Size of the checkbox
    const checkboxSize = 4; // Size of the checkbox

    // Offsets for each checkbox (ensure they are placed continuously)
    const checkboxSpacing = checkboxSize + 20; // Spacing between checkboxes (includes space for labels)

    // Function to draw a right tick ✔
    const drawCheckmark = (x, y) => {
      doc.line(x, y + 2, x + 2, y + 4); // bottom line of checkmark
      doc.line(x + 2, y + 4, x + 6, y); // upward slant of checkmark
    };

    // Draw the first checkbox ("as applicable")
    doc.rect(checkboxStartX, checkboxY, checkboxSize, checkboxSize); // Draw the checkbox (empty box)
    doc.text("as applicable", checkboxStartX + checkboxSize + 1, checkboxY + 3); // Label for "as applicable"
    if (formData.ApplicantCheckedOption === "as applicable") {
      drawCheckmark(checkboxStartX, checkboxY);
    }

    // Draw the second checkbox ("Shri")
    const checkboxX2 = checkboxStartX + checkboxSpacing; // Offset X position for next checkbox
    doc.rect(checkboxX2, checkboxY, checkboxSize, checkboxSize); // Draw the checkbox (empty box)
    doc.text("Shri", checkboxX2 + checkboxSize + 1, checkboxY + 3); // Label for "Shri"
    if (formData.ApplicantCheckedOption === "Shri") {
      drawCheckmark(checkboxX2, checkboxY);
    }

    // Draw the third checkbox ("Smt")
    const checkboxX3 = checkboxX2 + checkboxSpacing; // Further offset for the next checkbox
    doc.rect(checkboxX3, checkboxY, checkboxSize, checkboxSize); // Draw the checkbox (empty box)
    doc.text("Smt", checkboxX3 + checkboxSize + 1, checkboxY + 3); // Label for "Smt"
    if (formData.ApplicantCheckedOption === "Smt") {
      drawCheckmark(checkboxX3, checkboxY);
    }

    // Draw the fourth checkbox ("Kumari")
    const checkboxX4 = checkboxX3 + checkboxSpacing; // Further offset for the next checkbox
    doc.rect(checkboxX4, checkboxY, checkboxSize, checkboxSize); // Draw the checkbox (empty box)
    doc.text("Kumari", checkboxX4 + checkboxSize + 1, checkboxY + 3); // Label for "Kumari"
    if (formData.ApplicantCheckedOption === "Kumari") {
      drawCheckmark(checkboxX4, checkboxY);
    }

    // Draw the fifth checkbox ("M/S")
    const checkboxX5 = checkboxX4 + checkboxSpacing; // Further offset for the next checkbox
    doc.rect(checkboxX5, checkboxY, checkboxSize, checkboxSize); // Draw the checkbox (empty box)
    doc.text("M/S", checkboxX5 + checkboxSize + 1, checkboxY + 3); // Label for "M/S"
    if (formData.ApplicantCheckedOption === "M/S") {
      drawCheckmark(checkboxX5, checkboxY);
    }


    // Function to draw a title and a set of aligned boxes
    function drawTitleAndAlignedBoxes(title, titleX, titleY, boxX, boxY, boxCountn, boxWidthn, boxHeightn, inputText, doc, fontSize = 10,
      fontWeight = "normal", yOffset = 0) {

      if (!doc) {
        console.error("jsPDF instance (doc) is undefined!");
        return;
      }

      // Draw the title
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8); // Set font size for the title
      doc.text(title, titleX, titleY);

      // Convert inputText to a string safely
      const letters = String(inputText || "").substring(0, boxCountn).split("");


      // Set font and font size for box content
      doc.setFont("KidsAvenue", fontWeight);
      doc.setFontSize(fontSize);

      for (let i = 0; i < boxCountn; i++) {
        const currentX = boxX + i * boxWidthn;
        doc.rect(currentX, boxY, boxWidthn, boxHeightn); // Draw box

        if (letters[i]) {
          const textX = currentX + boxWidthn / 2 - 1.5;
          const textY = boxY + boxHeightn / 2 + fontSize / 2 - 1 + yOffset;
          doc.text(letters[i], textX, textY); // Apply adjusted Y position
        }
      }
    }

    // Shared variables for box dimensions and alignment
    const boxCountn = 32; // Number of boxes
    const boxWidthn = 5; // Width of each box
    const boxHeightn = 5; // Height of each box
    const boxesStartX = 40; // Fixed starting X position for all boxes
    const titleStartX = 10; // X position for titles

    drawTitleAndAlignedBoxes(
      "Last Name / Surname",
      titleStartX,
      73,
      boxesStartX,
      70,
      boxCountn,
      boxWidthn,
      boxHeightn,
      formData.LastName.toUpperCase(),
      doc,
      8,               // 👈 smaller font size
      "normal",          // 👈 bold weight
      -2            // 👈 move text up a bit
    );

    drawTitleAndAlignedBoxes(
      "First Name",
      titleStartX,
      78,
      boxesStartX,
      75,
      boxCountn,
      boxWidthn,
      boxHeightn,
      formData.FirstName.toUpperCase(),
      doc,
      8,               // 👈 smaller font size
      "normal",          // 👈 bold weight
      -2

    );

    drawTitleAndAlignedBoxes(
      "Middle Name",
      titleStartX,
      84,
      boxesStartX,
      80,
      boxCountn,
      boxWidthn,
      boxHeightn,
      formData.MiddleName.toUpperCase(),
      doc,
      8,
      "normal",
      -2
    );

    // Function to draw the title and a set of aligned boxes
    function drawTitleAndBoxes(title, titleX, titleY, boxX, boxY, boxCount, boxWidth, boxHeight, text, doc) {

      if (!doc) {
        console.error("jsPDF instance (doc) is undefined!");
        return;
      }

      // Draw the title
      doc.setFontSize(8); // Set font size for the title
      doc.text(title, titleX, titleY);

      // Ensure text is safely converted to string and sliced to match boxCount
      const letters = String(text || "").substring(0, boxCount).split("");

      // Draw the boxes and insert letters
      for (let i = 0; i < boxCount; i++) {
        const currentX = boxX + i * boxWidth;
        doc.rect(currentX, boxY, boxWidth, boxHeight); // Draw the box

        // Add letter to the center of the box (if exists)
        if (letters[i]) {
          doc.setFontSize(10);
          doc.text(letters[i], currentX + boxWidth / 2 - 1, boxY + boxHeight / 2 + 3); // Center letter
        }
      }
    }

    doc.setFont("helvetica", "bold");
    doc.setFontSize(8);
    const text2 = "2. Abbreviations of the above name, as you would like it, to be printed on the PAN card";
    const x2 = 6;
    const y2 = 91;
    const width2 = 200; // Adjust width as per your requirement


    // Set background color
    doc.setFillColor(240, 240, 240); // Light gray background (RGB)
    doc.rect(x2 - 1, y2 - fontSize * lineHeight, width2, height, "F"); // "F" stands for fill
    doc.text(text2, 10, y2);

    // Shared variables for box dimensions and alignment
    const boxCountPan = 38; // Number of boxes (on each line)
    const boxesStartXPan = 10; // Fixed starting X position for all boxes



    function drawTitleAndBoxes(
      title,
      titleX,
      titleY,
      startX,
      startY,
      boxCount,
      boxWidth,
      boxHeight,
      inputText,
      doc,
      fontSize = 8,
      fontWeight = "normal",
      yOffset = 0
    ) {
      // Set font and size
      doc.setFont("KidsAvenue", fontWeight);
      doc.setFontSize(fontSize);

      // Optional title
      if (title) {
        doc.setFont("helvetica", "bold");
        doc.setFontSize(8);
        doc.text(title, titleX, titleY);
        doc.setFont("helvetica", fontWeight); // Reset font
        doc.setFontSize(fontSize);            // Reset font size
      }

      for (let i = 0; i < boxCount; i++) {
        const currentX = startX + i * boxWidth;
        doc.rect(currentX, startY, boxWidth, boxHeight); // Draw the box

        if (inputText && inputText[i]) {
          doc.text(
            inputText[i],
            currentX + 1.5,
            startY + boxHeight / 2 + fontSize / 2 - 1 + yOffset // vertical adjustment
          );
        }
      }
    }
    // Use Kids Avenue font for the PAN card printed name
    doc.setFont("KidsAvenue", "normal");
    drawTitleAndBoxes(
      "",                 // No title
      0,
      0,
      boxesStartXPan,     // X position
      94,                 // Y position for boxes
      boxCountPan,        // 38 boxes
      boxWidthn,
      boxHeightn,
      formData.NewPanName.toUpperCase(), // Text to render
      doc,
      8,                  // Font size
      "normal",           // Font weight
      -2                 // yOffset to move text UP
    );

    doc.setFont("helvetica", "bold");
    doc.setFontSize(8);
    const text3 = "3. Have you ever been known by any other name?";
    const y3 = 108;

    // Set background color
    doc.setFillColor(240, 240, 240); // Light gray background (RGB)
    doc.rect(x2 - 1, y3 - fontSize * lineHeight, width, height, "F"); // "F" stands for fill
    doc.text(text3, 10, y3);

    const locationcheckboxYn = 105; // Y position for the checkboxes
    const labelXOffsetn = 2;
    const labelYOffsetn = checkboxSize - 1;
    // Draw the "Father's Name" checkbox and label
    const resiCheckboxX = 90; // X position for the Father's Name checkbox
    doc.rect(resiCheckboxX, locationcheckboxYn, checkboxSize, checkboxSize); // Draw the checkbox
    doc.text(
      "Yes",
      resiCheckboxX + checkboxSize + labelXOffsetn,
      locationcheckboxYn + labelYOffsetn
    ); // Draw the label, aligned with the checkbox

    // Draw the "Mother's Name" checkbox and label
    const officeCheckboxX = 110; // X position for the Mother's Name checkbox
    doc.rect(officeCheckboxX, locationcheckboxYn, checkboxSize, checkboxSize); // Draw the checkbox
    doc.text(
      "No",
      officeCheckboxX + checkboxSize + labelXOffsetn,
      locationcheckboxYn + labelYOffsetn
    ); // Draw the label, aligned with the checkbox
    // Auto-tick "No" for question 3
    drawCheckmark(officeCheckboxX, locationcheckboxYn);

    // Lease Select Title Section Below Full Name
    const SelectTitleX = 30; // Horizontal position of the title
    const SelectTitleY = 116; // Position for the Lease Select Title (below the Full Name section)
    // Draw the "Lease Select Title"
    doc.setFontSize(8); // Set font size for the title
    doc.setFont("helvetica", "normal");
    doc.text("If yes, please give that other name", 10, 113);

    doc.setFontSize(8); // Set font size for the title
    doc.setFont("helvetica", "normal");
    doc.text("Please select title", 10, 118);

    // Define the starting X and Y position for checkboxes (aligned with the title)
    const checkbox2StartX = SelectTitleX + 5; // Starting X position for checkboxes (offset to the right of the title)
    const checkbox2Y = SelectTitleY - 2; // Adjust Y to align with the title text

    const checkboxSpacingn = 40; // Adjust this value to control the spacing between the checkboxes

    // Draw the first checkbox ("as applicable")
    doc.rect(checkbox2StartX, checkbox2Y, checkboxSize, checkboxSize); // Draw the checkbox (empty box)
    doc.text("as applicable", checkbox2StartX + checkboxSize + 1, checkbox2Y + 3); // Label for "as applicable"

    // Draw the second checkbox ("Shri")
    const checkboxX2n = checkbox2StartX + checkboxSpacingn; // Offset X position for next checkbox
    doc.rect(checkboxX2n, checkbox2Y, checkboxSize, checkboxSize); // Draw the checkbox (empty box)
    doc.text("Shri", checkboxX2n + checkboxSize + 1, checkbox2Y + 3); // Label for "Shri"

    // Draw the third checkbox ("Smt")
    const checkboxX3n = checkboxX2 + checkboxSpacingn; // Further offset for the next checkbox
    doc.rect(checkboxX3n, checkbox2Y, checkboxSize, checkboxSize); // Draw the checkbox (empty box)
    doc.text("Smt", checkboxX3n + checkboxSize + 1, checkbox2Y + 3); // Label for "Smt"

    // Draw the fourth checkbox ("Kumari")
    const checkboxX4n = checkboxX3n + checkboxSpacingn; // Further offset for the next checkbox
    doc.rect(checkboxX4n, checkbox2Y, checkboxSize, checkboxSize); // Draw the checkbox (empty box)
    doc.text("Kumari", checkboxX4n + checkboxSize + 1, checkbox2Y + 3); // Label for "Kumari"

    // Draw the fifth checkbox ("M/S")
    const checkboxX5n = checkboxX4n + checkboxSpacingn; // Further offset for the next checkbox
    doc.rect(checkboxX5n, checkbox2Y, checkboxSize, checkboxSize); // Draw the checkbox (empty box)
    doc.text("M/S", checkboxX5n + checkboxSize + 1, checkbox2Y + 3); // Label for "M/S"

    doc.setFontSize(6); // Set font size for the title
    doc.setFont("helvetica", "normal");

    // Draw the "Last Name / Surname" title and boxes
    drawTitleAndAlignedBoxes(
      "Last Name / Surname",
      titleStartX,
      124, // Title Y position
      boxesStartX,
      121, // Boxes Y position
      boxCountn,
      boxWidthn,
      boxHeightn,
      formData.LastName.toUpperCase(),
      doc,
      8,      // font size inside boxes
      "normal",
      -2
    );

    // Draw the "First Name" title and boxes
    drawTitleAndAlignedBoxes(
      "First Name",
      titleStartX,
      130, // Title Y position
      boxesStartX,
      126, // Boxes Y position
      boxCountn,
      boxWidthn,
      boxHeightn,
      formData.FirstName.toUpperCase(),
      doc,
      8,      // font size inside boxes
      "normal",
      -2
    );

    // Draw the "Middle Name" title and boxes
    drawTitleAndAlignedBoxes(
      "Middle Name",
      titleStartX,
      135, // Title Y position
      boxesStartX,
      131, // Boxes Y position
      boxCountn,
      boxWidthn,
      boxHeightn,
      formData.MiddleName.toUpperCase(),
      doc,
      8,                  // Font size
      "normal",           // Font weight
      -2
    );

    doc.setFont("helvetica", "bold");
    doc.setFontSize(8);
    const text4 = "4. Gender (for Individual applicants only) ";
    const y4 = 141;

    // Set background color
    doc.setFillColor(240, 240, 240); // Light gray background (RGB)
    doc.rect(x2 - 1, y4 - fontSize * lineHeight, width, height, "F"); // "F" stands for fill
    doc.text(text4, 10, y4);



    // Define the positions and sizes for the checkboxes
    const GendercheckboxYn = 138; // Y position for the checkboxes
    const GenderlabelYOffset = checkboxSize - 1; // Offset to align the label text with the checkbox
    const GenderlabelXOffset = 2; // Offset for the label text from the checkbox

    // Draw the "Male" checkbox and label
    const MaleCheckboxX = 75; // X position for the Male checkbox
    doc.rect(MaleCheckboxX, GendercheckboxYn, checkboxSize, checkboxSize); // Draw the checkbox
    doc.text(
      "Male",
      MaleCheckboxX + checkboxSize + GenderlabelXOffset,
      GendercheckboxYn + GenderlabelYOffset
    ); // Draw the label, aligned with the checkbox

    // Draw the "female" checkbox and label
    const FemaleCheckboxX = 95; // X position for thefemale checkbox
    doc.rect(FemaleCheckboxX, GendercheckboxYn, checkboxSize, checkboxSize); // Draw the checkbox
    doc.text(
      "Female",
      FemaleCheckboxX + checkboxSize + GenderlabelXOffset,
      GendercheckboxYn + GenderlabelYOffset
    ); // Draw the label, aligned with the checkbox

    // Draw the "Transgender" checkbox and label
    const transgenderCheckboxX = 120; // X position for the Transgender checkbox
    doc.rect(transgenderCheckboxX, GendercheckboxYn, checkboxSize, checkboxSize); // Draw the checkbox
    doc.text(
      "Transgender",
      transgenderCheckboxX + checkboxSize + GenderlabelXOffset,
      GendercheckboxYn + GenderlabelYOffset
    ); // Draw the label, aligned with the checkbox

    // Draw the "Photo Mismatch" checkbox and label
    const PhotoCheckboxXn = 155; // X position for the label
    const PhotoCheckboxYn = 141; // Y position aligned with the Gender checkbox
    doc.text("(please tick as applicable)", PhotoCheckboxXn, PhotoCheckboxYn);

    // Auto-select Gender based on RepresentativeCheckedOption
    if (formData.ApplicantCheckedOption === "Shri") {
      // Shri → Male
      drawCheckmark(MaleCheckboxX, GendercheckboxYn);
    } else if (
      formData.ApplicantCheckedOption === "Smt" ||
      formData.ApplicantCheckedOption === "Kumari" ||
      formData.ApplicantCheckedOption === "M/S"
    ) {
      // Smt / Kumari / M/S → Female
      drawCheckmark(FemaleCheckboxX, GendercheckboxYn);
    }

    doc.setFont("helvetica", "bold");
    doc.setFontSize(8);
    const text5 = "5. Date of Birth/Incorporation/Agreement/Partnership or Trust Deed/ Formation of Body of individuals or Association of Person";
    const y5 = 147;

    // Set background color
    doc.setFillColor(240, 240, 240); // Light gray background (RGB)
    doc.rect(x2 - 1, y5 - fontSize * lineHeight, width, height, "F"); // "F" stands for fill
    doc.text(text5, 10, y5);

    const rawDob = String(formatDateToString(formData.Dob) || "");
    const dob = rawDob.replace(/\//g, ""); // Remove all slashes

    const day = dob.slice(0, 2);   // "DD"
    const month = dob.slice(2, 4); // "MM"
    const year = dob.slice(4, 8);  // "YYYY"

    // Shared dimensions and spacing
    const DatelabelYOffset = -2; // Offset to place labels above the boxes
    const DatestartX = 10; // Starting X position for the first label/box group
    const DatestartY = 154; // Starting Y position for the boxes
    const boxSpacing = 5; // Space between each label/box group

    // Draw "Day" label and boxes
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.text("Day", DatestartX, DatestartY + DatelabelYOffset); // Draw the "Day" label above the boxes
    for (let i = 0; i < 2; i++) {
      doc.rect(DatestartX + i * (boxWidthn + 2), DatestartY, boxWidthn, boxHeightn);
      if (day[i]) {
        doc.setFont("KidsAvenue", "normal");
        doc.text(day[i], DatestartX + i * (boxWidthn + 2) + 2, DatestartY + 4);
        doc.setFont("helvetica", "normal");
      }
    }

    // Draw "Month" label and boxes
    const MonthStartX = DatestartX + 2 * boxWidthn + boxSpacing; // X position for "Month"
    doc.text("Month", MonthStartX, DatestartY + DatelabelYOffset); // Draw the "Month" label above the boxes
    for (let i = 0; i < 2; i++) {
      doc.rect(MonthStartX + i * (boxWidthn + 2), DatestartY, boxWidthn, boxHeightn);
      if (month[i]) {
        doc.setFont("KidsAvenue", "normal");
        doc.text(month[i], MonthStartX + i * (boxWidthn + 2) + 2, DatestartY + 4);
        doc.setFont("helvetica", "normal");
      }
    }

    // Draw "Year" label and boxes
    const YearStartX = MonthStartX + 2 * boxWidthn + boxSpacing; // X position for "Year"
    doc.text("Year", YearStartX, DatestartY + DatelabelYOffset); // Draw the "Year" label above the boxes
    for (let i = 0; i < 4; i++) {
      doc.rect(YearStartX + i * (boxWidthn + 2), DatestartY, boxWidthn, boxHeightn);
      if (year[i]) {
        doc.setFont("KidsAvenue", "normal");
        doc.text(year[i], YearStartX + i * (boxWidthn + 2) + 2, DatestartY + 4);
        doc.setFont("helvetica", "normal");
      }
    }


    doc.setFont("helvetica", "bold");
    doc.setFontSize(8);
    const text6 = "6. Details of Parents (applicable only for individual applicants)";
    const y6 = 164;

    // Set background color
    doc.setFillColor(240, 240, 240); // Light gray background (RGB)
    doc.rect(x2 - 1, y6 - fontSize * lineHeight, width, height, "F"); // "F" stands for fill
    doc.text(text6, 10, y6);

    // Draw the "Lease Select Title"
    doc.setFontSize(8); // Set font size for the title
    doc.setFont("helvetica", "normal");
    doc.text("Whether mother is a single parent and you wish to apply for PAN by furnishing the name of your mother only", 10, 169);


    const parentcheckboxYn = 171; // Y position for the checkboxes

    // Draw the "Father's Name" checkbox and label
    const parentyCheckboxX = 10; // X position for the Father's Name checkbox
    doc.rect(parentyCheckboxX, parentcheckboxYn, checkboxSize, checkboxSize); // Draw the checkbox
    doc.text(
      "Yes",
      parentyCheckboxX + checkboxSize + labelXOffsetn,
      parentcheckboxYn + labelYOffsetn
    ); // Draw the label, aligned with the checkbox

    // Draw the "Mother's Name" checkbox and label
    const parentnCheckboxX = 30; // X position for the Mother's Name checkbox
    doc.rect(parentnCheckboxX, parentcheckboxYn, checkboxSize, checkboxSize); // Draw the checkbox
    doc.text(
      "No",
      parentnCheckboxX + checkboxSize + labelXOffsetn,
      parentcheckboxYn + labelYOffsetn
    ); // Draw the label, aligned with the checkbox
    // Tick "No" only when Individual is selected
    if (formData.category === "INDIVIDUAL") {
      drawCheckmark(parentnCheckboxX, parentcheckboxYn);
    }

    // Draw the "Lease Select Title"
    doc.setFontSize(8); // Set font size for the title
    doc.setFont("helvetica", "normal");
    doc.text("If yes, please fill in mother’s name in the appropriate space provide below", 10, 179);


    // Draw the "Lease Select Title"
    doc.setFontSize(8); // Set font size for the title
    doc.setFont("helvetica", "bold");
    doc.text("Father’s Name (Mandatory except where mother is a single parent and PAN is applied by furnishing the name of mother only)", 10, 183);

    doc.setFontSize(8); // Set font size for the title
    doc.setFont("helvetica", "normal");

    // Draw the "Middle Name" title and boxes
    drawTitleAndAlignedBoxes(
      "Last Name / Surname",
      titleStartX,
      188, // Title Y position
      boxesStartX,
      185, // Boxes Y position
      boxCountn,
      boxWidthn,
      boxHeightn,
      formData.FatherLastName.toUpperCase(),
      doc,
      8,      // font size inside boxes
      "normal",
      -2
    );

    // Draw the "First Name" title and boxes
    drawTitleAndAlignedBoxes(
      "First Name",
      titleStartX,
      193, // Title Y position
      boxesStartX,
      190, // Boxes Y position
      boxCountn,
      boxWidthn,
      boxHeightn,
      formData.FatherFirstName.toUpperCase(),
      doc,
      8,      // font size inside boxes
      "normal",
      -2
    );

    // Draw the "Middle Name" title and boxes
    drawTitleAndAlignedBoxes(
      "Middle",
      titleStartX,
      198, // Title Y position
      boxesStartX,
      195, // Boxes Y position
      boxCountn,
      boxWidthn,
      boxHeightn,
      formData.FatherMiddleName.toUpperCase(),
      doc,
      8,                  // Font size
      "normal",           // Font weight
      -2
    );

    // Applicant Details Section
    doc.setFont("helvetica", "bold");
    doc.setFontSize(8);
    doc.text(
      "Mother’s Name (optional except where mother is a single parent and PAN is applied by furnishing the name of mother only) ",
      10,
      203
    );

    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    // Draw the "Middle Name" title and boxes
    drawTitleAndAlignedBoxes(
      "Last Name / Surname",
      titleStartX,
      208,// Title Y position
      boxesStartX,
      205, // Boxes Y position
      boxCountn,
      boxWidthn,
      boxHeightn,
      formData.MotherLastName.toUpperCase(),
      doc,
      8,                  // Font size
      "normal",           // Font weight
      -2
    );

    // Draw the "Middle Name" title and boxes
    drawTitleAndAlignedBoxes(
      "First Name",
      titleStartX,
      213, // Title Y position
      boxesStartX,
      210, // Boxes Y position
      boxCountn,
      boxWidthn,
      boxHeightn,
      formData.MotherFirstName.toUpperCase(),
      doc,
      8,                  // Font size
      "normal",           // Font weight
      -2
    );

    // Draw the "Middle Name" title and boxes
    drawTitleAndAlignedBoxes(
      "Middle Name",
      titleStartX,
      218, // Title Y position
      boxesStartX,
      215, // Boxes Y position
      boxCountn,
      boxWidthn,
      boxHeightn,
      formData.MotherMiddleName.toUpperCase(),
      doc,
      8,                  // Font size
      "normal",           // Font weight
      -2
    );

    // Applicant Details Section
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.text(
      "Select the name of either father or mother which you may like to be printed on PAN card (Select one only)",
      10,
      223
    );

    const SelectcheckboxYn = 225; // Y position for the checkboxes

    // Draw the "Father's Name" checkbox and label
    const fatherCheckboxX = 10; // X position for the Father's Name checkbox
    doc.rect(fatherCheckboxX, SelectcheckboxYn, checkboxSize, checkboxSize); // Draw the checkbox
    doc.text(
      "Father’s name",
      fatherCheckboxX + checkboxSize + labelXOffsetn,
      SelectcheckboxYn + labelYOffsetn
    ); // Draw the label, aligned with the checkbox
    // Auto-tick "Father's name" by default
    drawCheckmark(fatherCheckboxX, SelectcheckboxYn);

    // Draw the "Mother's Name" checkbox and label
    const motherCheckboxX = 50; // X position for the Mother's Name checkbox
    doc.rect(motherCheckboxX, SelectcheckboxYn, checkboxSize, checkboxSize); // Draw the checkbox
    doc.text(
      "Mother’s name",
      motherCheckboxX + checkboxSize + labelXOffsetn,
      SelectcheckboxYn + labelYOffsetn
    ); // Draw the label, aligned with the checkbox

    // Applicant Details Section
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.text(
      "(Please tick as applicable)",
      80,
      227
    );

    // Define the long text string
    let applicantText = "(In case no option is provided then PAN card will be issued with father’s name except where mother is a single parent and you wish to apply for PAN by furnishing name of the mother only)";
    // Set font and size
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    // Use doc.text() to break the text into multiple lines for better formatting
    doc.text(applicantText, 10, 233, { maxWidth: 180 });

    doc.setFont("helvetica", "bold");
    doc.setFontSize(8);
    const text7 = "7. Address";
    const y7 = 241;
    // Set background color
    doc.setFillColor(240, 240, 240); // Light gray background (RGB)
    doc.rect(x2 - 1, y7 - fontSize * lineHeight, width, height, "F"); // "F" stands for fill
    doc.text(text7, 10, y7);


    // Define the long text string
    let applicantTextR = "(Residence Addres)";
    // Set font and size
    doc.setFont("helvetica", "bold");
    doc.setFontSize(8);
    // Use doc.text() to break the text into multiple lines for better formatting
    doc.text(applicantTextR, 10, 246);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    const DetailboxesStartX = 63;
    const boxCountb = 27; // Number of boxes


    // Draw the "Middle Name" title and boxes
    drawTitleAndAlignedBoxes(
      "Flat/Room/ Door / Block No",
      titleStartX,
      250, // Title Y position
      DetailboxesStartX,
      247, // Boxes Y position
      boxCountb,
      boxWidthn,
      boxHeightn,
      formData.ResidentRoom.toUpperCase(),
      doc,
      8,                  // Font size
      "normal",           // Font weight
      -2
    );

    // Draw the "Middle Name" title and boxes
    drawTitleAndAlignedBoxes(
      "Name of Premises/ Building/Village",
      titleStartX,
      255, // Title Y position
      DetailboxesStartX,
      252, // Boxes Y position
      boxCountb,
      boxWidthn,
      boxHeightn,
      formData.ResidentPremises.toUpperCase(),
      doc,
      8,                  // Font size
      "normal",           // Font weight
      -2
    );

    // Draw the "Middle Name" title and boxes
    drawTitleAndAlignedBoxes(
      "Road/Street/ Lane/Post Office",
      titleStartX,
      260, // Title Y position
      DetailboxesStartX,
      257, // Boxes Y position
      boxCountb,
      boxWidthn,
      boxHeightn,
      formData.ResidentStreet.toUpperCase(),
      doc,
      8,                  // Font size
      "normal",           // Font weight
      -2
    );

    // Draw the "Middle Name" title and boxes
    drawTitleAndAlignedBoxes(
      "Area / Locality / Taluka / Sub- Division",
      titleStartX,
      265, // Title Y position
      DetailboxesStartX,
      262, // Boxes Y position
      boxCountb,
      boxWidthn,
      boxHeightn,
      formData.ResidentArea.toUpperCase(),
      doc,
      8,                  // Font size
      "normal",           // Font weight
      -2
    );
    // Draw the "Middle Name" title and boxes
    drawTitleAndAlignedBoxes(
      "Town / City / District",
      titleStartX,
      270, // Title Y position
      DetailboxesStartX,
      267, // Boxes Y position
      boxCountb,
      boxWidthn,
      boxHeightn,
      formData.ResidentCity.toUpperCase(),
      doc,
      8,                  // Font size
      "normal",           // Font weight
      -2
    );

    // Shared dimensions and spacing
    const startXn = 10; // Starting X position for the first label/box group
    const startYn = 280; // Starting Y position for the boxes
    // Draw "State / Union Territory" label and box (large box)
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.text("State / Union Territory", startXn, startYn + DatelabelYOffset); // Label for State
    doc.rect(startXn, startYn, 70, boxHeightn); // Large box for State
    // User-entered state in Kids Avenue
    doc.setFont("KidsAvenue", "normal");
    doc.text(String(formData.ResidentState || "").toUpperCase(), 12, 283.5);
    doc.setFont("helvetica", "normal");

    // Draw "Pincode / Zip Code" label and 7 small boxes
    const pincodeStartX = startXn + 70 + 0; // Starting X position for Pincode
    doc.text("Pincode / Zip Code", pincodeStartX, startYn + DatelabelYOffset); // Label for Pincode
    // Ensure the pincode fits into 7 boxes (using padding or truncation)
    const pincode = (formData.ResidentPinCode || "").toString().padEnd(7, " ").substring(0, 7);

    for (let i = 0; i < 7; i++) { // Keep the 7-box design
      const currentX = pincodeStartX + i * (boxWidthn); // Use original spacing
      doc.rect(currentX, startYn, boxWidthn, boxHeightn); // Draw the 7 boxes
      // User-entered pincode digits in Kids Avenue
      doc.setFont("KidsAvenue", "normal");
      doc.text(pincode[i], currentX + boxWidthn / 2 - 1, startYn + boxHeightn / 2 + 1); // Center the digits or spaces
      doc.setFont("helvetica", "normal");
    }
    // Draw "Country Name" label and large box
    const countryStartX = pincodeStartX + 7 * (boxWidthn + 0) + 0; // Starting X for Country Name
    doc.text("Country Name", countryStartX, startYn + DatelabelYOffset); // Label for Country Name
    doc.rect(countryStartX, startYn, 70, boxHeightn); // Large box for Country Name
    doc.text("INDIA", countryStartX + 2, startYn + boxHeightn / 2 + 1);

    // Add a new page
    doc.addPage();
    // Draw border on the second page
    drawBorder();


    // Define the long text string
    let officeText = "Office Addres";
    // Set font and size
    doc.setFont("helvetica", "bold");
    doc.setFontSize(8);
    // Use doc.text() to break the text into multiple lines for better formatting
    doc.text(officeText, 10, 10);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);

    // Draw the "Middle Name" title and boxes
    drawTitleAndAlignedBoxes(
      "Name of office",
      titleStartX,
      14, // Title Y position
      DetailboxesStartX,
      10, // Boxes Y position
      boxCountb,
      boxWidthn,
      boxHeightn,
      formData.OfficeName.toUpperCase(),
      doc,
      8,                  // Font size
      "normal",           // Font weight
      -2
    );
    // Draw the "Middle Name" title and boxes
    drawTitleAndAlignedBoxes(
      "Flat/Room/ Door / Block No",
      titleStartX,
      18, // Title Y position
      DetailboxesStartX,
      15, // Boxes Y position
      boxCountb,
      boxWidthn,
      boxHeightn,
      formData.OfficeRoom.toUpperCase(),
      doc,
      8,                  // Font size
      "normal",           // Font weight
      -2
    );

    // Draw the "Middle Name" title and boxes
    drawTitleAndAlignedBoxes(
      "Name of Premises / Building / Village",
      titleStartX,
      23, // Title Y position
      DetailboxesStartX,
      20, // Boxes Y position
      boxCountb,
      boxWidthn,
      boxHeightn,
      formData.OfficePremises.toUpperCase(),
      doc,
      8,                  // Font size
      "normal",           // Font weight
      -2
    );

    // Draw the "Middle Name" title and boxes
    drawTitleAndAlignedBoxes(
      "Road/Street/ Lane/Post Office",
      titleStartX,
      28, // Title Y position
      DetailboxesStartX,
      25, // Boxes Y position
      boxCountb,
      boxWidthn,
      boxHeightn,
      formData.OfficeStreet.toUpperCase(),
      doc,
      8,                  // Font size
      "normal",           // Font weight
      -2
    );

    // Draw the "Middle Name" title and boxes
    drawTitleAndAlignedBoxes(
      "Area / Locality / Taluka / Sub- Division",
      titleStartX,
      33, // Title Y position
      DetailboxesStartX,
      30, // Boxes Y position
      boxCountb,
      boxWidthn,
      boxHeightn,
      formData.OfficeArea.toUpperCase(),
      doc,
      8,                  // Font size
      "normal",           // Font weight
      -2
    );
    // Draw the "Middle Name" title and boxes
    drawTitleAndAlignedBoxes(
      "Town / City / District",
      titleStartX,
      38, // Title Y position
      DetailboxesStartX,
      35, // Boxes Y position
      boxCountb,
      boxWidthn,
      boxHeightn,
      formData.OfficeCity.toUpperCase(),
      doc,
      8,                  // Font size
      "normal",           // Font weight
      -2
    );

    const officestartY = 45; // Starting Y position for the boxes
    // Draw "State / Union Territory" label and box (large box)
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.text("State / Union Territory", startXn, officestartY + DatelabelYOffset); // Label for State
    doc.rect(startXn, officestartY, 70, boxHeightn); // Large box for State
    // User-entered state in Kids Avenue
    doc.setFont("KidsAvenue", "normal");
    doc.text(String(formData.OfficeState || "").toUpperCase(), startXn + 1, officestartY + boxHeightn / 2 + 1); // Adjust for vertical centering
    doc.setFont("helvetica", "normal");
    // Draw "Pincode / Zip Code" label and 7 small boxes
    const pincodeStartXn = startXn + 70 + 0; // Starting X position for Pincode
    doc.text("Pincode / Zip Code", pincodeStartXn, officestartY + DatelabelYOffset); // Label for Pincode
    // Ensure the pincode fits into 7 boxes (padding or truncation)
    const officePincode = (formData.OfficePinCode || "").toString().padEnd(7, " ").substring(0, 7);
    // Draw 7 small boxes and input digits
    for (let i = 0; i < 7; i++) {
      const currentX = pincodeStartXn + i * (boxWidthn); // Adjust spacing between boxes
      doc.rect(currentX, officestartY, boxWidthn, boxHeightn); // Draw boxes
      doc.setFont("KidsAvenue", "normal");
      doc.text(officePincode[i], currentX + boxWidthn / 2 - 1, officestartY + boxHeightn / 2 + 1);
      doc.setFont("helvetica", "normal");
    }
    // Draw "Country Name" label and large box
    const countryStartXn = pincodeStartXn + 7 * (boxWidthn + 0) + 0; // Starting X for Country Name
    doc.text("Country Name", countryStartXn, officestartY + DatelabelYOffset); // Label for Country Name
    doc.rect(countryStartXn, officestartY, 70, boxHeightn); // Large box for Country Name
    doc.text("INDIA", countryStartXn + 2, officestartY + boxHeightn / 2 + 1.2); // Adjust X and Y for proper positioning

    doc.setFont("helvetica", "bold");
    doc.setFontSize(8);
    const text8 = "8. Address for Communication";
    const y8 = 54;

    // Set background color
    doc.setFillColor(240, 240, 240); // Light gray background (RGB)
    doc.rect(x2 - 1, y8 - fontSize * lineHeight, width, height, "F"); // "F" stands for fill
    doc.text(text8, 10, y8);

    // Define the positions and sizes for the checkboxes
    const RcheckboxY = 51; // Y position for the checkboxes

    // Draw the "Residence" checkbox and label
    const RCheckboxX = 60; // X position for the Residence checkbox
    doc.rect(RCheckboxX, RcheckboxY, checkboxSize, checkboxSize); // Draw the checkbox
    doc.text(
      "Residence",
      RCheckboxX + checkboxSize + GenderlabelXOffset,
      RcheckboxY + GenderlabelYOffset
    ); // Draw the label, aligned with the checkbox
    // Tick "Residence" only when Individual is selected
    if (formData.category === "INDIVIDUAL") {
      drawCheckmark(RCheckboxX, RcheckboxY);
    }

    // Draw the "female" checkbox and label
    const FemlaeCheckboxX = 95; // X position for thefemale checkbox
    doc.rect(FemlaeCheckboxX, RcheckboxY, checkboxSize, checkboxSize); // Draw the checkbox
    doc.text(
      "Office",
      FemlaeCheckboxX + checkboxSize + GenderlabelXOffset,
      RcheckboxY + GenderlabelYOffset
    ); // Draw the label, aligned with the checkbox

    // Draw the "Photo Mismatch" checkbox and label
    const PhotoCheckboxX = 155; // X position for the label
    const PhotoCheckboxY = 54; // Y position aligned with the Gender checkbox
    doc.text("(please tick as applicable)", PhotoCheckboxX, PhotoCheckboxY);


    doc.setFont("helvetica", "bold");
    doc.setFontSize(8);
    const text9 = "9. Telephone Number & Email ID details";
    const y9 = 59;

    // Set background color
    doc.setFillColor(240, 240, 240); // Light gray background (RGB)
    doc.rect(x2 - 1, y9 - fontSize * lineHeight, width, height, "F"); // "F" stands for fill
    doc.text(text9, 10, y9);


    // Shared dimensions and spacing
    const CountrystartX = 65; // Starting X position for the first label/box group
    const CountrystartY = 65; // Starting Y position for the boxes

    // Draw "Country Code" label and 3 small boxes
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.text("Country Code", CountrystartX, CountrystartY + DatelabelYOffset);

    const countryCode = "+91".padEnd(3, " ");
    for (let i = 0; i < 3; i++) {
      doc.rect(CountrystartX + i * (boxWidthn + 0), CountrystartY, boxWidthn, boxHeightn);
      doc.setFont("KidsAvenue", "normal");
      doc.text(countryCode[i] || "", CountrystartX + i * (boxWidthn + 0) + 2, CountrystartY + 4);
      doc.setFont("helvetica", "normal");
    }

    // Draw "Area/STD Code" label and 7 small boxes
    const areaStartX = 60 + 3 * (boxWidthn + 5); // Starting X for Area/STD Code
    doc.text("Area/STD Code", areaStartX, CountrystartY + DatelabelYOffset); // Label for Area/STD Code
    const STDCode = String(formData.STDCode || "").padEnd(7, " ");
    for (let i = 0; i < 7; i++) {
      doc.rect(areaStartX + i * (boxWidthn + 0), CountrystartY, boxWidthn, boxHeightn);
      doc.setFont("KidsAvenue", "normal");
      doc.text(STDCode[i] || "", areaStartX + i * (boxWidthn + 0) + 2, CountrystartY + 4);
      doc.setFont("helvetica", "normal");
    }

    // Draw "Telephone/Mobile Number" label and 13 small boxes
    const telStartX = 60 + 7 * (boxWidthn + 5) + 5; // Starting X for Telephone/Mobile Number
    doc.text("Telephone/Mobile Number", telStartX, CountrystartY + DatelabelYOffset); // Label for Telephone/Mobile Number
    const MobileNo = String(formData.MobileNo || "").padEnd(12, " ");
    for (let i = 0; i < 12; i++) {
      doc.rect(telStartX + i * (boxWidthn + 0), CountrystartY, boxWidthn, boxHeightn);
      doc.setFont("KidsAvenue", "normal");
      doc.text(MobileNo[i] || "", telStartX + i * (boxWidthn + 0) + 2, CountrystartY + 4);
      doc.setFont("helvetica", "normal");
    }

    const emailStartX = 10; // Starting X position for the Email ID
    const emailStartY = 74; // Starting Y position for the box
    // Draw "Email ID" label and box
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.text("Email ID", emailStartX, emailStartY + DatelabelYOffset); // Draw the label above the box
    doc.rect(63, 70, 134, 5); // Draw a single box for Email ID
    doc.setFont("KidsAvenue", "normal");
    doc.text(String(formData.EmailId || ""), 65, 74);
    doc.setFont("helvetica", "normal");

    doc.setFont("helvetica", "bold");
    doc.setFontSize(8);
    const text10 = "10. Status of applicant";
    const y10 = 79;

    // Set background color
    doc.setFillColor(240, 240, 240); // Light gray background (RGB)
    doc.rect(x2 - 1, y10 - fontSize * lineHeight, width, height, "F"); // "F" stands for fill
    doc.text(text10, 10, y10);


    // Define the positions and sizes for the checkboxes
    const applicantcheckboxY = 81; // Y position for the checkboxes
    doc.setFont("helvetica", "normal");
    // Draw the "Individual" checkbox and label
    const IndividuaCheckboxX = 15; // X position for the Individual checkbox
    doc.rect(IndividuaCheckboxX, applicantcheckboxY, checkboxSize, checkboxSize); // Draw the checkbox
    doc.text(
      "Individual",
      IndividuaCheckboxX + checkboxSize + GenderlabelXOffset,
      applicantcheckboxY + GenderlabelYOffset
    ); // Draw the label, aligned with the checkbox
    // Tick "Individual" only when INDIVIDUAL is selected as status
    if (formData.category === "INDIVIDUAL") {
      drawCheckmark(IndividuaCheckboxX, applicantcheckboxY);
    }

    // Draw the "female" checkbox and label
    const familyCheckboxX = 38; // X position for thefemale checkbox
    doc.rect(familyCheckboxX, applicantcheckboxY, checkboxSize, checkboxSize); // Draw the checkbox
    doc.text(
      "Hindu undivided family",
      familyCheckboxX + checkboxSize + GenderlabelXOffset,
      applicantcheckboxY + GenderlabelYOffset
    ); // Draw the label, aligned with the checkbox

    // Draw the "female" checkbox and label
    const CompanyCheckboxX = 80; // X position for thefemale checkbox
    doc.rect(CompanyCheckboxX, applicantcheckboxY, checkboxSize, checkboxSize); // Draw the checkbox
    doc.text(
      "Company",
      CompanyCheckboxX + checkboxSize + GenderlabelXOffset,
      applicantcheckboxY + GenderlabelYOffset
    ); // Draw the label, aligned with the checkbox

    // Draw the "female" checkbox and label
    const PartnershipCheckboxX = 103; // X position for thefemale checkbox
    doc.rect(PartnershipCheckboxX, applicantcheckboxY, checkboxSize, checkboxSize); // Draw the checkbox
    doc.text(
      "Partnership Firm",
      PartnershipCheckboxX + checkboxSize + GenderlabelXOffset,
      applicantcheckboxY + GenderlabelYOffset
    ); // Draw the label, aligned with the checkbox

    // Draw the "female" checkbox and label
    const AssociationCheckboxX = 135; // X position for thefemale checkbox
    doc.rect(AssociationCheckboxX, applicantcheckboxY, checkboxSize, checkboxSize); // Draw the checkbox
    doc.text(
      "Association of Persons",
      AssociationCheckboxX + checkboxSize + GenderlabelXOffset,
      applicantcheckboxY + GenderlabelYOffset
    ); // Draw the label, aligned with the checkbox

    // Draw the "female" checkbox and label
    const GovernmentCheckboxX = 175; // X position for thefemale checkbox
    doc.rect(GovernmentCheckboxX, applicantcheckboxY, checkboxSize, checkboxSize); // Draw the checkbox
    doc.text(
      "Government",
      GovernmentCheckboxX + checkboxSize + GenderlabelXOffset,
      applicantcheckboxY + GenderlabelYOffset
    ); // Draw the label, aligned with the checkbox

    const applicantcheckboxY2 = 86; // Y position for the checkboxes

    // Draw the "female" checkbox and label
    const TrustsCheckboxX = 15; // X position for thefemale checkbox
    doc.rect(TrustsCheckboxX, applicantcheckboxY2, checkboxSize, checkboxSize); // Draw the checkbox
    doc.text(
      "Trusts",
      TrustsCheckboxX + checkboxSize + GenderlabelXOffset,
      applicantcheckboxY2 + GenderlabelYOffset
    ); // Draw the label, aligned with the checkbox

    // Draw the "female" checkbox and label
    const BodyCheckboxX = 35; // X position for thefemale checkbox
    doc.rect(BodyCheckboxX, applicantcheckboxY2, checkboxSize, checkboxSize); // Draw the checkbox
    doc.text(
      "Body of Individuals",
      BodyCheckboxX + checkboxSize + GenderlabelXOffset,
      applicantcheckboxY2 + GenderlabelYOffset
    ); // Draw the label, aligned with the checkbox

    // Draw the "female" checkbox and label
    const LocalCheckboxX = 70; // X position for thefemale checkbox
    doc.rect(LocalCheckboxX, applicantcheckboxY2, checkboxSize, checkboxSize); // Draw the checkbox
    doc.text(
      "Local Authority",
      LocalCheckboxX + checkboxSize + GenderlabelXOffset,
      applicantcheckboxY2 + GenderlabelYOffset
    ); // Draw the label, aligned with the checkbox

    // Draw the "female" checkbox and label
    const ArtificialCheckboxX = 105; // X position for thefemale checkbox
    doc.rect(ArtificialCheckboxX, applicantcheckboxY2, checkboxSize, checkboxSize); // Draw the checkbox
    doc.text(
      "Artificial Juridical Persons",
      ArtificialCheckboxX + checkboxSize + GenderlabelXOffset,
      applicantcheckboxY2 + GenderlabelYOffset
    ); // Draw the label, aligned with the checkbox

    // Draw the "female" checkbox and label
    const LimitedCheckboxX = 150; // X position for thefemale checkbox
    doc.rect(LimitedCheckboxX, applicantcheckboxY2, checkboxSize, checkboxSize); // Draw the checkbox
    doc.text(
      "Limited Liability Partnership",
      LimitedCheckboxX + checkboxSize + GenderlabelXOffset,
      applicantcheckboxY2 + GenderlabelYOffset
    ); // Draw the label, aligned with the checkbox

    doc.setFont("helvetica", "bold");
    doc.setFontSize(8);
    const text11 = "11. Registration Number (for company, firms, LLPs etc.)";
    const y11 = 94;

    // Set background color
    doc.setFillColor(240, 240, 240); // Light gray background (RGB)
    doc.rect(x2 - 1, y11 - fontSize * lineHeight, width, height, "F"); // "F" stands for fill
    doc.text(text11, 10, y11);

    // Draw 25 boxes in a single line
    let currentX = 10; // Starting X position
    const RegistrationboxWidth = 5; // Width of each box
    const RegistrationboxHeight = 5; // Height of each box
    for (let i = 0; i < 30; i++) {
      doc.rect(currentX, 91 + 5, RegistrationboxWidth, RegistrationboxHeight); // Draw a rectangle
      currentX += RegistrationboxWidth; // Update X position for the next box
    }
    doc.setFont("helvetica", "bold");
    doc.setFontSize(8);
    const text12 = "12. n case of a person, who is required to quote Aadhaar number or the Enrolment ID of Aadhaar application form as per section 139 AA";
    const y12 = 105;

    // Set background color
    doc.setFillColor(240, 240, 240); // Light gray background (RGB)
    doc.rect(x2 - 1, y12 - fontSize * lineHeight, width, height, "F"); // "F" stands for fill
    doc.text(text12, 10, y12);

    // Applicant Details Section
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.text(
      "Please mention your AADHAAR number (if allotted)",
      10,
      110
    );

    // Parameters for the boxes
    const allottedstartX = 80; // Starting X position (adjust based on spacing from text)
    const allottedstartY = 107; // Y position for boxes
    const allotteboxWidth = 5; // Width of each box
    const allotteboxHeight = 5; // Height of each box

    // Ensure the Aadhar EID fits into 12 boxes (padding or truncation)
    const aadharEID = (formData.Aadhar_EID || "").toString().padEnd(12, " ").substring(0, 12);

    // Draw 12 boxes in a single line
    let allottedcurrentX = allottedstartX;
    for (let i = 0; i < 12; i++) {
      doc.rect(allottedcurrentX, allottedstartY, allotteboxWidth, allotteboxHeight); // Draw a rectangle
      doc.setFont("KidsAvenue", "normal");
      doc.text(aadharEID[i], allottedcurrentX + allotteboxWidth / 2 - 1, allottedstartY + allotteboxHeight / 2 + 1);
      doc.setFont("helvetica", "normal");
      allottedcurrentX += allotteboxWidth; // Update X position for the next box
    }

    // Applicant Details Section
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.text(
      "If AADHAAR number is not allotted, please mention the enrolment ID of Aadhaar application form",
      10,
      115
    );

    const IfallottedstartX = 50; // Starting X position (adjust based on spacing from text)
    const IfallottedstartY = 116; // Y position for boxes

    let IfallottedcurrentXn = IfallottedstartX;
    for (let i = 0; i < 28; i++) {
      doc.rect(IfallottedcurrentXn, IfallottedstartY, allotteboxWidth, allotteboxHeight); // Draw a rectangle
      IfallottedcurrentXn += allotteboxWidth; // Update X position for the next box
    }

    // Applicant Details Section
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.text(
      "Name as per AADHAAR letter or card or as per the Enrolment ID of Aadhaar application form",
      10,
      123
    );

    // Parameters for the boxes
    const EnrolmentstartX = 60; // Starting X position for the boxes
    let EnrolmentstartY = 124; // Starting Y position (just below the text)
    const boxesPerLine = 26; // Number of boxes per line

    // Aadhaar name in uppercase, spread across 3 lines of 26 boxes each
    const aadharNameUpper = (formData.AadharName || "").toUpperCase();
    const totalAadharBoxes = boxesPerLine * 3;
    const aadharNamePadded = aadharNameUpper.substring(0, totalAadharBoxes);

    // Function to draw a single line of boxes with optional text
    function drawLineOfBoxes(startX, startY, boxCount, charOffset) {
      let currentX = startX;
      for (let i = 0; i < boxCount; i++) {
        doc.rect(currentX, startY, allotteboxWidth, allotteboxHeight); // Draw a rectangle (box)
        const ch = aadharNamePadded[charOffset + i];
        if (ch && ch.trim()) {
          doc.setFontSize(7);
          doc.setFont("KidsAvenue", "normal");
          doc.text(ch, currentX + allotteboxWidth / 2 - 1, startY + allotteboxHeight / 2 + 1);
          doc.setFont("helvetica", "normal");
          doc.setFontSize(8);
        }
        currentX += allotteboxWidth; // Move to the next box position
      }
    }
    // Draw 3 lines of boxes with Aadhaar name filled in
    for (let i = 0; i < 3; i++) {
      drawLineOfBoxes(EnrolmentstartX, EnrolmentstartY, boxesPerLine, i * boxesPerLine);
      EnrolmentstartY += allotteboxHeight; // Move to the next line directly below
    }
    doc.setFont("helvetica", "bold");
    doc.setFontSize(8);
    const text13 = "13. Source of Income";
    const y13 = 143;
    // Set background color
    doc.setFillColor(240, 240, 240); // Light gray background (RGB)
    doc.rect(x2 - 1, y13 - fontSize * lineHeight, width, height, "F"); // "F" stands for fill
    doc.text(text13, 10, y13);

    const IncomestartX = 10; // Starting X position
    let IncomestartY = 145; // Starting Y position for the first line
    const IncomelineHeight = 4.5; // Height between lines
    doc.setFont("helvetica", "normal");
    // Function to draw a checkbox with text
    function drawCheckboxWithText(text, x, y) {
      doc.rect(x, y, checkboxSize, checkboxSize); // Draw the checkbox
      doc.text(text, x + checkboxSize, y + checkboxSize - 1); // Add text next to the checkbox
    }

    // Line 1: "Salary" and "Capital Gains" checkboxes
    drawCheckboxWithText(" Salary", IncomestartX, IncomestartY);
    drawCheckboxWithText(" Capital Gains", IncomestartX + 150, IncomestartY); // Adjust X for second checkbox

    // Line 2: "Income from Other sources"
    IncomestartY += IncomelineHeight; // Move to the next line
    drawCheckboxWithText(" Income from Business / Profession", IncomestartX, IncomestartY);
    drawCheckboxWithText(" Income from Other source", IncomestartX + 150, IncomestartY);
    // Auto-tick "Income from Other source"
    drawCheckmark(IncomestartX + 150, IncomestartY);

    // Line 3: "Income from House property" and "No income"
    IncomestartY += IncomelineHeight; // Move to the next line
    drawCheckboxWithText(" Income from House property", IncomestartX, IncomestartY);
    drawCheckboxWithText(" No income", IncomestartX + 150, IncomestartY); // Adjust X for second checkbox

    const IncomecontentY = 150; // Y position for the content
    // Calculate content width
    const textb = "Business/Profession code";
    const instructionText = "[For Code: Refer instructions]";
    const textWidthb = doc.getTextWidth(textb);
    const instructionWidth = doc.getTextWidth(instructionText);
    const totalWidth = textWidthb + checkboxSize * 2 + instructionWidth + 5;

    // Calculate starting X to center the content
    const startXb = (210 - totalWidth) / 2; // A4 width = 210mm

    // Draw content
    // Draw centered content
    doc.text(textb, startXb, IncomecontentY); // Add main text
    doc.rect(startXb + textWidthb + 5, IncomecontentY - checkboxSize + 1, checkboxSize, checkboxSize); // Draw first small box
    doc.rect(startXb + textWidthb + checkboxSize + 5, IncomecontentY - checkboxSize + 1, checkboxSize, checkboxSize); // Draw second small box
    doc.text(
      instructionText,
      startXb + textWidthb + checkboxSize * 2 + 7,
      IncomecontentY
    ); // Add instruction text

    doc.setFont("helvetica", "bold");
    doc.setFontSize(8);
    const text14 = "14. Representative Assessee (RA)";
    const y14 = 163;
    // Set background color
    doc.setFillColor(240, 240, 240); // Light gray background (RGB)
    doc.rect(x2 - 1, y14 - fontSize * lineHeight, width, height, "F"); // "F" stands for fill
    doc.text(text14, 10, y14);

    // Applicant Details Section
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.text(
      "Full name, address of the Representative Assessee, who is assessible under the Income Tax Act in respect of the person, whose particulars have\n been given in the column 1-13.",
      10,
      168
    );
    doc.setFont("helvetica", "bold");
    doc.setFontSize(8);
    const textn = "Full Name (Full expanded name : initials are not permitted)";
    const yn = 177;
    // Set background color
    doc.setFillColor(240, 240, 240); // Light gray background (RGB)
    doc.rect(x2 - 1, yn - fontSize * lineHeight, width, height, "F"); // "F" stands for fill
    doc.text(textn, 10, yn);

    const FullNameTitleX = 30; // Horizontal position of the title
    const FullSelectTitleY = 181; // Position for the Lease Select Title (below the Full Name section)
    doc.setFontSize(8); // Set font size for the title
    doc.setFont("helvetica", "normal");
    doc.text("Please select title", 10, 182);

    // Function to draw a checkmark (✔)
    const drawCheckmark1 = (x, y) => {
      doc.line(x, y + 1, x + 2, y + 3); // bottom-left to center
      doc.line(x + 2, y + 3, x + 6, y - 1); // center to top-right
    };

    // Define the starting X and Y position for checkboxes (aligned with the title)
    const checkboxStartXn = FullNameTitleX + 15; // Starting X position for checkboxes (offset to the right of the title)
    const checkboxYn = FullSelectTitleY - 2; // Adjust Y to align with the title text

    // Draw the first checkbox ("as applicable")
    doc.rect(checkboxStartXn, checkboxYn, checkboxSize, checkboxSize);
    doc.text("as applicable", checkboxStartXn + checkboxSize + 1, checkboxYn + 3);
    if (formData.RepresentativeCheckedOption === "as applicable") {
      drawCheckmark(checkboxStartXn, checkboxYn);
    }

    // Draw the second checkbox ("Shri")
    const checkboxXn = checkboxStartXn + checkboxSpacing;
    doc.rect(checkboxXn, checkboxYn, checkboxSize, checkboxSize);
    doc.text("Shri", checkboxXn + checkboxSize + 1, checkboxYn + 3);
    if (formData.RepresentativeCheckedOption === "Shri") {
      drawCheckmark(checkboxXn, checkboxYn);
    }

    // Draw the third checkbox ("Smt")
    const checkboxXn1 = checkboxXn + checkboxSpacing;
    doc.rect(checkboxXn1, checkboxYn, checkboxSize, checkboxSize);
    doc.text("Smt", checkboxXn1 + checkboxSize + 1, checkboxYn + 3);
    if (formData.RepresentativeCheckedOption === "Smt") {
      drawCheckmark(checkboxXn1, checkboxYn);
    }

    // Draw the fourth checkbox ("Kumari")
    const checkboxXn2 = checkboxXn1 + checkboxSpacing;
    doc.rect(checkboxXn2, checkboxYn, checkboxSize, checkboxSize);
    doc.text("Kumari", checkboxXn2 + checkboxSize + 1, checkboxYn + 3);
    if (formData.RepresentativeCheckedOption === "Kumari") {
      drawCheckmark(checkboxXn2, checkboxYn);
    }

    // Draw the fifth checkbox ("M/S")
    const checkboxXn3 = checkboxXn2 + checkboxSpacing;
    doc.rect(checkboxXn3, checkboxYn, checkboxSize, checkboxSize);
    doc.text("M/S", checkboxXn3 + checkboxSize + 1, checkboxYn + 3);
    if (formData.RepresentativeCheckedOption === "M/S") {
      drawCheckmark(checkboxXn3, checkboxYn);
    }


    // Draw the "Last Name / Surname" title and boxes
    drawTitleAndAlignedBoxes(
      "Last Name / Surname",
      titleStartX,
      187, // Title Y position
      boxesStartX,
      184, // Boxes Y position
      boxCountn,
      boxWidthn,
      boxHeightn,
      (formData.RepresentativeLastName || "").toUpperCase(),
      doc,
      8,
      "normal",
      -2
    );

    // Draw the "First Name" title and boxes
    drawTitleAndAlignedBoxes(
      "First Name",
      titleStartX,
      192, // Title Y position
      boxesStartX,
      189, // Boxes Y position
      boxCountn,
      boxWidthn,
      boxHeightn,
      formData.RepresentativeFirstName.toUpperCase(),
      doc,
      8,
      "normal",
      -2
    );

    // Draw the "Middle Name" title and boxes
    drawTitleAndAlignedBoxes(
      "Middle Name",
      titleStartX,
      197, // Title Y position
      boxesStartX,
      194, // Boxes Y position
      boxCountn,
      boxWidthn,
      boxHeightn,
      formData.RepresentativeMiddleName.toUpperCase(),
      doc,
      8,
      "normal",
      -2
    );

    doc.setFont("helvetica", "bold");
    doc.setFontSize(8);
    const textno = "Address";
    const yno = 203;
    // Set background color
    doc.setFillColor(240, 240, 240); // Light gray background (RGB)
    doc.rect(x2 - 1, yno - fontSize * lineHeight, width, height, "F"); // "F" stands for fill
    doc.text(textno, 10, yno);

    doc.setFont("helvetica", "normal");
    // Draw the "Middle Name" title and boxes
    drawTitleAndAlignedBoxes(
      "Flat/Room/ Door / Block No",
      titleStartX,
      209, // Title Y position
      DetailboxesStartX,
      205, // Boxes Y position
      boxCountb,
      boxWidthn,
      boxHeightn,
      formData.RepresentativeRoom.toUpperCase(),
      doc,
      8,
      "normal",
      -2
    );

    // Draw the "Middle Name" title and boxes
    drawTitleAndAlignedBoxes(
      "Name of Premises/ Building/Village",
      titleStartX,
      214, // Title Y position
      DetailboxesStartX,
      210, // Boxes Y position
      boxCountb,
      boxWidthn,
      boxHeightn,
      formData.RepresentativePremises.toUpperCase(),
      doc,
      8,
      "normal",
      -2
    );

    // Draw the "Middle Name" title and boxes
    drawTitleAndAlignedBoxes(
      "Road/Street/ Lane/Post Office",
      titleStartX,
      219, // Title Y position
      DetailboxesStartX,
      215, // Boxes Y position
      boxCountb,
      boxWidthn,
      boxHeightn,
      formData.RepresentativeStreet.toUpperCase(),
      doc,
      8,
      "normal",
      -2
    );

    // Draw the "Middle Name" title and boxes
    drawTitleAndAlignedBoxes(
      "Area / Locality / Taluka / Sub- Division",
      titleStartX,
      224, // Title Y position
      DetailboxesStartX,
      220, // Boxes Y position
      boxCountb,
      boxWidthn,
      boxHeightn,
      formData.RepresentativeArea.toUpperCase(),
      doc,
      8,
      "normal",
      -2
    );
    // Draw the "Middle Name" title and boxes
    drawTitleAndAlignedBoxes(
      "Town / City / District",
      titleStartX,
      229, // Title Y position
      DetailboxesStartX,
      225, // Boxes Y position
      boxCountb,
      boxWidthn,
      boxHeightn,
      formData.RepresentativeCity.toUpperCase(),
      doc,
      8,
      "normal",
      -2
    );

    // Shared dimensions and spacing
    const addressstartXn = 10; // Starting X position for the first label/box group
    const addressstartYn = 235; // Starting Y position for the boxes
    // Draw "State / Union Territory" label and box (large box)
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.text("State / Union Territory", addressstartXn, addressstartYn + DatelabelYOffset); // Label for State
    doc.rect(addressstartXn, addressstartYn, 70, boxHeightn); // Large box for State
    doc.setFont("KidsAvenue", "normal");
    doc.text(String(formData.RepresentativeState || ""), 12, 238);
    doc.setFont("helvetica", "normal");

    // Draw "Pincode / Zip Code" label and 7 small boxes
    const addresspincodeStartX = addressstartXn + 70 + 0; // Starting X position for Pincode
    doc.text("Pincode / Zip Code", addresspincodeStartX, addressstartYn + DatelabelYOffset); // Label for Pincode

    // Ensure the pincode fits into 7 boxes (using padding or truncation)
    const pincode1 = (formData.RepresentativePinCode || "").toString().padEnd(7, " ").substring(0, 7);
    // Draw 7 small boxes for Pincode with numbers inside
    for (let i = 0; i < 7; i++) {
      const currentX = addresspincodeStartX + i * (boxWidthn); // Adjust spacing if needed
      doc.rect(currentX, addressstartYn, boxWidthn, boxHeightn); // Draw boxes
      doc.setFont("KidsAvenue", "normal");
      doc.text(pincode1[i], currentX + boxWidthn / 2 - 1, addressstartYn + boxHeightn / 2 + 1);
      doc.setFont("helvetica", "normal");
    }

    doc.setFont("helvetica", "bold");
    doc.setFontSize(8);
    const text15 = "15.  Documents submitted as Proof of Identity (POI), Proof of Address (POA) and Proof of Date of Birth (POB)";
    const y15 = 244;

    // Set background color
    doc.setFillColor(240, 240, 240); // Light gray background (RGB)
    doc.rect(x2 - 1, y15 - fontSize * lineHeight, width, height, "F"); // "F" stands for fill
    doc.text(text15, 10, y15);

    // Applicant Details Section
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.text(
      "Please refer to the instructions (as specified in Rule 114 of I.T. Rules, 1962) for list of mandatory certified documents to be submitted as applicable.\n[Annexure A, Annexure B & Annexure C are to be used wherever applicable]",
      10,
      260
    );

    const DocumentsstartLineX = 10; // Starting X position
    const DocumentsstartLineY = 249; // Starting Y position
    const DocumentstextOffsetY = 0;
    const boxWidthLinen = 65; // Width of the single box
    const boxWidthLine = 70; // Width of the single box
    const boxHeightLine = 5; // Height of the box

    // Function to draw a single box
    function drawBox(x, y, width, height) {
      doc.rect(x, y, width, height); // Draw a rectangle (box)
    }

    // Prepare document proof values
    const docProofText = "Aadhar Card";
    const docNameText = (formData.AadharName || "").toUpperCase();
    const docSelfText = "Self";

    // First line: "I/We have enclosed" and box (box 1 - POI)
    let DocumentscurrentY = DocumentsstartLineY;
    doc.text("I/We have enclosed", DocumentsstartLineX, DocumentscurrentY + DocumentstextOffsetY);
    drawBox(DocumentsstartLineX + 28, DocumentscurrentY - 3, boxWidthLinen, boxHeightLine); // Box 1
    doc.setFontSize(7);
    doc.setFont("KidsAvenue", "normal");
    doc.text(docProofText, DocumentsstartLineX + 30, DocumentscurrentY + 1); // Fill box 1
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);

    // Second line: "as proof of identity," and box (box 2 - POA)
    DocumentscurrentY += 1; // Move to the next line for better spacing
    doc.text("as proof of identity,", 105, DocumentscurrentY + DocumentstextOffsetY);
    drawBox(DocumentsstartLineX + 122, DocumentscurrentY - 3, boxWidthLinen, boxHeightLine); // Box 2
    doc.setFontSize(7);
    doc.setFont("KidsAvenue", "normal");
    doc.text(docProofText, DocumentsstartLineX + 124, DocumentscurrentY + 1); // Fill box 2
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);

    // Third line: "as proof of address and" + box (box 3 - POB) + "as proof of date of birth."
    DocumentscurrentY += 4.5; // Move to the next line for better spacing
    doc.text("as proof of address and", DocumentsstartLineX, DocumentscurrentY + DocumentstextOffsetY);
    drawBox(DocumentsstartLineX + 32, DocumentscurrentY - 3, boxWidthLinen, boxHeightLine); // Box 3
    doc.setFontSize(7);
    doc.setFont("KidsAvenue", "normal");
    doc.text(docProofText, DocumentsstartLineX + 34, DocumentscurrentY + 1); // Fill box 3
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.text("as proof of date of birth.", 110, DocumentscurrentY + DocumentstextOffsetY);


    const startLineX = 10; // Starting X position
    const startLineY = 271; // Starting Y position
    const textOffsetY = -2; // Offset to move text slightly upward

    // Function to draw a single box
    function drawBox(x, y, width, height) {
      doc.rect(x, y, width, height); // Draw a rectangle (box)
    }

    // First line: "I/We," and box (box 4 - Name as per Aadhaar)
    let currentY = startLineY;
    doc.text("I/We,", startLineX, currentY + textOffsetY);
    drawBox(startLineX + 8, currentY - 6, boxWidthLine, boxHeightLine); // Box 4 after "I/We"
    doc.setFontSize(7);
    doc.setFont("KidsAvenue", "normal");
    doc.text(docNameText, startLineX + 10, currentY - 2); // Fill box 4 with Aadhaar name
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);

    // Text "the applicant, in the capacity of" with box (box 5 - Self)
    doc.text("the applicant, in the capacity of", startLineX + 1 + boxWidthLine + 10, currentY + textOffsetY);
    drawBox(startLineX + 3 + boxWidthLine + 50, currentY - 6, boxWidthLine, boxHeightLine); // Box 5 after text
    doc.setFontSize(7);
    doc.setFont("KidsAvenue", "normal");
    doc.text(docSelfText, startLineX + 5 + boxWidthLine + 50, currentY - 2); // Fill box 5 with "Self"
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);

    // Next line: Declaration text
    currentY += 3; // Move to the next line
    doc.text(
      "do hereby declare that what is stated above is true to the best of my/our information and belief.",
      startLineX,
      currentY
    );

    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.text(
      "Place",
      10,
      279
    );

    // Place value (DISTRICT)
    const placeText = formData.district || "";

    doc.rect(30, 276, boxWidthLine, boxHeightLine);

    // Fill district text inside box
    doc.setFont("KidsAvenue", "normal");
    doc.setFontSize(9);
    doc.text(
      placeText,
      32,   // X inside box
      280   // Y inside box (centered vertically in box 276-281)
    );
    doc.setFont("helvetica", "normal");
    // Draw the "Date" label
    doc.text("Date", 10, 288); // Inline label before the boxes

    const startYdate = 286; // Starting Y position
    const labelSpacing = 1; // Space between labels and boxes
    let startXdate = 50; // Starting X position for boxes (initial position)

    // Custom offset to shift boxes to the right
    const xOffset = 20; // Shift boxes by 20 units to the right

    // Function to draw labeled boxes
    function drawLabeledBoxes(labels, startXdate, startYdate, boxWidthn, boxHeightn, dateStr) {
      labels.forEach((label, index) => {
        // Calculate X position with additional offset to shift boxes right
        const boxX = startXdate + index * (boxWidthn + 0) + xOffset; // Added xOffset to shift boxes right

        doc.setFont("KidsAvenue", "normal");
        doc.setFontSize(8);

        // Place label above the box
        doc.text(label, boxX + boxWidthn / 4, startYdate - labelSpacing);

        // Draw the box (only once)
        doc.rect(boxX, startYdate, boxWidthn, boxHeightn); // Only one call to draw the box

        // Fill date text inside box
        if (dateStr && dateStr[index]) {
          doc.setFontSize(9);
          doc.text(dateStr[index], boxX + boxWidthn / 2 - 1, startYdate + boxHeightn / 2 + 1);
        }
      });
    }

    // Prepare date string (DDMMYYYY) from backendSubmissionDate (e.g., "2026-02-07T01:42:21")
    let formattedDate = "";
    if (backendSubmissionDate) {
      try {
        const d = new Date(backendSubmissionDate);
        if (!isNaN(d.getTime())) {
          const day = String(d.getDate()).padStart(2, "0");
          const month = String(d.getMonth() + 1).padStart(2, "0");
          const year = String(d.getFullYear());
          formattedDate = day + month + year;
        } else {
          // Fallback parsing
          const dateParts = backendSubmissionDate.split(/[-T /]/);
          if (dateParts.length >= 3) {
            if (dateParts[0].length === 4) {
              formattedDate = dateParts[2].substring(0, 2) + dateParts[1] + dateParts[0];
            } else {
              formattedDate = dateParts[0] + dateParts[1] + dateParts[2].substring(0, 4);
            }
          }
        }
      } catch (e) {
        console.error("Error parsing submissionDate:", e);
      }
    }

    // Labels for date format
    const dateLabels = ["D", "D", "M", "M", "Y", "Y", "Y", "Y"];

    // Right-side box properties
    const marginRight = 7; // Right margin of the PDF
    const rightBoxWidth = 65; // Wider box for better text display
    const rightBoxHeight = 20; // Smaller height for better alignment
    const rightBoxX = pageWidth - rightBoxWidth - marginRight; // Place box to the rightmost side
    const rightBoxY = 271; // Align Y position with the starting line

    // Draw the labeled date boxes
    drawLabeledBoxes(dateLabels, startLineX, startYdate, boxWidthn, boxHeightn, formattedDate);

    // Draw the right-side box
    drawBox(rightBoxX, rightBoxY, rightBoxWidth, rightBoxHeight);
    if (signatureBase64) {
      doc.addImage(signatureBase64, "JPEG", rightBoxX, rightBoxY, rightBoxWidth, rightBoxHeight);
    }

    if (!signatureBase64) {
      // Add single-line text inside the right-side box (centered)
      doc.text(
        "Signature / Left Thumb Impression of Applicant",
        rightBoxX + 3,
        rightBoxY + rightBoxHeight / 1.1 // Center text vertically within the box
      );
    }

    doc.setFont("helvetica", "normal");
    doc.setFontSize(6);
    doc.text(
      "Note: As per provisions of Section 272B of the Income Tax Act., 1961, a penalty of ` 10,000 can be levied on possession of more than one PAN.",
      5,
      295
    );



    // // Draw table with customized styles
    // doc.autoTable({
    //     startY: startYL,
    //     margin: { left: 5 }, // Set left margin to 5px
    //     head: headers,
    //     body: data,
    //     theme: 'grid',
    //     styles: {
    //         fontSize: 9,
    //         textColor: [51, 51, 51], // Dark gray text color for body
    //         cellPadding: 2
    //     },
    //     headStyles: {
    //         fillColor: [204, 204, 204], // Light gray background for headers
    //         textColor: [0, 0, 0], // Black font color for headers
    //         fontStyle: 'normal'
    //     },
    //     columnStyles: {
    //         0: { cellWidth: colWidthsnl[0] }, // Mode
    //         1: { cellWidth: colWidthsnl[1] }, // Income-tax Department
    //         2: { cellWidth: colWidthsnl[2] }  // Protean
    //     }
    // });

    // Update currentYL for next section
    // currentYL = doc.autoTable.previous.finalY + 5;


    // Add more pages as needed
    // for (let i = 3; i <= 6; i++) {
    //   doc.addPage();
    //   drawBorder();
    //   doc.setFont("helvetica", "bold");
    //   doc.setFontSize(12);
    //   //doc.text(`Page ${i} Title`, centerX, 20); // Example content for each page
    // }
    doc.save("New_PAN_Application.pdf");

    // Then redirect (after small delay)
    setTimeout(() => {
      window.location.href = "/dashboard";
    }, 300);
  };

  return (
    <div className="kids-avenue-font">

      <form onSubmit={handleSubmitNewPan} autoComplete="off">
        <div className="card card-default">

          <div className="card-body">
            <div className="row">
              <div className="form-group col-md-3">
                <label htmlFor="AreaCode">AREA CODE</label>
                <input type="text"
                  className="form-control"
                  name="AreaCode"
                  maxLength={3}
                  // pattern="\d{0,9}"
                  // inputMode="numeric"
                  value={formData.AreaCode}
                  onChange={handleChange} />
              </div>
              <div className="form-group col-md-3">
                <label htmlFor="AoType">AO TYPE</label>
                <input type="text"
                  className="form-control"
                  name="AOType"
                  maxLength={2}
                  // pattern="\d{0,9}"
                  // inputMode="numeric"
                  value={formData.AOType}
                  onChange={handleChange} />
              </div>
              <div className="form-group col-md-3">
                <label htmlFor="RangeCode">RANGE CODE</label>
                <input type="text"
                  className="form-control"
                  name="RangeCode"
                  maxLength={3}
                  pattern="\d{0,9}"
                  inputMode="numeric"
                  value={formData.RangeCode}
                  onChange={handleChange} />
              </div>
              <div className="form-group col-md-3">
                <label htmlFor="AONo">AO CODE</label>
                <input type="text"
                  className="form-control"
                  name="AOCode"
                  maxLength={2}
                  pattern="\d{0,9}"
                  inputMode="numeric"
                  value={formData.AOCode}
                  onChange={handleChange} />
              </div>
              <div className="form-group col-md-3">
                <label htmlFor="State">STATE</label>
                <select
                  name="state"
                  value={formData.state}
                  onChange={handleStateDistrictChange}
                  className="form-control"
                >
                  <option value="">SELECT STATE</option>
                  {Object.keys(statesAndDistricts).map((state) => (
                    <option key={state} value={state}>
                      {state}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group col-md-3">
                <label htmlFor="exampleFormControlSelect12">DISTRICT</label>
                <select
                  name="district"
                  value={formData.district}
                  onChange={handleStateDistrictChange}
                  disabled={!formData.state}
                  className="form-control"
                >
                  <option value="">SELECT DISTRICT</option>
                  {formData.state &&
                    statesAndDistricts[formData.state].map((district) => (
                      <option key={district} value={district}>
                        {district}
                      </option>
                    ))}
                </select>
              </div>
            </div>
          </div>
          <div className="border-top"></div>
          <div className="card-header">
            <div className="row">
              <div className="col-md-3">
                <label>STATUS OF APPLICANT</label>
              </div>

              <div className="col-md-3">
                <select className="form-control" name="category" onChange={handleCategoryChange}>
                  <option>SELECT OPTION</option>
                  <option>INDIVIDUAL</option>
                  <option>TRUST</option>
                  <option>HINDU UNDIVIDED FAMILY</option>
                  <option>PARTNERSHIP FIRM</option>
                  <option>ASSOCIATION OF PERSON</option>
                  <option>BODY OF INDIVIDUALS</option>
                </select>
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className="applicant-section">
              <div className="form-check d-inline-block mb-3 col-md-2">
                <input className="form-check-input"
                  type="radio"
                  //checked="checked" value="" 
                  name="Shri"
                  checked={formData.ApplicantCheckedOption === "Shri"}
                  onChange={handleCheckboxChange} />
                <label className="form-check-label" htmlFor="Shri">SHRI</label>
              </div>

              <div className="form-check d-inline-block mb-3 col-md-2">
                <input className="form-check-input"
                  type="radio"
                  name="Smt"
                  checked={formData.ApplicantCheckedOption === "Smt"}
                  onChange={handleCheckboxChange} />
                <label className="form-check-label" htmlFor="smt">SMT.</label>
              </div>

              <div className="form-check d-inline-block mb-3 col-md-2">
                <input className="form-check-input"
                  type="radio"
                  name="Kumari"
                  checked={formData.ApplicantCheckedOption === "Kumari"}
                  onChange={handleCheckboxChange} />
                <label className="form-check-label" htmlFor="Kumari">KUMARI</label>
              </div>
              <div className="form-check d-inline-block mb-3 col-md-2">
                <input className="form-check-input"
                  type="radio"
                  name="Ms"
                  checked={formData.ApplicantCheckedOption === "Ms"}
                  onChange={handleCheckboxChange} />
                <label className="form-check-label" htmlFor="ms">MS</label>
              </div>
            </div>
            <div class="row">
              <div className="col-sm-12">
                <div className="form-group">
                  <label htmlFor="email">NAME AS PER AADHAR <span style={{ color: "red" }}>*</span></label>
                  <input type="text"
                    className="form-control"
                    name="AadharName"
                    value={formData.AadharName}
                    required
                    onChange={handleChange} />
                  {errors.AadharName && <small style={{ color: "red" }}>{errors.AadharName}</small>}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-3">
                <div className="form-group">
                  <label style={{ lineHeight: '35px' }}>APPLICANT NAME <span style={{ color: "red" }}>*</span></label>
                </div>
              </div>
              <div className="col-sm-3">
                <div className="form-group">
                  <input type="text"
                    className="form-control"
                    placeholder="LAST NAME"
                    name="LastName"
                    value={formData.LastName}
                    required
                    onChange={handleChange} />
                </div>
              </div>
              <div className="col-sm-3">
                <div className="form-group">
                  <input type="text"
                    className="form-control"
                    placeholder="FIRST NAME"
                    name="FirstName"
                    value={formData.FirstName}
                    onChange={handleChange} />
                </div>
              </div>
              <div className="col-sm-3">
                <div className="form-group">
                  <input type="text"
                    className="form-control"
                    placeholder="MIDDLE NAME"
                    name="MiddleName"
                    value={formData.MiddleName}
                    onChange={handleChange} />
                </div>
              </div>
              <div className="col-sm-12">
                <div className="form-group">
                  <label htmlFor="mname">NAME AS YOU WOULD LIKE IT TO BE PRINTED ON THE PAN CARD <span style={{ color: "red" }}>*</span></label>
                  <input type="text"
                    className="form-control"
                    placeholder=""
                    name="NewPanName"
                    value={formData.NewPanName}
                    required
                    onChange={handleChange} />
                </div>
              </div>
              <div className="col-sm-12">
                <label>WHETHER MOTHER IS A SINGLE PARENT AND YOU WISH TO APPLY FOR PAN BY FURNISHING THE NAME OF YOUR MOTHER ONLY? (PLEASE TICK AS APPLICABLE)</label>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-3">
                <div className="form-group">
                  <label style={{ lineHeight: '35px' }}>FATHER'S NAME <span style={{ color: "red" }}>*</span></label>
                </div>
              </div>
              <div className="col-sm-3">
                <div className="form-group">
                  <input type="text"
                    className="form-control"
                    placeholder="FATHER'S LAST NAME"
                    name="FatherLastName"
                    value={formData.FatherLastName}
                    required
                    onChange={handleChange} />
                </div>
              </div>
              <div className="col-sm-3">
                <div className="form-group">
                  <input type="text"
                    className="form-control"
                    placeholder="FIRST NAME"
                    name="FatherFirstName"
                    value={formData.FatherFirstName}
                    onChange={handleChange} />
                </div>
              </div>
              <div className="col-sm-3">
                <div className="form-group">
                  <input type="text"
                    className="form-control"
                    placeholder="MIDDLE NAME"
                    name="FatherMiddleName"
                    value={formData.FatherMiddleName}
                    onChange={handleChange} />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-3">
                <div className="form-group">
                  <label style={{ lineHeight: '35px' }}>MOTHER'S NAME</label>
                </div>
              </div>
              <div className="col-sm-3">
                <div className="form-group">
                  <input type="text"
                    className="form-control"
                    placeholder="MOTHER'S LAST NAME"
                    name="MotherLastName"
                    value={formData.MotherLastName}
                    onChange={handleChange} />
                </div>
              </div>
              <div className="col-sm-3">
                <div className="form-group">
                  <input type="text"
                    className="form-control"
                    placeholder="FIRST NAME"
                    name="MotherFirstName"
                    value={formData.MotherFirstName}
                    onChange={handleChange} />
                </div>
              </div>
              <div className="col-sm-3">
                <div className="form-group">
                  <input type="text"
                    className="form-control"
                    placeholder="MIDDLE NAME"
                    name="MotherMiddleName"
                    value={formData.MotherMiddleName}
                    onChange={handleChange} />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-3">
                <div className="form-group">
                  <label>Date of Birth / Incorporation <span style={{ color: "red" }}>*</span></label>
                </div>
              </div>
              <div className="col-sm-3">
                <div className="input-group mb-3">
                  <input type="date"
                    className="form-control"
                    data-mask="00/00/0000"
                    name="Dob"
                    value={formData.Dob}
                    required
                    onChange={handleChange} />
                </div>
              </div>
              <div className="col-sm-3">
                <p style={{ fontSize: '90%' }}>ex. DD/MM/YYYY</p>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-3">
                <div className="form-group">
                  <label style={{ lineHeight: '35px' }}>CONTACT DETAILS</label>
                </div>
              </div>
              <div className="col-sm-3">
                <div className="form-group">
                  <input type="text"
                    className="form-control"
                    placeholder="ISD CODE"
                    name="ISDCode"
                    value={formData.ISDCode}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="col-sm-3">
                <div className="form-group">
                  <input type="text"
                    className="form-control"
                    placeholder="STD CODE"
                    name="STDCode"
                    value={formData.STDCode}
                    onChange={handleChange} />
                </div>
              </div>
              <div className="col-sm-3">
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text mdi mdi-phone" name="basic-addon1" ></span>
                  </div>
                  <input type="text"
                    className="form-control"
                    data-mask="(999) 999-9999"
                    placeholder="MOBILE NO"
                    name="MobileNo"
                    value={formData.MobileNo}
                    required
                    onChange={handleChange} />

                </div>
                <p style={{ fontSize: '90%' }}>EX. (999) 999-9999 <span style={{ color: "red" }}>*</span></p>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-6">
                <div className="form-group"></div>
                <label htmlFor="email">EMAIL ADDRESS <span style={{ color: "red" }}>*</span></label>
                <input type="email"
                  className="form-control"
                  name="EmailId"
                  placeholder="ENTER EMAIL"
                  value={formData.EmailId}
                  required
                  onChange={handleChange} />
                <label className="mt-2 d-block">WE'LL NEVER SHARE YOUR EMAIL WITH ANYONE ELSE.</label>
              </div>


            </div>
            <div className="row">
              <div className="form-group col-md-3">
                <label htmlFor="AreaCode">PAN CARD DISPATCHED STATE</label>
                <input type="text"
                  className="form-control"
                  name="PanDispatchState"
                  value={formData.PanDispatchState}
                  onChange={handleChange} />
              </div>
              <div className="form-group col-md-3">
                <label htmlFor="AoType">AADHAAR/EID<span style={{ color: "red" }}>*</span></label>
                <input type="text"
                  className="form-control"
                  name="Aadhar_EID"
                  value={formData.Aadhar_EID}
                  required
                  onChange={handleChange}
                  maxLength="12" />
                {errors.Aadhar_EID && <small style={{ color: "red" }}>{errors.Aadhar_EID}</small>}
              </div>
              <div className="form-group col-md-3">
                <label htmlFor="RangeCode">RA ADDRESS</label>
                <input type="text"
                  className="form-control"
                  name="RAAddress"
                  value={formData.RAAddress}
                  onChange={handleChange} />
              </div>
            </div>
          </div>
          <div className="border-top"></div>
          <div className="card-header">
            <h2>ADDRESS</h2>
          </div>
          <div className="card-body">
            <ul className="nav nav-tabs mb-3" id="pills-tab2" role="tablist">
              <li className="nav-item">
                <button className="nav-link active" id="pills-home-tab" data-toggle="pill" href="#nav-tabs-home2" role="tab"
                  aria-controls="nav-tabs" aria-selected="true">
                  RESIDENT</button>
              </li>
              <li className="nav-item">
                <button className="nav-link" id="nav-profile-tab" data-toggle="pill" href="#nav-profile2" role="tab"
                  aria-controls="nav-profile" aria-selected="false">
                  OFFICE</button>
              </li>
            </ul>
            <div className="tab-content mt-5" id="nav-tabContent">
              <div className="tab-pane fade show active" id="nav-tabs-home2" role="tabpanel" aria-labelledby="nav-home-tab">
                <h5 className="mb-3">RESIDENT ADDRESS</h5>
                <div className="row">
                  <div className="form-group col-md-3">
                    <label htmlFor="AreaCode">FLAT/ ROOM/ BOCK NO.</label>
                  </div>
                  <div className="form-group col-md-9">
                    <input type="text"
                      className="form-control"
                      name="ResidentRoom"
                      value={formData.ResidentRoom}
                      maxLength={25}
                      onChange={handleChange} />
                  </div>
                  <div className="form-group col-md-3">
                    <label htmlFor="AoType">NAME OF PREMISES/ BLDG/ VILLAGE </label>
                  </div>
                  <div className="form-group col-md-9">
                    <input type="text"
                      className="form-control"
                      name="ResidentPremises"
                      value={formData.ResidentPremises}
                      maxLength={25}
                      onChange={handleChange} />
                  </div>
                  <div className="form-group col-md-3">
                    <label htmlFor="RangeCode">ROAD/ STREET/ LANE/ POST</label>
                  </div>
                  <div className="form-group col-md-9">
                    <input type="text"
                      className="form-control"
                      name="ResidentStreet"
                      value={formData.ResidentStreet}
                      maxLength={25}
                      onChange={handleChange} />
                  </div>
                  <div className="form-group col-md-3">
                    <label htmlFor="AONo">AREA/ LOCALITY/ TALUKA</label>
                  </div>
                  <div className="form-group col-md-3">
                    <input type="text"
                      className="form-control"
                      name="ResidentArea"
                      maxLength={25}
                      value={formData.ResidentArea}
                      onChange={handleChange} />
                  </div>
                  <div className="form-group col-md-3">
                    <label htmlFor="AONo">STATE/ UNION TERRITORY </label>
                  </div>
                  <div className="form-group col-md-3">
                    <select
                      name="ResidentState"
                      value={formData.ResidentState}
                      onChange={handleChange}
                      className="form-control"
                    >
                      <option value="">SELECT STATE</option>
                      {Object.keys(statesAndDistricts).map((state) => (
                        <option key={state} value={state}>
                          {state}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group col-md-3">
                    <label htmlFor="AONo">TOWN/ CITY/ DISTRICT</label>

                  </div>
                  <div className="form-group col-md-3">
                    <select
                      name="ResidentCity"
                      value={formData.ResidentCity}
                      onChange={handleChange}
                      disabled={!formData.ResidentState}
                      className="form-control"
                    >
                      <option value="">SELECT DISTRICT</option>
                      {formData.ResidentState &&
                        statesAndDistricts[formData.ResidentState].map((district) => (
                          <option key={district} value={district}>
                            {district}
                          </option>
                        ))}
                    </select>

                  </div>


                  <div className="form-group col-md-3">
                    <label htmlFor="AONo">PIN CODE </label>
                  </div>
                  <div className="form-group col-md-3">
                    <input type="number"
                      className="form-control"
                      name="ResidentPinCode"
                      nputMode="numeric"
                      pattern="\d{0,9}"
                      maxLength={6}
                      value={formData.ResidentPinCode}
                      onChange={handleChange} />
                  </div>
                </div>
                {!hideRA && (
                  <div>
                    <h5 className="mb-3">REPRESENTATIVE ASSESSEE ( RA )</h5>

                    <div className="row">
                      <div className="col-md-12">
                        <p>Full name. address of the Representative Assessee, who is assessible under the income Tax Act in respect of the person, whose particulars have
                          been given in the column 1-13</p>
                      </div>
                      <div className="representative-section">
                        <div className="form-check d-inline-block mb-3 col-md-2">
                          <input className="form-check-input"
                            type="radio"
                            //checked="checked" 
                            name="Shri"
                            checked={formData.RepresentativeCheckedOption === "Shri"}
                            onChange={handleCheckboxChange} />
                          <label className="form-check-label" htmlFor="Shri">SHRI</label>
                        </div>

                        <div className="form-check d-inline-block mb-3 col-md-2">
                          <input className="form-check-input"
                            type="radio"
                            name="Smt"
                            checked={formData.RepresentativeCheckedOption === "Smt"}
                            onChange={handleCheckboxChange} />
                          <label className="form-check-label" htmlFor="smt">SMT.</label>
                        </div>

                        <div className="form-check d-inline-block mb-3 col-md-2">
                          <input className="form-check-input"
                            type="radio"
                            name="Kumari"
                            checked={formData.RepresentativeCheckedOption === "Kumari"}
                            onChange={handleCheckboxChange} />

                          <label className="form-check-label" htmlFor="Kumari"> KUMARI</label>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-3">
                        <div className="form-group">
                          <label style={{ lineHeight: '35px' }}>FULL NAME ( RA )</label>
                        </div>
                      </div>
                      <div className="col-sm-3">
                        <div className="form-group">
                          <input type="text"
                            className="form-control"
                            placeholder="LAST NAME"
                            name="RepresentativeLastName"
                            value={formData.RepresentativeLastName}
                            onChange={handleChange} />
                        </div>
                      </div>
                      <div className="col-sm-3">
                        <div className="form-group">
                          <input type="text"
                            className="form-control"
                            placeholder="FIRST NAME"
                            name="RepresentativeFirstName"
                            value={formData.RepresentativeFirstName}
                            onChange={handleChange} />
                        </div>
                      </div>
                      <div className="col-sm-3">
                        <div className="form-group">
                          <input type="text"
                            className="form-control"
                            placeholder="MIDDLE NAME"
                            name="RepresentativeMiddleName"
                            value={formData.RepresentativeMiddleName}
                            onChange={handleChange} />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="form-group col-md-3">
                        <label htmlFor="AreaCode">FLAT/ ROOM/ BOCK NO.</label>
                      </div>
                      <div className="form-group col-md-8">
                        <input type="text"
                          className="form-control"
                          name="RepresentativeRoom"
                          value={formData.RepresentativeRoom}
                          onChange={handleChange}
                          maxLength={25} />
                      </div>
                      <div className="form-group col-md-3">
                        <label htmlFor="AoType">NAME OF PREMISES/ BLDG/ VILLAGE </label>
                      </div>
                      <div className="form-group col-md-9">
                        <input type="text"
                          className="form-control"
                          name="RepresentativePremises"
                          value={formData.RepresentativePremises}
                          maxLength={25}
                          onChange={handleChange} />

                      </div>
                      <div className="form-group col-md-3">
                        <label htmlFor="RangeCode">ROAD/ STREET/ LANE/ POST</label>
                      </div>
                      <div className="form-group col-md-9">
                        <input type="text"
                          className="form-control"
                          name="RepresentativeStreet"
                          value={formData.RepresentativeStreet}
                          maxLength={25}
                          onChange={handleChange} />
                      </div>
                      <div className="form-group col-md-3">
                        <label htmlFor="AONo">AREA/ LOCALITY/ TALUKA</label>
                      </div>
                      <div className="form-group col-md-3">
                        <input type="text"
                          className="form-control"
                          name="RepresentativeArea"
                          maxLength={25}
                          value={formData.RepresentativeArea}
                          onChange={handleChange} />
                      </div>
                      <div className="form-group col-md-3">
                        <label htmlFor="AONo">STATE/ UNION TERRITORY </label>
                      </div>
                      <div className="form-group col-md-3">
                        <select
                          name="RepresentativeState"
                          value={formData.RepresentativeState}
                          onChange={handleChange}
                          className="form-control"
                        >
                          <option value="">SELECT STATE</option>
                          {Object.keys(statesAndDistricts).map((state) => (
                            <option key={state} value={state}>
                              {state}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="form-group col-md-3">
                        <label htmlFor="AONo">TOWN/ CITY/ DISTRICT</label>
                      </div>
                      <div className="form-group col-md-3">
                        <select
                          name="RepresentativeCity"
                          value={formData.RepresentativeCity}
                          onChange={handleChange}
                          disabled={!formData.RepresentativeState}
                          className="form-control"
                        >
                          <option value="">SELECT DISTRICT</option>
                          {formData.RepresentativeState &&
                            statesAndDistricts[formData.RepresentativeState].map((district) => (
                              <option key={district} value={district}>
                                {district}
                              </option>
                            ))}
                        </select>
                      </div>

                      <div className="form-group col-md-3">
                        <label htmlFor="AONo">PIN CODE </label>
                      </div>
                      <div className="form-group col-md-3">
                        <input type="number"
                          className="form-control"
                          name="RepresentativePinCode"
                          nputMode="numeric"
                          pattern="\d{0,9}"
                          maxLength={6}
                          value={formData.RepresentativePinCode}
                          onChange={handleChange} />
                      </div>
                    </div>
                  </div>
                )}

                <div className="border-top"></div>
                <h5 className="mb-3 mt-4">UPLOAD DOCUMENT</h5>
                <div className="row">
                  <div className="col-md-3">
                    <input type="file"
                      className="form-control"
                      name="pdfDocument"
                      accept="application/pdf"
                      required={!newPanId}
                      ref={pdfDocumentRef}
                      onChange={handleFileChange} />
                    <label htmlFor="AONo">FORM AND DOCUMENTS ( PDF ONLY ){!newPanId && <span style={{ color: "red" }}>*</span>} </label>
                  </div>
                  <div className="col-md-3">
                    <input type="file"
                      className="form-control"
                      name="photo"
                      required={!newPanId}
                      accept=".jpg, .png"
                      ref={photoRef}
                      onChange={handleFileChange} />
                    <label htmlFor="AONo">PHOTO (JPG AND PNG ONLY) {!newPanId && <span style={{ color: "red" }}>*</span>}</label>
                  </div>
                  <div className="col-md-3">
                    <input type="file"
                      className="form-control"
                      name="signature"
                      required={!newPanId}
                      accept=".jpg, .png"
                      ref={signatureRef}
                      onChange={handleFileChange} />
                    <label htmlFor="AONo">SIGNATURE (JPG AND PNG ONLY) {!newPanId && <span style={{ color: "red" }}>*</span>}</label>
                  </div>
                </div>
              </div>
              <div className="tab-pane fade" id="nav-profile2" role="tabpanel" aria-labelledby="nav-profile-tab">
                <h5 className="mb-3">OFFICE ADDRESS</h5>
                <div className="row">
                  <div className="form-group col-md-3">
                    <label htmlFor="AreaCode">OFFICE NAME</label>
                  </div>
                  <div className="form-group col-md-9">
                    <input type="text"
                      className="form-control"
                      name="OfficeName"
                      value={formData.OfficeName}
                      onChange={handleChange} />
                  </div>
                  <div className="form-group col-md-3">
                    <label htmlFor="AreaCode">FLAT/ ROOM/ BOCK NO.</label>
                  </div>
                  <div className="form-group col-md-9">
                    <input type="text"
                      className="form-control"
                      name="OfficeRoom"
                      maxLength={25}
                      value={formData.OfficeRoom}
                      onChange={handleChange} />
                  </div>
                  <div className="form-group col-md-3">
                    <label htmlFor="AoType">NAME OF PREMISES/ BLDG/ VILLAGE </label>
                  </div>
                  <div className="form-group col-md-8">
                    <input type="text"
                      className="form-control"
                      name="OfficePremises"
                      value={formData.OfficePremises}
                      onChange={handleChange}
                      maxLength={25} />
                  </div>
                  <div className="form-group col-md-3">
                    <label htmlFor="RangeCode">ROAD/ STREET/ LANE/ POST</label>
                  </div>
                  <div className="form-group col-md-9">
                    <input type="text"
                      className="form-control"
                      name="OfficeStreet"
                      value={formData.OfficeStreet}
                      onChange={handleChange}
                      maxLength={25} />
                  </div>
                  <div className="form-group col-md-3">
                    <label htmlFor="AONo">AREA/ LOCALITY/ TALUKA</label>
                  </div>
                  <div className="form-group col-md-3">
                    <input type="text"
                      className="form-control"
                      name="OfficeArea"
                      value={formData.OfficeArea}
                      onChange={handleChange}
                      maxLength={25} />
                  </div>
                  <div className="form-group col-md-3">
                    <label htmlFor="AONo">STATE/ UNION TERRITORY </label>
                  </div>
                  <div className="form-group col-md-3">
                    <select
                      name="OfficeState"
                      value={formData.OfficeState}
                      onChange={handleChange}
                      className="form-control"
                    >
                      <option value="">SELECT STATE</option>
                      {Object.keys(statesAndDistricts).map((state) => (
                        <option key={state} value={state}>
                          {state}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group col-md-3">
                    <label htmlFor="AONo">TOWN/ CITY/ DISTRICT</label>
                  </div>
                  <div className="form-group col-md-3">
                    <select
                      name="OfficeCity"
                      value={formData.OfficeCity}
                      onChange={handleChange}
                      disabled={!formData.OfficeState}
                      className="form-control"
                    >
                      <option value="">SELECT DISTRICT</option>
                      {formData.OfficeState &&
                        statesAndDistricts[formData.OfficeState].map((district) => (
                          <option key={district} value={district}>
                            {district}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div className="form-group col-md-3">
                    <label htmlFor="AONo">PIN CODE </label>
                  </div>
                  <div className="form-group col-md-3">
                    <input type="number"
                      className="form-control"
                      name="OfficePinCode"
                      nputMode="numeric"
                      pattern="\d{0,9}"
                      maxLength={6}
                      value={formData.OfficePinCode}
                      onChange={handleChange} />
                  </div>
                </div>
              </div>
            </div>
            <div className="form-footer pt-3 text-center">
              {!newPanId && <p>Note: Form Submition Charges Rs.120</p>}
              <button type="submit" className="btn btn-primary btn-pill">
                {newPanId ? "Update" : "Submit"}
              </button>
            </div>
          </div>
        </div>
      </form>

    </div>

  );
};
export default NewPanApplication;
